import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, Subscribable, Subscription, of} from 'rxjs';
import { catchError, first, map, mergeMap, timeout } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { AnyAaaaRecord } from 'dns';

@Injectable({
  providedIn: 'root',
})
export class LivewalkTestService {
  statusSubject: Subject<any> = new Subject();
  stoppedRule: Subject<any> = new Subject();
  securityTestStop: Subject<any> = new Subject();
  disableActions: Subject<any> = new Subject();
  walktestFilterSubject: Subject<any> = new Subject();
  walktestEventSubject: Subject<any> = new Subject();
  walktestReportDataSubject: Subject<any> = new Subject();
  joinLiveSubject: Subject<any> = new Subject();
  triggerDetailedSubmit: Subject<any>;
  detailedreportMesage: Subject<any> = new Subject();
  popupObservable: Subject<any> = new Subject();

  A: string = 'frgrtyhyujhogdrt';
  B: string = 'wdvfrtghyujkimlo';

  allAvailableTestTypes = [];
  continuoustests = {};
  singletests = {};
  applicationsingle = {};
  applicationscontinuous = {};
  allTestsMapping: any = {};
  walktesttypeMapping: any = {};

  testTypeMapping: any = {
    curl: 'CURL',
    curl_continuous: 'CURLCONTI',
    'curl-continuous': 'CURLCONTI',
    ping: 'PING',
    ping_continuous: 'PINGCONTI',
    'ping-continuous': 'PINGCONTI',
    'rf-continuous': 'RF',
    'rf-pindrop': 'PINRF',
    'iperf-pindrop': 'PINIPERF',
    'iperf-continuous': 'IPERF',
    'iperftest-pindrop': 'PINIPERFTEST',
    'iperftest-continuous': 'IPERFTEST',
    '3_min': 'PINRF',
    continuous: 'RF',
    iperf: 'PINIPERF',
    iperf_continuous: 'IPERF',
    iperftest: 'PINIPERFTEST',
    iperftest_continuous: 'IPERFTEST',
    ytube_continuous: 'YOUTUBE',
    ytube: 'PINYOUTUBE',
    'youtube-pindrop': 'PINYOUTUBE',
    'youtube-continuous': 'YOUTUBE',
    'speed-continuous': 'SPEEDCONTI',
    speed: 'SPEED',
    sptest_continuous: 'SPEEDCONTI',
    sptest: 'SPEED',
    video_single: 'VIDEO',
    video_continuous: 'VIDEOCONTI',
    call: 'CALL',
    call_continuous: 'CALLCONTI',
    'call-continuous': 'CALLCONTI',
    'rrc-single': 'RRC',
    'rrc-continuous': 'RRCCONTI',
    gnss: 'GNSS',
    'gnss-continuous': 'GNSSCONTI',
    gnss_continuous: 'GNSSCONTI',
    rrc_state: 'RRC',
    rrc_state_continuous: 'RRCCONTI',
    ftp: 'FTP',
    'ftp-continuous': 'FTPCONTI',
    ftp_continuous: 'FTPCONTI',
    wget_post: 'WGETPOST',
    'wget-post-continuous': 'WGETPOSTCONTI',
    wget_post_continuous: 'WGETPOSTCONTI',
    'security-continuous': 'SECURITY',
    security_continuous: 'SECURITY',
    securitytest: 'SECURITY',
    'security-single': 'SECURITY_SINGLE',
    security_single: 'SECURITY_SINGLE',
    ftptest:"FTP"
  };

  getPopupObservable() {
    return this.popupObservable.asObservable();
  }

  getNewInstanceOfTriggerDetailedSubmit() {
    this.triggerDetailedSubmit = new Subject();
    return this.triggerDetailedSubmit;
  }
  getCurrentInstanceOfTriggeredDetailedSubmit() {
    return this.triggerDetailedSubmit;
  }

  getDesableObs() {
    return this.disableActions.asObservable();
  }
  getStoppedRule() {
    return this.stoppedRule.asObservable();
  }
  devicesWithTestStartedStatus = [];
  typeMapping = {};
  // {
  //   RF: 'continuous', PINRF: '3_min', IPERF: 'iperf_continuous', PINIPERF: 'iperf', PING:'ping', CURL:"curl", CURLCONTI:"curl_continuous", PINGCONTI:"ping_continuous",
  //   PINYOUTUBE:"ytube", YOUTUBE:"ytube_continuous", SPEED:"sptest", SPEEDCONTI:"sptest_continuous", VIDEO:"video_single", "VIDEOCONTI":"video_continuous", CALL:"call",
  //   CALLCONTI:"call_continuous", RRC:"rrc_status", RRCCONTI:"rrc_status_continuous",
  // }
  baseInfo = {
    a_IMEI: '-',
    'c_Scan Time': '-',
    'b_Connected To': '-',
    d_Duration: '-',
  };

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  getVideoServerIpPort(locname?: any) {
    let op = new Observable((subscriber) => {
      subscriber.next({ port: 1234 });
    });
    return op;
  }

  downloadCSV(ruleids: any, time?: any, mapid?: any, deviceid?: any, tz?: any) {
    const filter = { ruleids, time, mapid, deviceid, tz };
    let api = `${this.fileServerUrl}/csvdownload/generatecsv`;
    return this.httpClient.post(api, filter, { responseType: 'blob' });
  }

  checkfor5GNetworkPresence(survey) {
    let network = '';
    if (survey) {
      for (let i = survey.length - 1; i >= 0; i--) {
        if (survey?.[i]?.servingcell) {
          if (survey?.[i]?.servingcell.includes('5G')) {
            network = network != '' ? network + ' + ' + '5G' : '5G';
          }
          if (survey?.[i]?.servingcell.includes('LTE')) {
            network = network != '' ? network + ' + ' + '4G' : '4G';
          }
        }
      }
    }
    return network;
  }

  padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

  time_convert(milliseconds: number) {
    if (milliseconds < 1000) {
      return `${milliseconds} ms`;
    } else {
      let seconds = Math.floor(milliseconds / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);

      seconds = seconds % 60;
      minutes = minutes % 60;
      hours = hours % 24;

      return `${this.padTo2Digits(hours)}:${this.padTo2Digits(
        minutes,
      )}:${this.padTo2Digits(seconds)}`;
    }
  }

  deleteMultipleScheduled(ids = []) {
    const options = { body: { ids: ids } };
    return this.httpClient.delete(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_mDelete`,
      options,
    );
  }

  getAllTemplatesRaw() {
    return this.httpClient.get(
      this.apiEndPoint + '/gwdevice/band_template/_search?size=1000',
    );
  }

  getPolicyMatrix() {
    return this.httpClient.get(
      `${this.apiEndPoint}/gwdevice/policy_matrix/_search?size=10000`,
    );
  }

  getSecurityProfileResults(runId: string, seq_num?:any) {
    const body = {
      query: {
        bool: {
          must: [
            { query_string: { query: runId, type: 'phrase', fields: ['run_id'] } },
            { query_string: { query: seq_num, type: 'phrase', fields: ['seq_number'] } }
          ]
        }
      },
      sort: { '_kuzzle_info.createdAt': 'desc' }
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/security_profile_results/_search?size=10000`,
      body
    );
  }

  searchSecurityTestResults(startTime: number, endTime: number, profileIds: string[], ruleIds: string[]) {
    const must: any[] = [
      { range: { '_kuzzle_info.createdAt': { gte: startTime, lte: endTime } } }
    ];
    if (profileIds.length > 0) {
      must.push({ terms: { 'profile_id': profileIds } });
    }
    if (ruleIds.length > 0) {
      must.push({ terms: { 'rule_result.rule_id': ruleIds } });
    }
    const body = { query: { bool: { must } }, sort: { '_kuzzle_info.createdAt': 'desc' } };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/security_profile_results/_search?size=10000`,
      body
    );
  }

  triggerSecurityProfileResultsAll(startTime: number, endTime: number, profileHashes: string[], ruleIds: string[], random?: string, user?: string, testname?: string) {
    const token = localStorage.getItem('token');
    return this.httpClient.post(
      `${this.fileServerUrl}/security-profile/results/all`,
      { startTime, endTime, profile_hash: profileHashes, rule_ids: ruleIds, random: random ?? Math.random().toString(36).slice(2, 12).toUpperCase(), user, testname },
      { headers: { Authorization: `Bearer ${token}` }, responseType: 'text' }
    );
  }

  getSecurityProfileAllJobs(user: any, authorization?: any) {
    const filter: any = {
      query: { bool: { must: [] } },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    if (authorization != 'admin' && authorization != 'super admin') {
      filter.query.bool.must.push({
        query_string: { query: user, type: 'phrase', fields: ['user'] },
      });
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/security_profile_results_all/_search?size=1000`,
      filter
    );
  }

  getAllDetailedReportData() {
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/detailedreportdata/_search?size=10000`,
      {
        query: { bool: { must: [{ term: { type: 'security' } }] } },
        sort: { '_kuzzle_info.createdAt': 'desc' },
      }
    );
  }

  getProfileBaselines(profiles: { profile_id: string; profile_hash: string }[]) {
    const should = profiles.map(p => ({
      bool: {
        must: [
          { query_string: { query: p.profile_id, type: 'phrase', fields: ['profile_id'] } },
          { query_string: { query: p.profile_hash, type: 'phrase', fields: ['profile_hash'] } }
        ]
      }
    }));
    const body = {
      query: { bool: { should, minimum_should_match: 1 } },
      sort: { '_kuzzle_info.createdAt': 'desc' }
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/security_profile_baseline/_search?size=10000`,
      body
    );
  }

  approveBaseline(id: string) {
    return this.httpClient.patch(
      `${this.apiEndPoint}/gwdevice/security_profile_baseline/${id}/_update`,
      { status: 'APPROVED' }
    );
  }



  constructor(
    private httpClient: HttpClient,
    @Inject('apiEndPoint') private apiEndPoint: string,
    @Inject('fileServerUrl') private fileServerUrl: string,
    @Inject('diagnosticUrl') private containerapiEndPoint,
  ) {
    this.generateAvailableTests();
    this.createAllTestsMapping();
  }

  private devices = new BehaviorSubject<any>('');

  getAllDevices() {
    return this.devices.asObservable();
  }
  sendAllDevices(alldevices) {
    return this.devices.next(alldevices);
  }

  startTest(parameters) {
    return this.httpClient.post(
      `${this.apiEndPoint}/_/2.0/edgecontrol`,
      parameters,
    );
  }

  generateRandomNum(
    length: number = 32,
    chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
  ) {
    var result = '';
    for (var i = length; i > 0; --i)
      result += chars[Math.floor(Math.random() * chars.length)];
    return result + new Date().valueOf();
  }

  setColorOriginal(param: string, para: any) {
    if (
      param == 'iperf_udp_ul_throughput' ||
      param == 'iperf_udp_dl_throughput' ||
      param == 'iperf_tcp_ul_throughput' ||
      param == 'iperf_tcp_dl_throughput'
    ) {
      return para >= 220
        ? '#00FF00'
        : para >= 198 && para <= 219.999
          ? '#12FF00'
          : para >= 180 && para <= 197.999
            ? '#35FF00'
            : para >= 162 && para <= 179.999
              ? '#58FF00'
              : para >= 144 && para <= 161.999
                ? '#8DFF00'
                : para >= 126 && para <= 143.999
                  ? '#B0FF00'
                  : para >= 108 && para <= 125.999
                    ? '#C2FF00'
                    : para >= 90 && para <= 107.999
                      ? '#D4FF00'
                      : para >= 72 && para <= 89.999
                        ? '#E5FF00'
                        : para >= 54 && para <= 71.999
                          ? '#FF6900'
                          : para >= 36 && para <= 53.999
                            ? '#FF4600'
                            : para >= 18 && para <= 35.999
                              ? '#FF2300'
                              : // para >= 0.01 && para <= 17.9999 ? '#FF0000' :
                                para >= 13 && para <= 17.9999
                                ? '#fd5c63'
                                : para >= 8 && para <= 12.9999
                                  ? '#C04000'
                                  : para >= 3 && para <= 7.9999
                                    ? '#C41E3A'
                                    : para >= 0.0009 && para <= 2.9999
                                      ? '#58111A'
                                      : '#B2BEB5';
    } else if (
  param == 'iperf_udp_dl_jitter' ||
  param == 'iperf_udp_ul_jitter' ||
  param == 'totaltime'
) {
  return para >= 190
    ? '#00FF00'
    : para >= 165 && para <= 190.999
      ? '#12FF00'
      : para >= 150 && para <= 164.999
        ? '#35FF00'
        : para >= 135 && para <= 149.999
          ? '#58FF00'
          : para >= 120 && para <= 134.999
            ? '#8DFF00'
            : para >= 105 && para <= 119.999
              ? '#B0FF00'
              : para >= 90 && para <= 104.999
                ? '#C2FF00'
                : para >= 75 && para <= 89.999
                  ? '#D4FF00'
                  : para >= 60 && para <= 74.999
                    ? '#E5FF00'
                    : para >= 45 && para <= 59.999
                      ? '#FF6900'
                      : para >= 30 && para <= 44.999
                        ? '#FF4600'
                        : para >= 15 && para <= 29.999
                          ? '#FF2300'
                          : para >= 0 && para <= 14.9999
                            ? '#FF0000'
                            : '#FF0000';
}
 else if (param == 'sinr') {
      return para >= 30
        ? '#0d47a1'
        : para < 30 && para >= 25
          ? '#388e3c'
          : para < 25 && para >= 20
            ? '#76ff03'
            : para < 20 && para >= 15
              ? '#ffff00'
              : para < 15 && para >= 10
                ? '#ff9800'
                : para < 10 && para >= 5
                  ? '#ff3d00'
                  : para < 5 && para >= 3
                    ? '#bdbdbd'
                    : para < 3
                      ? '#616161'
                      : '#0d47a1';
    } else if (param == 'upload' || param == 'download') {
      //for sptest
      return para >= 190
        ? '#00FF00'
        : para >= 165 && para <= 190.999
          ? '#12FF00'
          : para >= 150 && para <= 164.999
            ? '#35FF00'
            : para >= 135 && para <= 149.999
              ? '#58FF00'
              : para >= 120 && para <= 134.999
                ? '#8DFF00'
                : para >= 105 && para <= 119.999
                  ? '#B0FF00'
                  : para >= 90 && para <= 104.999
                    ? '#C2FF00'
                    : para >= 75 && para <= 89.999
                      ? '#D4FF00'
                      : para >= 60 && para <= 74.999
                        ? '#E5FF00'
                        : para >= 45 && para <= 59.999
                          ? '#FF6900'
                          : para >= 30 && para <= 44.999
                            ? '#FF4600'
                            : para >= 15 && para <= 29.999
                              ? '#FF2300'
                              : para >= 0 && para <= 14.9999
                                ? '#FF0000'
                                : '#FF0000';
    } else if (
      param == 'pkts_tx' ||
      param == 'pkts_rx' ||
      param == 'audio_jitter_std' ||
      param == 'video_jitter_std'
    ) {
      //for ping
      return para >= 190
        ? '#FF0000'
        : para >= 165 && para <= 190.999
          ? '#FF2300'
          : para >= 150 && para <= 164.999
            ? '#FF4600'
            : para >= 135 && para <= 149.999
              ? '#FF6900'
              : para >= 120 && para <= 134.999
                ? '#E5FF00'
                : para >= 105 && para <= 119.999
                  ? '#D4FF00'
                  : para >= 90 && para <= 104.999
                    ? '#C2FF00'
                    : para >= 75 && para <= 89.999
                      ? '#B0FF00'
                      : para >= 60 && para <= 74.999
                        ? '#8DFF00'
                        : para >= 45 && para <= 59.999
                          ? '#58FF00'
                          : para >= 30 && para <= 44.999
                            ? '#35FF00'
                            : para >= 15 && para <= 29.999
                              ? '#12FF00'
                              : para >= 0 && para <= 14.9999
                                ? '#00FF00'
                                : '#00FF00';
    } else if (param == 'pkt_loss') {
      //for ping
      return para >= 100
        ? ' #FF0000'
        : para >= 90 && para <= 99.999
          ? '  #FF4600'
          : para >= 80 && para <= 89.999
            ? ' #FF6900'
            : para >= 70 && para <= 79.999
              ? ' #FFAC1C'
              : para >= 60 && para <= 69.999
                ? ' #B0FF00'
                : para >= 50 && para <= 59.999
                  ? ' #8DFF00'
                  : para >= 40 && para <= 49.999
                    ? ' #58FF00'
                    : para >= 30 && para <= 39.999
                      ? ' #35FF00'
                      : para >= 20 && para <= 29.999
                        ? ' #12FF00'
                        : para >= 10 && para <= 19.999
                          ? ' #00FF00'
                          : para >= 0 && para <= 9.9999
                            ? ' #008000'
                            : ' #008000';
    } else if (
      param == 'average_download_speed_mbps' ||
      param == 'bitrate' ||
      param == 'fps' ||
      param == 'speed'
    ) {
      //for ytube
      return para >= 190
        ? '#00FF00'
        : para >= 165 && para <= 190.999
          ? '#12FF00'
          : para >= 150 && para <= 164.999
            ? '#35FF00'
            : para >= 135 && para <= 149.999
              ? '#58FF00'
              : para >= 120 && para <= 134.999
                ? '#8DFF00'
                : para >= 105 && para <= 119.999
                  ? '#B0FF00'
                  : para >= 90 && para <= 104.999
                    ? '#C2FF00'
                    : para >= 75 && para <= 89.999
                      ? '#D4FF00'
                      : para >= 60 && para <= 74.999
                        ? '#E5FF00'
                        : para >= 45 && para <= 59.999
                          ? '#FF6900'
                          : para >= 30 && para <= 44.999
                            ? '#FF4600'
                            : para >= 15 && para <= 29.999
                              ? '#FF2300'
                              : para >= 0 && para <= 14.9999
                                ? '#FF0000'
                                : '#FF0000';
    } else if (param == 'overall_quality_assessment') {
      //for ytube
      return para == 'Poor'
        ? '#FF2300'
        : para == 'Fair'
          ? '#E5FF00'
          : para == 'Good'
            ? '#8DFF00'
            : para == 'Excellent'
              ? '#00FF00'
              : '#808080';
    } else if (
      param == 'ALERTING' ||
      param == 'ORIGINATING' ||
      param == 'CONNECTED'
    ) {
      //for call status
      return param == 'ALERTING' && para
        ? '#a6eb47ff'
        : param == 'ORIGINATING' && para
          ? '#61c008ff'
          : param == 'CONNECTED' && para
            ? '#097909ff'
            : '#808080';
    } else if (param == 'GPS') {
      return '#388e3c';
    } else {
      if (para == 99) {
        return '#808080';
      } else if (param == 'rsrq') {
        return para <= -116
          ? '#132257'
          : para >= -115 && para <= -110
            ? '#132257'
            : para >= -109 && para <= -105
              ? '#ff3d00'
              : para >= -104 && para <= -100
                ? '#ef6c00'
                : para >= -99 && para <= -95
                  ? '#eeff41'
                  : para >= -94 && para <= -90
                    ? '#1b5e20'
                    : para >= -89 && para <= -85
                      ? '#388e3c'
                      : para >= -84 && para <= -80
                        ? '#afb42b'
                        : para >= -79 && para <= -75
                          ? '#00e676'
                          : para >= -74 && para <= -70
                            ? '#8e24aa'
                            : para >= -69 && para <= -65
                              ? '#e57373'
                              : para >= -64 && para <= -60
                                ? '#e040fb'
                                : para >= -59 && para <= -55
                                  ? '#e1bee7'
                                  : para >= -54 && para <= -50
                                    ? '#5072A7'
                                    : para >= -49 && para <= -45
                                      ? '#318CE7'
                                      : para >= -44 && para <= -40
                                        ? '#6699CC'
                                        : para >= -39 && para <= -35
                                          ? '#89CFF0'
                                          : para >= -34 && para <= -30
                                            ? '#7FFFD4'
                                            : para >= -29 && para <= -25
                                              ? '#B2FFFF'
                                              : para >= -24 && para <= -20
                                                ? '#FF1493'
                                                : para >= -19 && para <= -15
                                                  ? '#00CED1'
                                                  : para >= -14 && para <= -10
                                                    ? '#FFD700'
                                                    : para >= -9 && para <= -5
                                                      ? '#8B0000'
                                                      : para >= -4 && para <= 0
                                                        ? '#32CD32'
                                                        : para >= 0
                                                          ? '#FF4500'
                                                          : '#FF4500';
      } else {
        return para <= -116
          ? '#132257'
          : para >= -115 && para <= -110
            ? '#132257'
            : para >= -109 && para <= -105
              ? '#ff3d00'
              : para >= -104 && para <= -100
                ? '#ef6c00'
                : para >= -99 && para <= -95
                  ? '#eeff41'
                  : para >= -94 && para <= -90
                    ? '#1b5e20'
                    : para >= -89 && para <= -85
                      ? '#388e3c'
                      : para >= -84 && para <= -80
                        ? '#afb42b'
                        : para >= -79 && para <= -75
                          ? '#00e676'
                          : para >= -74 && para <= -70
                            ? '#8e24aa'
                            : para >= -69 && para <= -65
                              ? '#e57373'
                              : para >= -64 && para <= -60
                                ? '#e040fb'
                                : para >= -59 && para <= -55
                                  ? '#e1bee7'
                                  : para >= -54 && para <= -50
                                    ? '#5072A7'
                                    : para >= -49 && para <= -45
                                      ? '#318CE7'
                                      : para >= -44 && para <= -40
                                        ? '#6699CC'
                                        : para >= -39 && para <= -35
                                          ? '#89CFF0'
                                          : para >= -34 && para <= -30
                                            ? '#7FFFD4'
                                            : para >= -29 && para <= -25
                                              ? '#B2FFFF'
                                              : '#B2FFFF';
      }
    }
  }



// setColor(param: string, para: any) {
//   if (
//   param == 'iperf_udp_ul_throughput' ||
//   param == 'iperf_udp_dl_throughput' ||
//   param == 'iperf_tcp_ul_throughput' ||
//   param == 'iperf_tcp_dl_throughput'
// ) {
//   return para >= 1000
//     ? '#FF0000'
//     : para >= 695 && para < 1000
//       ? '#FF4D00'
//       : para >= 483 && para < 695
//         ? '#FF8000'
//         : para >= 336 && para < 483
//           ? '#FFCC00'
//             : para >= 234 && para < 336
//               ? '#FFFF00'
//               : para >= 162 && para < 234
//                 ? '#B3FF00'
//                 : para >= 113 && para < 162
//                   ? '#80FF00'
//                   : para >= 78 && para < 113
//                     ? '#33FF00'
//                     : para >= 55 && para < 78
//                       ? '#00FF1A'
//                       : para >= 38 && para < 55
//                         ? '#00FF4D'
//                         : para >= 26 && para < 38
//                           ? '#00FF99'
//                           : para >= 18 && para < 26
//                             ? '#00FFCC'
//                             : para >= 13 && para < 18
//                               ? '#00E6FF'
//                               : para >= 9 && para < 13
//                                 ? '#0099FF'
//                                 : para >= 6 && para < 9
//                                   ? '#0066FF'
//                                   : para >= 4 && para < 6
//                                     ? '#001AFF'
//                                     : para >= 3 && para < 4
//                                       ? '#1900F0'
//                                       : para >= 2 && para < 3
//                                         ? '#3100C0'
//                                         : para >= 1 && para < 2
//                                           ? '#4000A0'
//                                           : para >= 0 && para < 1
//                                             ? '#570070'
//                                             : '#570070';
// }
//  else if (
//     param == 'iperf_udp_dl_jitter' ||
//     param == 'iperf_udp_ul_jitter'
//   ) {
//     return para >= 100
//       ? '#FF0000'
//       : para >= 75 && para < 100
//         ? '#FF1A00'
//         : para >= 50 && para < 75
//           ? '#FF3300'
//           : para >= 30 && para < 50
//             ? '#FF4D00'
//             : para >= 20 && para < 30
//               ? '#FF6600'
//               : para >= 15 && para < 20
//                 ? '#FF9900'
//                 : para >= 10 && para < 15
//                   ? '#FFCC00'
//                   : para >= 5 && para < 10
//                     ? '#FFFF00'
//                     : para >= 2 && para < 5
//                       ? '#99FF00'
//                       : para >= 1 && para < 2
//                         ? '#00FF66'
//                         : para >= 0 && para < 1
//                           ? '#00FFFF'
//                           : '#570070';
//   } else if (param == 'sinr') {
//     // *** REVERSED COLORS ***
//     return para >= 30
//       ? '#FF0000'
//       : para >= 25 && para < 30
//         ? '#FFFF00'
//         : para >= 20 && para < 25
//           ? '#99FF00'
//           : para >= 15 && para < 20
//             ? '#00FF33'
//             : para >= 10 && para < 15
//               ? '#00FFCC'
//               : para >= 5 && para < 10
//                 ? '#0099FF'
//                 : para >= 3 && para < 5
//                   ? '#0000FF'
//                   : para >= 0 && para < 3
//                     ? '#2100E0'
//                     : para >= -5 && para < 0
//                       ? '#3800B0'
//                       : para >= -10 && para < -5
//                         ? '#4F0080'
//                         : para < -10
//                           ? '#570070'
//                           : '#570070';
//   } else if (param == 'upload' || param == 'download') {
//      return para >= 1000
//     ? '#FF0000'
//     : para >= 695 && para < 1000
//       ? '#FF4D00'
//       : para >= 483 && para < 695
//         ? '#FF8000'
//         : para >= 336 && para < 483
//           ? '#FFCC00'
//             : para >= 234 && para < 336
//               ? '#FFFF00'
//               : para >= 162 && para < 234
//                 ? '#B3FF00'
//                 : para >= 113 && para < 162
//                   ? '#80FF00'
//                   : para >= 78 && para < 113
//                     ? '#33FF00'
//                     : para >= 55 && para < 78
//                       ? '#00FF1A'
//                       : para >= 38 && para < 55
//                         ? '#00FF4D'
//                         : para >= 26 && para < 38
//                           ? '#00FF99'
//                           : para >= 18 && para < 26
//                             ? '#00FFCC'
//                             : para >= 13 && para < 18
//                               ? '#00E6FF'
//                               : para >= 9 && para < 13
//                                 ? '#0099FF'
//                                 : para >= 6 && para < 9
//                                   ? '#0066FF'
//                                   : para >= 4 && para < 6
//                                     ? '#001AFF'
//                                     : para >= 3 && para < 4
//                                       ? '#1900F0'
//                                       : para >= 2 && para < 3
//                                         ? '#3100C0'
//                                         : para >= 1 && para < 2
//                                           ? '#4000A0'
//                                           : para >= 0 && para < 1
//                                             ? '#570070'
//                                             : '#570070';
//   } else if (
//     param == 'pkts_tx' ||
//     param == 'pkts_rx' ||
//     param == 'audio_jitter_std' ||
//     param == 'video_jitter_std'
//   ) {
//     return para >= 100
//       ? '#FF0000'
//       : para >= 75 && para < 100
//         ? '#FF1A00'
//         : para >= 50 && para < 75
//           ? '#FF3300'
//           : para >= 30 && para < 50
//             ? '#FF4D00'
//             : para >= 20 && para < 30
//               ? '#FF6600'
//               : para >= 15 && para < 20
//                 ? '#FF9900'
//                 : para >= 10 && para < 15
//                   ? '#FFCC00'
//                   : para >= 5 && para < 10
//                     ? '#FFFF00'
//                     : para >= 2 && para < 5
//                       ? '#99FF00'
//                       : para >= 1 && para < 2
//                         ? '#00FF66'
//                         : para >= 0 && para < 1
//                           ? '#00FFFF'
//                           : '#570070';
//   } else if (param == 'pkt_loss') {
//     return para >= 100
//       ? '#FF0000'
//       : para >= 50 && para < 100
//         ? '#FF1A00'
//         : para >= 25 && para < 50
//           ? '#FF3300'
//           : para >= 15 && para < 25
//             ? '#FF4D00'
//             : para >= 10 && para < 15
//               ? '#FF6600'
//               : para >= 7 && para < 10
//                 ? '#FF9900'
//                 : para >= 5 && para < 7
//                   ? '#FFCC00'
//                   : para >= 3 && para < 5
//                     ? '#FFFF00'
//                     : para >= 2 && para < 3
//                       ? '#CCFF00'
//                       : para >= 1 && para < 2
//                         ? '#66FF00'
//                         : para >= 0.5 && para < 1
//                           ? '#00FF66'
//                           : para >= 0.1 && para < 0.5
//                             ? '#00FFCC'
//                             : para >= 0 && para < 0.1
//                               ? '#00FFFF'
//                               : '#570070';
//   } else if (
//     param == 'average_download_speed_mbps' ||
//     param == 'bitrate' ||
//     param == 'speed'
//   ) {
//      return para >= 1000
//     ? '#FF0000'
//     : para >= 695 && para < 1000
//       ? '#FF4D00'
//       : para >= 483 && para < 695
//         ? '#FF8000'
//         : para >= 336 && para < 483
//           ? '#FFCC00'
//             : para >= 234 && para < 336
//               ? '#FFFF00'
//               : para >= 162 && para < 234
//                 ? '#B3FF00'
//                 : para >= 113 && para < 162
//                   ? '#80FF00'
//                   : para >= 78 && para < 113
//                     ? '#33FF00'
//                     : para >= 55 && para < 78
//                       ? '#00FF1A'
//                       : para >= 38 && para < 55
//                         ? '#00FF4D'
//                         : para >= 26 && para < 38
//                           ? '#00FF99'
//                           : para >= 18 && para < 26
//                             ? '#00FFCC'
//                             : para >= 13 && para < 18
//                               ? '#00E6FF'
//                               : para >= 9 && para < 13
//                                 ? '#0099FF'
//                                 : para >= 6 && para < 9
//                                   ? '#0066FF'
//                                   : para >= 4 && para < 6
//                                     ? '#001AFF'
//                                     : para >= 3 && para < 4
//                                       ? '#1900F0'
//                                       : para >= 2 && para < 3
//                                         ? '#3100C0'
//                                         : para >= 1 && para < 2
//                                           ? '#4000A0'
//                                           : para >= 0 && para < 1
//                                             ? '#570070'
//                                             : '#570070';
//   } else if (param == 'fps') {
//     return para >= 60
//       ? '#570070'
//       : para >= 45 && para < 60
//         ? '#4000A0'
//         : para >= 30 && para < 45
//           ? '#2900D0'
//           : para >= 24 && para < 30
//             ? '#0000FF'
//             : para >= 20 && para < 24
//               ? '#0099FF'
//               : para >= 15 && para < 20
//                 ? '#00FFFF'
//                 : para >= 10 && para < 15
//                   ? '#00FF66'
//                   : para >= 5 && para < 10
//                     ? '#99FF00'
//                     : para >= 0 && para < 5
//                       ? '#FFFF00'
//                       : '#FF0000';
//   } else if (param == 'totaltime') {
//     return para >= 30
//       ? '#FF0000'
//       : para >= 20 && para < 30
//         ? '#FF1A00'
//         : para >= 15 && para < 20
//           ? '#FF3300'
//           : para >= 10 && para < 15
//             ? '#FF6600'
//             : para >= 7 && para < 10
//               ? '#FF9900'
//               : para >= 5 && para < 7
//                 ? '#FFCC00'
//                 : para >= 3 && para < 5
//                   ? '#FFFF00'
//                   : para >= 2 && para < 3
//                     ? '#99FF00'
//                     : para >= 1 && para < 2
//                       ? '#00FF66'
//                       : para >= 0.5 && para < 1
//                         ? '#00FFCC'
//                         : para >= 0 && para < 0.5
//                           ? '#00FFFF'
//                           : '#570070';
//   } else if (param == 'latency') {
//     return para >= 500
//       ? '#FF0000'
//       : para >= 300 && para < 500
//         ? '#FF1A00'
//         : para >= 200 && para < 300
//           ? '#FF3300'
//           : para >= 150 && para < 200
//             ? '#FF4D00'
//             : para >= 100 && para < 150
//               ? '#FF6600'
//               : para >= 75 && para < 100
//                 ? '#FF9900'
//                 : para >= 50 && para < 75
//                   ? '#FFCC00'
//                   : para >= 30 && para < 50
//                     ? '#FFFF00'
//                     : para >= 20 && para < 30
//                       ? '#99FF00'
//                       : para >= 10 && para < 20
//                         ? '#00FF66'
//                         : para >= 5 && para < 10
//                           ? '#00FFCC'
//                           : para >= 0 && para < 5
//                             ? '#00FFFF'
//                             : '#570070';
//   } else if (param == 'snr') {
//     return para >= 40
//       ? '#570070'
//       : para >= 35 && para < 40
//         ? '#4000A0'
//         : para >= 30 && para < 35
//           ? '#2900D0'
//           : para >= 25 && para < 30
//             ? '#0000FF'
//             : para >= 20 && para < 25
//               ? '#0099FF'
//               : para >= 15 && para < 20
//                 ? '#00FFFF'
//                 : para >= 10 && para < 15
//                   ? '#00FF66'
//                   : para >= 5 && para < 10
//                     ? '#99FF00'
//                     : para >= 0 && para < 5
//                       ? '#FFFF00'
//                       : '#FF0000';
//   } else if (param == 'overall_quality_assessment') {
//     return para == 'Poor'
//       ? '#FF0000'
//       : para == 'Fair'
//         ? '#FFCC00'
//         : para == 'Good'
//           ? '#00FF66'
//           : para == 'Excellent'
//             ? '#570070'
//             : '#808080';
//   } else if (
//     param == 'ALERTING' ||
//     param == 'ORIGINATING' ||
//     param == 'CONNECTED'
//   ) {
//     return param == 'ALERTING' && para
//       ? '#a6eb47ff'
//       : param == 'ORIGINATING' && para
//         ? '#61c008ff'
//         : param == 'CONNECTED' && para
//           ? '#097909ff'
//           : '#808080';
//   } else if (param == 'GPS') {
//     return '#388e3c';
//   } else {
//     if (para == 99) {
//       return '#808080';
//     } else if (param == 'rsrq') {
//       // *** REVERSED COLORS ***
// return para >= -3
//   ? '#FF0000'
//   : para >= -5 && para < -3
//     ? '#FF8000'
//     : para >= -7 && para < -5
//       ? '#FFFF00'
//       : para >= -9 && para < -7
//         ? '#99FF00'
//         : para >= -10 && para < -9
//           ? '#00FF66'
//           : para >= -11 && para < -10
//             ? '#00FFFF'
//             : para >= -12 && para < -11
//               ? '#0066FF'
//               : para >= -13 && para < -12
//                 ? '#0000FF'
//                 : para >= -15 && para < -13
//                   ? '#2900D0'
//                   : para >= -18 && para < -15
//                     ? '#3800B0'
//                     : para >= -20 && para < -18
//                       ? '#4F0080'
//                       : para < -20
//                         ? '#570070'
//                         : '#570070';

//     } else if (param == 'rsrp') {
//       // *** REVERSED COLORS ***
// return para >= -60
//   ? '#FF0000'
//   : para >= -65 && para < -60
//     ? '#FF4D00'
//     : para >= -70 && para < -65
//       ? '#FF9900'
//       : para >= -75 && para < -70
//         ? '#FFE600'
//         : para >= -80 && para < -75
//           ? '#B3FF00'
//           : para >= -85 && para < -80
//             ? '#4DFF00'
//             : para >= -90 && para < -85
//               ? '#00FF4D'
//               : para >= -95 && para < -90
//                 ? '#00FFB3'
//                 : para >= -100 && para < -95
//                   ? '#00FFFF'
//                   : para >= -105 && para < -100
//                     ? '#0099FF'
//                     : para >= -110 && para < -105
//                       ? '#0033FF'
//                       : para >= -115 && para < -110
//                         ? '#0000FF'
//                         : para >= -120 && para < -115
//                           ? '#2900D0'
//                           : para >= -130 && para < -120
//                             ? '#3800B0'
//                             : para >= -140 && para < -130
//                               ? '#4F0080'
//                               : para < -140
//                                 ? '#570070'
//                                 : '#570070';

//     } else {
//       // RSSI *** REVERSED COLORS ***
//       return para >= -30
//   ? '#FF0000'
//   : para >= -35 && para < -30
//     ? '#FF4D00'
//     : para >= -40 && para < -35
//       ? '#FF9900'
//       : para >= -45 && para < -40
//         ? '#FFE600'
//         : para >= -50 && para < -45
//           ? '#CCFF00'
//           : para >= -55 && para < -50
//             ? '#66FF00'
//             : para >= -60 && para < -55
//               ? '#00FF33'
//               : para >= -65 && para < -60
//                 ? '#00FF99'
//                 : para >= -70 && para < -65
//                   ? '#00FFFF'
//                   : para >= -75 && para < -70
//                     ? '#00B3FF'
//                     : para >= -80 && para < -75
//                       ? '#0066FF'
//                       : para >= -85 && para < -80
//                         ? '#0000FF'
//                         : para >= -90 && para < -85
//                           ? '#2100E0'
//                           : para >= -95 && para < -90
//                             ? '#3100C0'
//                             : para >= -100 && para < -95
//                               ? '#4000A0'
//                               : para >= -105 && para < -100
//                                 ? '#4F0080'
//                                 : para >= -110 && para < -105
//                                   ? '#570070'
//                                   : para < -110
//                                     ? '#570070'
//                                     : '#570070';

//     }
//   }
// }

setColorR1(param: string, para: any) {
  if (
    param == 'iperf_udp_ul_throughput' ||
    param == 'iperf_udp_dl_throughput' ||
    param == 'iperf_tcp_ul_throughput' ||
    param == 'iperf_tcp_dl_throughput'
  ) {
    return para >= 1000
      ? '#FF0000'
      : para >= 695 && para < 1000
        ? '#FF3300'
        : para >= 483 && para < 695
          ? '#FF8000'
          : para >= 336 && para < 483
            ? '#FFB300'
            : para >= 234 && para < 336
              ? '#FFFF00'
              : para >= 162 && para < 234
                ? '#CCFF00'
                : para >= 113 && para < 162
                  ? '#80FF00'
                  : para >= 78 && para < 113
                    ? '#4DFF00'
                    : para >= 55 && para < 78
                      ? '#00FF00'
                      : para >= 38 && para < 55
                        ? '#00FF33'
                        : para >= 26 && para < 38
                          ? '#00FF80'
                          : para >= 18 && para < 26
                            ? '#00FFB3'
                            : para >= 13 && para < 18
                              ? '#00FFE6'
                              : para >= 9 && para < 13
                                ? '#00CCFF'
                                : para >= 6 && para < 9
                                  ? '#0099FF'
                                  : para >= 4 && para < 6
                                    ? '#004DFF'
                                    : para >= 3 && para < 4
                                      ? '#001AFF'
                                      : para >= 2 && para < 3
                                        ? '#2100E0'
                                        : para >= 1 && para < 2
                                          ? '#3100C0'
                                          : para >= 0 && para < 1
                                            ? '#470090'
                                            : '#570070';
  } else if (
    param == 'iperf_udp_dl_jitter' ||
    param == 'iperf_udp_ul_jitter'
  ) {
    return para >= 100
      ? '#570070'
      : para >= 75 && para < 100
        ? '#3800B0'
        : para >= 50 && para < 75
          ? '#0000FF'
          : para >= 30 && para < 50
            ? '#0066FF'
            : para >= 20 && para < 30
              ? '#00E6FF'
              : para >= 15 && para < 20
                ? '#00FFB3'
                : para >= 10 && para < 15
                  ? '#00FF33'
                  : para >= 5 && para < 10
                    ? '#33FF00'
                    : para >= 2 && para < 5
                      ? '#B3FF00'
                      : para >= 1 && para < 2
                        ? '#FFE600'
                        : para >= 0 && para < 1
                          ? '#FF6600'
                          : '#FF0000';
  } else if (param == 'sinr') {
    return para >= 30
      ? '#FF0000'
      : para >= 25 && para < 30
        ? '#FF8000'
        : para >= 20 && para < 25
          ? '#FFFF00'
          : para >= 15 && para < 20
            ? '#80FF00'
            : para >= 10 && para < 15
              ? '#00FF00'
              : para >= 5 && para < 10
                ? '#00FF80'
                : para >= 3 && para < 5
                  ? '#00FFE6'
                  : para >= 0 && para < 3
                    ? '#0099FF'
                    : para >= -5 && para < 0
                      ? '#001AFF'
                      : para >= -10 && para < -5
                        ? '#3100C0'
                        : para < -10
                          ? '#570070'
                          : '#570070';
  } else if (param == 'upload' || param == 'download') {
    return para >= 1000
      ? '#FF0000'
      : para >= 695 && para < 1000
        ? '#FF3300'
        : para >= 483 && para < 695
          ? '#FF8000'
          : para >= 336 && para < 483
            ? '#FFB300'
            : para >= 234 && para < 336
              ? '#FFFF00'
              : para >= 162 && para < 234
                ? '#CCFF00'
                : para >= 113 && para < 162
                  ? '#80FF00'
                  : para >= 78 && para < 113
                    ? '#4DFF00'
                    : para >= 55 && para < 78
                      ? '#00FF00'
                      : para >= 38 && para < 55
                        ? '#00FF33'
                        : para >= 26 && para < 38
                          ? '#00FF80'
                          : para >= 18 && para < 26
                            ? '#00FFB3'
                            : para >= 13 && para < 18
                              ? '#00FFE6'
                              : para >= 9 && para < 13
                                ? '#00CCFF'
                                : para >= 6 && para < 9
                                  ? '#0099FF'
                                  : para >= 4 && para < 6
                                    ? '#004DFF'
                                    : para >= 3 && para < 4
                                      ? '#001AFF'
                                      : para >= 2 && para < 3
                                        ? '#2100E0'
                                        : para >= 1 && para < 2
                                          ? '#3100C0'
                                          : para >= 0 && para < 1
                                            ? '#470090'
                                            : '#570070';
  } else if (
    param == 'pkts_tx' ||
    param == 'pkts_rx' ||
    param == 'audio_jitter_std' ||
    param == 'video_jitter_std'
  ) {
      return para >= 100
        ? '#570070'
        : para >= 75 && para < 100
          ? '#3800B0'
          : para >= 50 && para < 75
            ? '#0000FF'
            : para >= 30 && para < 50
              ? '#0066FF'
              : para >= 20 && para < 30
                ? '#00E6FF'
                : para >= 15 && para < 20
                  ? '#00FFB3'
                  : para >= 10 && para < 15
                    ? '#00FF33'
                    : para >= 5 && para < 10
                      ? '#33FF00'
                      : para >= 2 && para < 5
                        ? '#B3FF00'
                        : para >= 1 && para < 2
                          ? '#FFE600'
                          : para >= 0 && para < 1
                            ? '#FF6600'
                            : '#FF0000';
  } else if (param == 'pkt_loss') {
return para >= 100
  ? '#570070'
  : para >= 50 && para < 100
    ? '#3800B0'
    : para >= 25 && para < 50
      ? '#1900F0'
      : para >= 15 && para < 25
        ? '#0033FF'
        : para >= 10 && para < 15
          ? '#0099FF'
          : para >= 7 && para < 10
            ? '#00FFFF'
            : para >= 5 && para < 7
              ? '#00FF99'
              : para >= 3 && para < 5
                ? '#00FF4D'
                : para >= 2 && para < 3
                  ? '#1AFF00'
                  : para >= 1 && para < 2
                    ? '#80FF00'
                    : para >= 0.5 && para < 1
                      ? '#E6FF00'
                      : para >= 0.1 && para < 0.5
                        ? '#FFCC00'
                        : para >= 0 && para < 0.1
                          ? '#FF0000'
                          : '#FF0000';

  } else if (
    param == 'average_download_speed_mbps' ||
    param == 'bitrate' ||
    param == 'speed'
  ) {
    return para >= 1000
      ? '#FF0000'
      : para >= 695 && para < 1000
        ? '#FF3300'
        : para >= 483 && para < 695
          ? '#FF8000'
          : para >= 336 && para < 483
            ? '#FFB300'
            : para >= 234 && para < 336
              ? '#FFFF00'
              : para >= 162 && para < 234
                ? '#CCFF00'
                : para >= 113 && para < 162
                  ? '#80FF00'
                  : para >= 78 && para < 113
                    ? '#4DFF00'
                    : para >= 55 && para < 78
                      ? '#00FF00'
                      : para >= 38 && para < 55
                        ? '#00FF33'
                        : para >= 26 && para < 38
                          ? '#00FF80'
                          : para >= 18 && para < 26
                            ? '#00FFB3'
                            : para >= 13 && para < 18
                              ? '#00FFE6'
                              : para >= 9 && para < 13
                                ? '#00CCFF'
                                : para >= 6 && para < 9
                                  ? '#0099FF'
                                  : para >= 4 && para < 6
                                    ? '#004DFF'
                                    : para >= 3 && para < 4
                                      ? '#001AFF'
                                      : para >= 2 && para < 3
                                        ? '#2100E0'
                                        : para >= 1 && para < 2
                                          ? '#3100C0'
                                          : para >= 0 && para < 1
                                            ? '#470090'
                                            : '#570070';
  }else if (param == 'fps') {
    return para >= 60
      ? '#FF0000'
      : para >= 45 && para < 60
        ? '#FF8000'
        : para >= 30 && para < 45
          ? '#E6FF00'
          : para >= 24 && para < 30
            ? '#66FF00'
            : para >= 20 && para < 24
              ? '#00FF33'
              : para >= 15 && para < 20
                ? '#00FFB3'
                : para >= 10 && para < 15
                  ? '#00B3FF'
                  : para >= 5 && para < 10
                    ? '#0033FF'
                    : para >= 0 && para < 5
                      ? '#3100C0'
                      : '#570070';
}else if (param == 'totaltime') {
    return para >= 30
      ? '#570070'
      : para >= 20 && para < 30
        ? '#3800B0'
        : para >= 15 && para < 20
          ? '#0000FF'
          : para >= 10 && para < 15
            ? '#0066FF'
            : para >= 7 && para < 10
              ? '#00E6FF'
              : para >= 5 && para < 7
                ? '#00FFB3'
                : para >= 3 && para < 5
                  ? '#00FF33'
                  : para >= 2 && para < 3
                    ? '#33FF00'
                    : para >= 1 && para < 2
                      ? '#B3FF00'
                      : para >= 0.5 && para < 1
                        ? '#FFE600'
                        : para >= 0 && para < 0.5
                          ? '#FF6600'
                          : '#FF0000';
  }
 else if (param == 'latency') {
    return para >= 500
      ? '#FF0000'
      : para >= 300 && para < 500
        ? '#FF6600'
        : para >= 200 && para < 300
          ? '#FFCC00'
          : para >= 150 && para < 200
            ? '#CCFF00'
            : para >= 100 && para < 150
              ? '#66FF00'
              : para >= 75 && para < 100
                ? '#00FF00'
                : para >= 50 && para < 75
                  ? '#00FF80'
                  : para >= 30 && para < 50
                    ? '#00FFE6'
                    : para >= 20 && para < 30
                      ? '#00B3FF'
                      : para >= 10 && para < 20
                        ? '#004DFF'
                        : para >= 5 && para < 10
                          ? '#1900F0'
                          : para >= 0 && para < 5
                            ? '#3800B0'
                            : '#570070';
  } else if (param == 'snr') {
    return para >= 40
      ? '#570070'
      : para >= 35 && para < 40
        ? '#3100C0'
        : para >= 30 && para < 35
          ? '#0033FF'
          : para >= 25 && para < 30
            ? '#00B3FF'
            : para >= 20 && para < 25
              ? '#00FFB3'
              : para >= 15 && para < 20
                ? '#00FF33'
                : para >= 10 && para < 15
                  ? '#66FF00'
                  : para >= 5 && para < 10
                    ? '#E6FF00'
                    : para >= 0 && para < 5
                      ? '#FF8000'
                      : '#FF0000';
  } else if (param == 'overall_quality_assessment') {
    return para == 'Poor'
      ? '#FF0000'
      : para == 'Fair'
        ? '#66FF00'
        : para == 'Good'
          ? '#00B3FF'
          : para == 'Excellent'
            ? '#570070'
            : '#808080';
  } else if (
    param == 'ALERTING' ||
    param == 'ORIGINATING' ||
    param == 'CONNECTED'
  ) {
    return param == 'ALERTING' && para
      ? '#a6eb47ff'
      : param == 'ORIGINATING' && para
        ? '#61c008ff'
        : param == 'CONNECTED' && para
          ? '#097909ff'
          : '#808080';
  } else if (param == 'GPS') {
    return '#388e3c';
  } else {
    if (para == 99) {
      return '#808080';
    } else if (param == 'rsrq') {
      return para >= -3
        ? '#FF0000'
        : para >= -5 && para < -3
          ? '#FF6600'
          : para >= -7 && para < -5
            ? '#FFE600'
            : para >= -9 && para < -7
              ? '#B3FF00'
              : para >= -10 && para < -9
                ? '#33FF00'
                : para >= -11 && para < -10
                  ? '#00FF33'
                  : para >= -12 && para < -11
                    ? '#00FFB3'
                    : para >= -13 && para < -12
                      ? '#00E6FF'
                      : para >= -15 && para < -13
                        ? '#0066FF'
                        : para >= -18 && para < -15
                          ? '#0000FF'
                          : para >= -20 && para < -18
                            ? '#3800B0'
                            : para < -20
                              ? '#570070'
                              : '#570070';
    } else if (param == 'rsrp') {
      return para >= -60
        ? '#FF0000'
        : para >= -65 && para < -60
          ? '#FF4D00'
          : para >= -70 && para < -65
            ? '#FFB300'
            : para >= -75 && para < -70
              ? '#FFFF00'
              : para >= -80 && para < -75
                ? '#B3FF00'
                : para >= -85 && para < -80
                  ? '#66FF00'
                  : para >= -90 && para < -85
                    ? '#00FF00'
                    : para >= -95 && para < -90
                      ? '#00FF4D'
                      : para >= -100 && para < -95
                        ? '#00FF99'
                        : para >= -105 && para < -100
                          ? '#00FFE6'
                          : para >= -110 && para < -105
                            ? '#00B3FF'
                            : para >= -115 && para < -110
                              ? '#0066FF'
                              : para >= -120 && para < -115
                                ? '#001AFF'
                                : para >= -130 && para < -120
                                  ? '#2100E0'
                                  : para >= -140 && para < -130
                                    ? '#4000A0'
                                    : para < -140
                                      ? '#570070'
                                      : '#570070';
    } else {
      return para>-35?'#FF0000':
         para >= -35 && para < -30
          ? '#FF0000'
          : para >= -40 && para < -35
            ? '#FF9900'
            : para >= -45 && para < -40
              ? '#FF9900'
              : para >= -50 && para < -45
                ?'#FFE600' 
                : para >= -55 && para < -50
                  ? '#CCFF00'
                  : para >= -60 && para < -55
                    ? '#4DFF00'
                    : para >= -65 && para < -60
                      ? '#00FF00'
                      : para >= -70 && para < -65
                        ? '#00FF4D'
                        : para >= -75 && para < -70
                          ? '#00FF99'
                          : para >= -80 && para < -75
                            ? '#00FFE6'
                            : para >= -85 && para < -80
                              ? '#00CCFF'
                              : para >= -90 && para < -85
                                ? '#0080FF'
                                : para >= -95 && para < -90
                                  ? '#004DFF'
                                  : para >= -100 && para < -95
                                    ? '#0000FF'
                                    : para >= -105 && para < -100
                                      ? '#2900D0'
                                      : para >= -110 && para < -105
                                        ? '#4000A0'
                                        : para < -110
                                          ? '#570070'
                                          : '#570070';
    }
  }
}

setColor(param: string, para: any) {
  if (
    param == 'iperf_udp_ul_throughput' ||
    param == 'iperf_udp_dl_throughput' ||
    param == 'iperf_tcp_ul_throughput' ||
    param == 'iperf_tcp_dl_throughput'
  ) {
    return para >= 695
      ? '#FF0000'
      : para >= 483 && para < 695
        ? '#FF4900'
        : para >= 336 && para < 483
          ? '#FF8E00'
          : para >= 234 && para < 336
            ? '#FFD200'
            : para >= 162 && para < 234
              ? '#E7FF00'
              : para >= 113 && para < 162
                ? '#A2FF00'
                : para >= 78 && para < 113
                  ? '#5DFF00'
                  : para >= 55 && para < 78
                    ? '#14FF00'
                    : para >= 38 && para < 55
                      ? '#00FF30'
                      : para >= 26 && para < 38
                        ? '#00FF75'
                        : para >= 18 && para < 26
                          ? '#00FFBA'
                          : para >= 13 && para < 18
                            ? '#00FFFE'
                            : para >= 9 && para < 13
                              ? '#00BBFF'
                              : para >= 6 && para < 9
                                ? '#0071FF'
                                : para >= 4 && para < 6
                                  ? '#002DFF'
                                  : para >= 3 && para < 4
                                    ? '#1700F1'
                                    : para >= 2 && para < 3
                                      ? '#2D00C6'
                                      : para >= 1 && para < 2
                                        ? '#42009B'
                                        : para >= 0 && para < 1
                                          ? '#570070'
                                          : '#570070';
  } else if (
    param == 'iperf_udp_dl_jitter' ||
    param == 'iperf_udp_ul_jitter'
  ) {
    return para >= 75
      ? '#570070'
      : para >= 50 && para < 75
        ? '#2C00C9'
        : para >= 30 && para < 50
          ? '#0031FF'
          : para >= 20 && para < 30
            ? '#00BBFF'
            : para >= 15 && para < 20
              ? '#00FFB5'
              : para >= 10 && para < 15
                ? '#00FF2B'
                : para >= 5 && para < 10
                  ? '#5DFF00'
                  : para >= 2 && para < 5
                    ? '#EBFF00'
                    : para >= 1 && para < 2
                      ? '#FF8900'
                      : para >= 0 && para < 1
                        ? '#FF0000'
                        : '#FF0000';
  } else if (param == 'sinr') {
    return para >= 25
      ? '#FF0000'
      : para >= 20 && para < 25
        ? '#FF9C00'
        : para >= 15 && para < 20
          ? '#C4FF00'
          : para >= 10 && para < 15
            ? '#27FF00'
            : para >= 5 && para < 10
              ? '#00FF75'
              : para >= 3 && para < 5
                ? '#00ECFF'
                : para >= 0 && para < 3
                  ? '#004FFF'
                  : para >= -5 && para < 0
                    ? '#2900CF'
                    : para >= -10 && para < -5
                      ? '#570070'
                      : '#570070';
  } else if (param == 'upload' || param == 'download') {
    return para >= 695
      ? '#FF0000'
      : para >= 483 && para < 695
        ? '#FF4900'
        : para >= 336 && para < 483
          ? '#FF8E00'
          : para >= 234 && para < 336
            ? '#FFD200'
            : para >= 162 && para < 234
              ? '#E7FF00'
              : para >= 113 && para < 162
                ? '#A2FF00'
                : para >= 78 && para < 113
                  ? '#5DFF00'
                  : para >= 55 && para < 78
                    ? '#14FF00'
                    : para >= 38 && para < 55
                      ? '#00FF30'
                      : para >= 26 && para < 38
                        ? '#00FF75'
                        : para >= 18 && para < 26
                          ? '#00FFBA'
                          : para >= 13 && para < 18
                            ? '#00FFFE'
                            : para >= 9 && para < 13
                              ? '#00BBFF'
                              : para >= 6 && para < 9
                                ? '#0071FF'
                                : para >= 4 && para < 6
                                  ? '#002DFF'
                                  : para >= 3 && para < 4
                                    ? '#1700F1'
                                    : para >= 2 && para < 3
                                      ? '#2D00C6'
                                      : para >= 1 && para < 2
                                        ? '#42009B'
                                        : para >= 0 && para < 1
                                          ? '#570070'
                                          : '#570070';
  } else if (
    param == 'pkts_tx' ||
    param == 'pkts_rx' ||
    param == 'audio_jitter_std' ||
    param == 'video_jitter_std'
  ) {
    return para >= 75
      ? '#570070'
      : para >= 50 && para < 75
        ? '#2C00C9'
        : para >= 30 && para < 50
          ? '#0031FF'
          : para >= 20 && para < 30
            ? '#00BBFF'
            : para >= 15 && para < 20
              ? '#00FFB5'
              : para >= 10 && para < 15
                ? '#00FF2B'
                : para >= 5 && para < 10
                  ? '#5DFF00'
                  : para >= 2 && para < 5
                    ? '#EBFF00'
                    : para >= 1 && para < 2
                      ? '#FF8900'
                      : para >= 0 && para < 1
                        ? '#FF0000'
                        : '#FF0000';
  } else if (param == 'pkt_loss') {
    return para >= 50
      ? '#570070'
      : para >= 25 && para < 50
        ? '#3300B9'
        : para >= 15 && para < 25
          ? '#0000FF'
          : para >= 10 && para < 15
            ? '#0071FF'
            : para >= 7 && para < 10
              ? '#00E2FF'
              : para >= 5 && para < 7
                ? '#00FFAB'
                : para >= 3 && para < 5
                  ? '#00FF35'
                  : para >= 2 && para < 3
                    ? '#3BFF00'
                    : para >= 1 && para < 2
                      ? '#ACFF00'
                      : para >= 0.5 && para < 1
                        ? '#FFE100'
                        : para >= 0.1 && para < 0.5
                          ? '#FF7000'
                          : para >= 0 && para < 0.1
                            ? '#FF0000'
                            : '#FF0000';
  } else if (
    param == 'average_download_speed_mbps' ||
    param == 'bitrate' ||
    param == 'speed'
  ) {
    return para >= 695
      ? '#FF0000'
      : para >= 483 && para < 695
        ? '#FF4900'
        : para >= 336 && para < 483
          ? '#FF8E00'
          : para >= 234 && para < 336
            ? '#FFD200'
            : para >= 162 && para < 234
              ? '#E7FF00'
              : para >= 113 && para < 162
                ? '#A2FF00'
                : para >= 78 && para < 113
                  ? '#5DFF00'
                  : para >= 55 && para < 78
                    ? '#14FF00'
                    : para >= 38 && para < 55
                      ? '#00FF30'
                      : para >= 26 && para < 38
                        ? '#00FF75'
                        : para >= 18 && para < 26
                          ? '#00FFBA'
                          : para >= 13 && para < 18
                            ? '#00FFFE'
                            : para >= 9 && para < 13
                              ? '#00BBFF'
                              : para >= 6 && para < 9
                                ? '#0071FF'
                                : para >= 4 && para < 6
                                  ? '#002DFF'
                                  : para >= 3 && para < 4
                                    ? '#1700F1'
                                    : para >= 2 && para < 3
                                      ? '#2D00C6'
                                      : para >= 1 && para < 2
                                        ? '#42009B'
                                        : para >= 0 && para < 1
                                          ? '#570070'
                                          : '#570070';
  } else if (param == 'fps') {
    return para >= 45
      ? '#FF0000'
      : para >= 30 && para < 45
        ? '#FFB500'
        : para >= 24 && para < 30
          ? '#98FF00'
          : para >= 20 && para < 24
            ? '#00FF1D'
            : para >= 15 && para < 20
              ? '#00FFCD'
              : para >= 10 && para < 15
                ? '#007BFF'
                : para >= 5 && para < 10
                  ? '#2100DE'
                  : para >= 0 && para < 5
                    ? '#570070'
                    : '#570070';
  } else if (param == 'totaltime') {
    return para >= 20
      ? '#570070'
      : para >= 15 && para < 20
        ? '#2C00C9'
        : para >= 10 && para < 15
          ? '#0031FF'
          : para >= 7 && para < 10
            ? '#00BBFF'
            : para >= 5 && para < 7
              ? '#00FFB5'
              : para >= 3 && para < 5
                ? '#00FF2B'
                : para >= 2 && para < 3
                  ? '#5DFF00'
                  : para >= 1 && para < 2
                    ? '#EBFF00'
                    : para >= 0.5 && para < 1
                      ? '#FF8900'
                      : para >= 0 && para < 0.5
                        ? '#FF0000'
                        : '#FF0000';
  } else if (param == 'latency') {
    return para >= 300
      ? '#570070'
      : para >= 200 && para < 300
        ? '#3100BF'
        : para >= 150 && para < 200
          ? '#0014FF'
          : para >= 100 && para < 150
            ? '#0093FF'
            : para >= 75 && para < 100
              ? '#00FFF0'
              : para >= 50 && para < 75
                ? '#00FF70'
                : para >= 30 && para < 50
                  ? '#0AFF00'
                  : para >= 20 && para < 30
                    ? '#89FF00'
                    : para >= 10 && para < 20
                      ? '#FFF900'
                      : para >= 5 && para < 10
                        ? '#FF7A00'
                        : para >= 0 && para < 5
                          ? '#FF0000'
                          : '#FF0000';
  } else if (param == 'snr') {
    return para >= 35
      ? '#FF0000'
      : para >= 30 && para < 35
        ? '#FFB500'
        : para >= 25 && para < 30
          ? '#98FF00'
          : para >= 20 && para < 25
            ? '#00FF1D'
            : para >= 15 && para < 20
              ? '#00FFCD'
              : para >= 10 && para < 15
                ? '#007BFF'
                : para >= 5 && para < 10
                  ? '#2100DE'
                  : para >= 0 && para < 5
                    ? '#570070'
                    : '#570070';
  } else if (param == 'overall_quality_assessment') {
    return para == 'Poor'
      ? '#FF0000'
      : para == 'Fair'
        ? '#66FF00'
        : para == 'Good'
          ? '#00B3FF'
          : para == 'Excellent'
            ? '#570070'
            : '#808080';
  } else if (
    param == 'ALERTING' ||
    param == 'ORIGINATING' ||
    param == 'CONNECTED'
  ) {
    return param == 'ALERTING' && para
      ? '#a6eb47ff'
      : param == 'ORIGINATING' && para
        ? '#61c008ff'
        : param == 'CONNECTED' && para
          ? '#097909ff'
          : '#808080';
  } else if (param == 'GPS') {
    return '#388e3c';
  } else if (param == 'transfer_speed_bps' || param == 'bytes_transferred') {
    const thresholds = param == 'transfer_speed_bps'
      ? [50000000, 25000000, 15000000, 10000000, 7000000, 5000000, 3000000, 2000000, 1000000, 500000, 200000, 100000, 0]
      : [50000000, 20000000, 10000000, 5000000, 2000000, 1000000, 500000, 200000, 100000, 50000, 10000, 0];
    const colors = ['#FF0000', '#FF4900', '#FF8E00', '#FFD200', '#E7FF00', '#A2FF00', '#5DFF00', '#14FF00', '#00FF30', '#00FF75', '#00FFBA', '#00FFFE', '#570070'];
    for (let i = 0; i < thresholds.length; i++) {
      if (para >= thresholds[i]) {
        return colors[i];
      }
    }
    return '#570070';
  } else if (param == 'total_time_sec') {
    return para >= 30
      ? '#570070'
      : para >= 20 && para < 30
        ? '#2C00C9'
        : para >= 15 && para < 20
          ? '#0031FF'
          : para >= 10 && para < 15
            ? '#00BBFF'
            : para >= 7 && para < 10
              ? '#00FFB5'
              : para >= 5 && para < 7
                ? '#00FF2B'
                : para >= 3 && para < 5
                  ? '#5DFF00'
                  : para >= 2 && para < 3
                    ? '#EBFF00'
                    : para >= 0.5 && para < 2
                      ? '#FF8900'
                      : para >= 0 && para < 0.5
                        ? '#FF0000'
                        : '#FF0000';
  } else {
    if (para == 99) {
      return '#808080';
    } else if (param == 'rsrq') {
      return para >= -5
        ? '#FF0000'
        : para >= -7 && para < -5
          ? '#FF8E00'
          : para >= -9 && para < -7
            ? '#E7FF00'
            : para >= -10 && para < -9
              ? '#5DFF00'
              : para >= -11 && para < -10
                ? '#00FF30'
                : para >= -12 && para < -11
                  ? '#00FFBA'
                  : para >= -13 && para < -12
                    ? '#00BBFF'
                    : para >= -15 && para < -13
                      ? '#002DFF'
                      : para >= -18 && para < -15
                        ? '#2D00C6'
                        : para >= -20 && para < -18
                          ? '#570070'
                          : '#570070';
    } else if (param == 'rsrp') {
      return para >= -65
        ? '#FF0000'
        : para >= -70 && para < -65
          ? '#FF6200'
          : para >= -75 && para < -70
            ? '#FFC400'
            : para >= -80 && para < -75
              ? '#DDFF00'
              : para >= -85 && para < -80
                ? '#7BFF00'
                : para >= -90 && para < -85
                  ? '#19FF00'
                  : para >= -95 && para < -90
                    ? '#00FF44'
                    : para >= -100 && para < -95
                      ? '#00FFA6'
                      : para >= -105 && para < -100
                        ? '#00FAFF'
                        : para >= -110 && para < -105
                          ? '#0098FF'
                          : para >= -115 && para < -110
                            ? '#0036FF'
                            : para >= -120 && para < -115
                              ? '#1D00E7'
                              : para >= -130 && para < -120
                                ? '#3A00AA'
                                : para >= -140 && para < -130
                                  ? '#570070'
                                  : '#570070';
    } else {
      return para >= -35
        ? '#FF0000'
        : para >= -40 && para < -35
          ? '#FF5300'
          : para >= -45 && para < -40
            ? '#FFA600'
            : para >= -50 && para < -45
              ? '#FFF900'
              : para >= -55 && para < -50
                ? '#B1FF00'
                : para >= -60 && para < -55
                  ? '#5DFF00'
                  : para >= -65 && para < -60
                    ? '#0AFF00'
                    : para >= -70 && para < -65
                      ? '#00FF49'
                      : para >= -75 && para < -70
                        ? '#00FF9C'
                        : para >= -80 && para < -75
                          ? '#00FFEF'
                          : para >= -85 && para < -80
                            ? '#00BBFF'
                            : para >= -90 && para < -85
                              ? '#0067FF'
                              : para >= -95 && para < -90
                                ? '#0014FF'
                                : para >= -100 && para < -95
                                  ? '#2400D8'
                                  : para >= -105 && para < -100
                                    ? '#3D00A4'
                                    : para >= -110 && para < -105
                                      ? '#570070'
                                      : '#570070';
    }
  }
}




  colorGenerator(arr = [], keys = []) {
    const colorObj = {};
    keys.map((key) => {
      colorObj[key] = {};
    });
    arr.map((each) => {
      if (each?.color) {
        keys.map((k) => {
          colorObj[k][each.color] = 0;
        });
      }
    });
    return colorObj;
  }

  // pingColor_pkttxrx = [
  //   { value: '>= 190', color: '#00FF00' },
  //   { value: '>= 165', color: '#00FF00' },
  //   { value: '>= 150', color: '#12FF00' },
  //   { value: '>= 135', color: '#35FF00' },
  //   { value: '>= 120', color: '#58FF00' },
  //   { value: '>= 105', color: '#8DFF00' },
  //   { value: '>= 90', color: '#B0FF00' },
  //   { value: '>= 75', color: '#C2FF00' },
  //   { value: '>= 60', color: '#D4FF00' },
  //   { value: '>= 45', color: '#E5FF00' },
  //   { value: '>= 30', color: '#FF6900' },
  //   { value: '>= 15', color: '#FF4600' },
  //   { value: '>= 0', color: '#FF2300' },
  // ];

  // pingColor_pktloss = [
  //   { value: '= 100', color: ' #FF0000' },
  //   { value: '>= 90', color: ' #FF4600' },
  //   { value: '>= 80', color: ' #FF6900' },
  //   { value: '>= 70', color: ' #FFAC1C' },
  //   { value: '>= 60', color: ' #B0FF00' },
  //   { value: '>= 50', color: ' #8DFF00' },
  //   { value: '>= 40', color: ' #58FF00' },
  //   { value: '>= 30', color: ' #35FF00' },
  //   { value: '>= 20', color: ' #12FF00' },
  //   { value: '>= 10', color: ' #00FF00' },
  //   { value: '>= 0', color: ' #008000' },
  // ];
  // speed_updn = [
  //   { value: '>= 190', color: '#00FF00' },
  //   { value: '>= 165', color: '#12FF00' },
  //   { value: '>= 150', color: '#35FF00' },
  //   { value: '>= 135', color: '#58FF00' },
  //   { value: '>= 120', color: '#8DFF00' },
  //   { value: '>= 105', color: '#B0FF00' },
  //   { value: '>= 90', color: '#C2FF00' },
  //   { value: '>= 75', color: '#D4FF00' },
  //   { value: '>= 60', color: '#E5FF00' },
  //   { value: '>= 45', color: '#FF6900' },
  //   { value: '>= 30', color: '#FF4600' },
  //   { value: '>= 15', color: '#FF2300' },
  //   { value: '>= 0', color: '#FF0000' },
  // ];
  // ytube_dl = [
  //   { value: '>= 190', color: '#00FF00' },
  //   { value: '>= 165', color: '#12FF00' },
  //   { value: '>= 150', color: '#35FF00' },
  //   { value: '>= 135', color: '#58FF00' },
  //   { value: '>= 120', color: '#8DFF00' },
  //   { value: '>= 105', color: '#B0FF00' },
  //   { value: '>= 90', color: '#C2FF00' },
  //   { value: '>= 75', color: '#D4FF00' },
  //   { value: '>= 60', color: '#E5FF00' },
  //   { value: '>= 45', color: '#FF6900' },
  //   { value: '>= 30', color: '#FF4600' },
  //   { value: '>= 15', color: '#FF2300' },
  //   { value: '>= 0', color: '#FF0000' },
  // ];

  //   iperfColors = [
  //   { value: '>=220', color: '#00FF00' },
  //   { value: '>=198', color: '#12FF00' },
  //   { value: '>=180', color: '#35FF00' },
  //   { value: '>=162', color: '#58FF00' },
  //   { value: '>=144', color: '#8DFF00' },
  //   { value: '>=126', color: '#B0FF00' },
  //   { value: '>=108', color: '#C2FF00' },
  //   { value: '>=90', color: '#D4FF00' },
  //   { value: '>=72', color: '#E5FF00' },
  //   { value: '>=54', color: '#FF6900' },
  //   { value: '>=36', color: '#FF4600' },
  //   { value: '>=18', color: '#FF2300' },
  //   { value: '>=13', color: '#fd5c63' },
  //   { value: '>=8', color: '#C04000' },
  //   { value: '>=3', color: '#C41E3A' },
  //   { value: '>0', color: '#58111A' },
  //   { value: '=0', color: '#B2BEB5' },
  // ];

  // jitterColors = [
  //   { value: '>=190', color: '#FF0000' },
  //   { value: '>=165', color: '#FF2300' },
  //   { value: '>=150', color: '#FF4600' },
  //   { value: '>=135', color: '#FF6900' },
  //   { value: '>=120', color: '#E5FF00' },
  //   { value: '>=105', color: '#D4FF00' },
  //   { value: '>=90', color: '#C2FF00' },
  //   { value: '>=75', color: '#B0FF00' },
  //   { value: '>=60', color: '#8DFF00' },
  //   { value: '>=45', color: '#58FF00' },
  //   { value: '>=30', color: '#35FF00' },
  //   { value: '>=15', color: '#12FF00' },
  //   { value: '>=0', color: '#00FF00' },
  // ];

  // rssiColorArray = [
  //   { value: '>-30.00', color: '#B2FFFF' },
  //   { value: '>-35.00', color: '#7FFFD4' },
  //   { value: '>-40.00', color: '#89CFF0' },
  //   { value: '>-45.00', color: '#6699CC' },
  //   { value: '>-50.00', color: '#318CE7' },
  //   { value: '>-55.00', color: '#5072A7' },
  //   { value: '>-60.00', color: '#e1bee7' },
  //   { value: '>-65.00', color: '#e040fb' },
  //   { value: '>-70.00', color: '#e57373' },
  //   { value: '>-75.00', color: '#8e24aa' },
  //   { value: '>-80.00', color: '#00e676' },
  //   { value: '>-85.00', color: '#afb42b' },
  //   { value: '>-90.00', color: '#388e3c' },
  //   { value: '>-95.00', color: '#1b5e20' },
  //   { value: '>-100.00', color: '#eeff41' },
  //   { value: '>-105.00', color: '#ef6c00' },
  //   { value: '>-110.00', color: '#ff3d00' },
  //   { value: '<= -110.00', color: '#132257' },
  // ];

  // rsrqColorArray = [
  //   { value: '>=0.00', color: '#FF4500' },
  //   { value: '>-5.00', color: '#32CD32' },
  //   { value: '>-10.00', color: '#8B0000' },
  //   { value: '>-15.00', color: '#FFD700' },
  //   { value: '>-20.00', color: '#00CED1' },
  //   { value: '>-25.00', color: '#FF1493' },
  //   { value: '>-30.00', color: '#B2FFFF' },
  //   { value: '>-35.00', color: '#7FFFD4' },
  //   { value: '>-40.00', color: '#89CFF0' },
  //   { value: '>-45.00', color: '#6699CC' },
  //   { value: '>-50.00', color: '#318CE7' },
  //   { value: '>-55.00', color: '#5072A7' },
  //   { value: '>-60.00', color: '#e1bee7' },
  //   { value: '>-65.00', color: '#e040fb' },
  //   { value: '>-70.00', color: '#e57373' },
  //   { value: '>-75.00', color: '#8e24aa' },
  //   { value: '>-80.00', color: '#00e676' },
  //   { value: '>-85.00', color: '#afb42b' },
  //   { value: '>-90.00', color: '#388e3c' },
  //   { value: '>-95.00', color: '#1b5e20' },
  //   { value: '>-100.00', color: '#eeff41' },
  //   { value: '>-105.00', color: '#ef6c00' },
  //   { value: '>-110.00', color: '#ff3d00' },
  //   { value: '<= -110.00', color: '#132257' },
  // ];

  // sinrColorArray = [
  //   { value: '>=30', color: '#0d47a1' },
  //   { value: '<30 & >=25', color: '#388e3c' },
  //   { value: '<25 & >=20', color: '#76ff03' },
  //   { value: '<20 & >=15', color: '#ffff00' },
  //   { value: '<15 & >=10', color: '#ff9800' },
  //   { value: '<10 & >=5', color: '#ff3d00' },
  //   { value: '<5 & >=3', color: '#bdbdbd' },
  //   { value: '<3 ', color: '#616161' },
  // ];



  // bitrateColorArray = [
  //   { value: '>=190', color: '#00FF00' },
  //   { value: '>=165', color: '#12FF00' },
  //   { value: '>=150', color: '#35FF00' },
  //   { value: '>=135', color: '#58FF00' },
  //   { value: '>=120', color: '#8DFF00' },
  //   { value: '>=105', color: '#B0FF00' },
  //   { value: '>=90', color: '#C2FF00' },
  //   { value: '>=75', color: '#D4FF00' },
  //   { value: '>=60', color: '#E5FF00' },
  //   { value: '>=45', color: '#FF6900' },
  //   { value: '>=30', color: '#FF4600' },
  //   { value: '>=15', color: '#FF2300' },
  //   { value: '>=0', color: '#FF0000' },
  // ];

  // fpsColorArray = [
  //   { value: '>=190', color: '#00FF00' },
  //   { value: '>=165', color: '#12FF00' },
  //   { value: '>=150', color: '#35FF00' },
  //   { value: '>=135', color: '#58FF00' },
  //   { value: '>=120', color: '#8DFF00' },
  //   { value: '>=105', color: '#B0FF00' },
  //   { value: '>=90', color: '#C2FF00' },
  //   { value: '>=75', color: '#D4FF00' },
  //   { value: '>=60', color: '#E5FF00' },
  //   { value: '>=45', color: '#FF6900' },
  //   { value: '>=30', color: '#FF4600' },
  //   { value: '>=15', color: '#FF2300' },
  //   { value: '>=0', color: '#FF0000' },
  // ];

  // speedColorArray = [
  //   { value: '>=190', color: '#00FF00' },
  //   { value: '>=165', color: '#12FF00' },
  //   { value: '>=150', color: '#35FF00' },
  //   { value: '>=135', color: '#58FF00' },
  //   { value: '>=120', color: '#8DFF00' },
  //   { value: '>=105', color: '#B0FF00' },
  //   { value: '>=90', color: '#C2FF00' },
  //   { value: '>=75', color: '#D4FF00' },
  //   { value: '>=60', color: '#E5FF00' },
  //   { value: '>=45', color: '#FF6900' },
  //   { value: '>=30', color: '#FF4600' },
  //   { value: '>=15', color: '#FF2300' },
  //   { value: '>=0', color: '#FF0000' },
  // ];

  // call_ColorArray = [
  //   { value: 'Alerted', color: '#a6eb47ff' },
  //   { value: 'Dialed', color: '#61c008ff' },
  //   { value: 'Responded', color: '#097909ff' },
  // ];

  gpsColorArray = [{ value: 'GPS', color: '#388e3c' }];


  //   yube_qlty = [
  //   { value: 'Poor', color: '#FF2300' },
  //   { value: 'Fair', color: '#E5FF00' },
  //   { value: 'Good', color: '#8DFF00' },
  //   { value: 'Excellent', color: '#00FF00' },
  // ];

  // audio_jitter = [
  //   { value: '>=190', color: '#FF0000' },
  //   { value: '>=165', color: '#FF2300' },
  //   { value: '>=150', color: '#FF4600' },
  //   { value: '>=135', color: '#FF6900' },
  //   { value: '>=120', color: '#E5FF00' },
  //   { value: '>=105', color: '#D4FF00' },
  //   { value: '>=90', color: '#C2FF00' },
  //   { value: '>=75', color: '#B0FF00' },
  //   { value: '>=60', color: '#8DFF00' },
  //   { value: '>=45', color: '#58FF00' },
  //   { value: '>=30', color: '#35FF00' },
  //   { value: '>=15', color: '#12FF00' },
  //   { value: '>=0', color: '#00FF00' },
  // ];

  // video_jitter = [
  //   { value: '>=190', color: '#FF0000' },
  //   { value: '>=165', color: '#FF2300' },
  //   { value: '>=150', color: '#FF4600' },
  //   { value: '>=135', color: '#FF6900' },
  //   { value: '>=120', color: '#E5FF00' },
  //   { value: '>=105', color: '#D4FF00' },
  //   { value: '>=90', color: '#C2FF00' },
  //   { value: '>=75', color: '#B0FF00' },
  //   { value: '>=60', color: '#8DFF00' },
  //   { value: '>=45', color: '#58FF00' },
  //   { value: '>=30', color: '#35FF00' },
  //   { value: '>=15', color: '#12FF00' },
  //   { value: '>=0', color: '#00FF00' },
  // ];

    // ── Color arrays based on setColor3 ──

  // For: iperf_udp_ul_throughput, iperf_udp_dl_throughput,
  //      iperf_tcp_ul_throughput, iperf_tcp_dl_throughput,
  //      upload, download,
  //      average_download_speed_mbps, bitrate, speed


    // ── Color arrays generated via generateColorRangeArray (source of truth: setColor) ──

  iperfColors = this.generateColorRangeArray(
    [1000, 695, 483, 336, 234, 162, 113, 78, 55, 38, 26, 18, 13, 9, 6, 4, 3, 2, 1, 0],
    (val) => this.setColor('iperf_udp_ul_throughput', val)
  );
  // iperfColors = [
  //   { value: '>= 1000', color: '#FF0000' },
  //   { value: '>= 695', color: '#FF3300' },
  //   { value: '>= 483', color: '#FF8000' },
  //   { value: '>= 336', color: '#FFB300' },
  //   { value: '>= 234', color: '#FFFF00' },
  //   { value: '>= 162', color: '#CCFF00' },
  //   { value: '>= 113', color: '#80FF00' },
  //   { value: '>= 78', color: '#4DFF00' },
  //   { value: '>= 55', color: '#00FF00' },
  //   { value: '>= 38', color: '#00FF33' },
  //   { value: '>= 26', color: '#00FF80' },
  //   { value: '>= 18', color: '#00FFB3' },
  //   { value: '>= 13', color: '#00FFE6' },
  //   { value: '>= 9', color: '#00CCFF' },
  //   { value: '>= 6', color: '#0099FF' },
  //   { value: '>= 4', color: '#004DFF' },
  //   { value: '>= 3', color: '#001AFF' },
  //   { value: '>= 2', color: '#2100E0' },
  //   { value: '>= 1', color: '#3100C0' },
  //   { value: '>= 0', color: '#470090' },
  //   { value: '< 0', color: '#570070' },
  // ];

  bitrateColorArray = this.generateColorRangeArray(
    [1000, 695, 483, 336, 234, 162, 113, 78, 55, 38, 26, 18, 13, 9, 6, 4, 3, 2, 1, 0],
    (val) => this.setColor('bitrate', val)
  );
  // bitrateColorArray = [
  //   { value: '>= 1000', color: '#FF0000' },
  //   { value: '>= 695', color: '#FF3300' },
  //   { value: '>= 483', color: '#FF8000' },
  //   { value: '>= 336', color: '#FFB300' },
  //   { value: '>= 234', color: '#FFFF00' },
  //   { value: '>= 162', color: '#CCFF00' },
  //   { value: '>= 113', color: '#80FF00' },
  //   { value: '>= 78', color: '#4DFF00' },
  //   { value: '>= 55', color: '#00FF00' },
  //   { value: '>= 38', color: '#00FF33' },
  //   { value: '>= 26', color: '#00FF80' },
  //   { value: '>= 18', color: '#00FFB3' },
  //   { value: '>= 13', color: '#00FFE6' },
  //   { value: '>= 9', color: '#00CCFF' },
  //   { value: '>= 6', color: '#0099FF' },
  //   { value: '>= 4', color: '#004DFF' },
  //   { value: '>= 3', color: '#001AFF' },
  //   { value: '>= 2', color: '#2100E0' },
  //   { value: '>= 1', color: '#3100C0' },
  //   { value: '>= 0', color: '#470090' },
  //   { value: '< 0', color: '#570070' },
  // ];

  speedColorArray = this.generateColorRangeArray(
    [1000, 695, 483, 336, 234, 162, 113, 78, 55, 38, 26, 18, 13, 9, 6, 4, 3, 2, 1, 0],
    (val) => this.setColor('speed', val)
  );
  // speedColorArray = [
  //   { value: '>= 1000', color: '#FF0000' },
  //   { value: '>= 695', color: '#FF3300' },
  //   { value: '>= 483', color: '#FF8000' },
  //   { value: '>= 336', color: '#FFB300' },
  //   { value: '>= 234', color: '#FFFF00' },
  //   { value: '>= 162', color: '#CCFF00' },
  //   { value: '>= 113', color: '#80FF00' },
  //   { value: '>= 78', color: '#4DFF00' },
  //   { value: '>= 55', color: '#00FF00' },
  //   { value: '>= 38', color: '#00FF33' },
  //   { value: '>= 26', color: '#00FF80' },
  //   { value: '>= 18', color: '#00FFB3' },
  //   { value: '>= 13', color: '#00FFE6' },
  //   { value: '>= 9', color: '#00CCFF' },
  //   { value: '>= 6', color: '#0099FF' },
  //   { value: '>= 4', color: '#004DFF' },
  //   { value: '>= 3', color: '#001AFF' },
  //   { value: '>= 2', color: '#2100E0' },
  //   { value: '>= 1', color: '#3100C0' },
  //   { value: '>= 0', color: '#470090' },
  //   { value: '< 0', color: '#570070' },
  // ];

  ytube_dl = this.generateColorRangeArray(
    [1000, 695, 483, 336, 234, 162, 113, 78, 55, 38, 26, 18, 13, 9, 6, 4, 3, 2, 1, 0],
    (val) => this.setColor('average_download_speed_mbps', val)
  );
  // ytube_dl = [
  //   { value: '>= 1000', color: '#FF0000' },
  //   { value: '>= 695', color: '#FF3300' },
  //   { value: '>= 483', color: '#FF8000' },
  //   { value: '>= 336', color: '#FFB300' },
  //   { value: '>= 234', color: '#FFFF00' },
  //   { value: '>= 162', color: '#CCFF00' },
  //   { value: '>= 113', color: '#80FF00' },
  //   { value: '>= 78', color: '#4DFF00' },
  //   { value: '>= 55', color: '#00FF00' },
  //   { value: '>= 38', color: '#00FF33' },
  //   { value: '>= 26', color: '#00FF80' },
  //   { value: '>= 18', color: '#00FFB3' },
  //   { value: '>= 13', color: '#00FFE6' },
  //   { value: '>= 9', color: '#00CCFF' },
  //   { value: '>= 6', color: '#0099FF' },
  //   { value: '>= 4', color: '#004DFF' },
  //   { value: '>= 3', color: '#001AFF' },
  //   { value: '>= 2', color: '#2100E0' },
  //   { value: '>= 1', color: '#3100C0' },
  //   { value: '>= 0', color: '#470090' },
  //   { value: '< 0', color: '#570070' },
  // ];

  speed_updn = this.generateColorRangeArray(
    [1000, 695, 483, 336, 234, 162, 113, 78, 55, 38, 26, 18, 13, 9, 6, 4, 3, 2, 1, 0],
    (val) => this.setColor('upload', val)
  );
  // speed_updn = [
  //   { value: '>= 1000', color: '#FF0000' },
  //   { value: '>= 695', color: '#FF3300' },
  //   { value: '>= 483', color: '#FF8000' },
  //   { value: '>= 336', color: '#FFB300' },
  //   { value: '>= 234', color: '#FFFF00' },
  //   { value: '>= 162', color: '#CCFF00' },
  //   { value: '>= 113', color: '#80FF00' },
  //   { value: '>= 78', color: '#4DFF00' },
  //   { value: '>= 55', color: '#00FF00' },
  //   { value: '>= 38', color: '#00FF33' },
  //   { value: '>= 26', color: '#00FF80' },
  //   { value: '>= 18', color: '#00FFB3' },
  //   { value: '>= 13', color: '#00FFE6' },
  //   { value: '>= 9', color: '#00CCFF' },
  //   { value: '>= 6', color: '#0099FF' },
  //   { value: '>= 4', color: '#004DFF' },
  //   { value: '>= 3', color: '#001AFF' },
  //   { value: '>= 2', color: '#2100E0' },
  //   { value: '>= 1', color: '#3100C0' },
  //   { value: '>= 0', color: '#470090' },
  //   { value: '< 0', color: '#570070' },
  // ];

  jitterColors = this.generateColorRangeArray(
    [100, 75, 50, 30, 20, 15, 10, 5, 2, 1, 0],
    (val) => this.setColor('iperf_udp_dl_jitter', val)
  );
  // jitterColors = [
  //   { value: '>= 100', color: '#570070' },
  //   { value: '>= 75', color: '#3800B0' },
  //   { value: '>= 50', color: '#0000FF' },
  //   { value: '>= 30', color: '#0066FF' },
  //   { value: '>= 20', color: '#00E6FF' },
  //   { value: '>= 15', color: '#00FFB3' },
  //   { value: '>= 10', color: '#00FF33' },
  //   { value: '>= 5', color: '#33FF00' },
  //   { value: '>= 2', color: '#B3FF00' },
  //   { value: '>= 1', color: '#FFE600' },
  //   { value: '>= 0', color: '#FF6600' },
  //   { value: '< 0', color: '#FF0000' },
  // ];

  pingColor_pkttxrx = this.generateColorRangeArray(
    [100, 75, 50, 30, 20, 15, 10, 5, 2, 1, 0],
    (val) => this.setColor('pkts_tx', val)
  );
  // pingColor_pkttxrx = [
  //   { value: '>= 100', color: '#FF0000' },
  //   { value: '>= 75', color: '#FF6600' },
  //   { value: '>= 50', color: '#FFE600' },
  //   { value: '>= 30', color: '#B3FF00' },
  //   { value: '>= 20', color: '#33FF00' },
  //   { value: '>= 15', color: '#00FF33' },
  //   { value: '>= 10', color: '#00FFB3' },
  //   { value: '>= 5', color: '#00E6FF' },
  //   { value: '>= 2', color: '#0066FF' },
  //   { value: '>= 1', color: '#0000FF' },
  //   { value: '>= 0', color: '#3800B0' },
  //   { value: '< 0', color: '#570070' },
  // ];

  audio_jitter = this.generateColorRangeArray(
    [100, 75, 50, 30, 20, 15, 10, 5, 2, 1, 0],
    (val) => this.setColor('audio_jitter_std', val)
  );
  // audio_jitter = [
  //   { value: '>= 100', color: '#570070' },
  //   { value: '>= 75', color: '#3800B0' },
  //   { value: '>= 50', color: '#0000FF' },
  //   { value: '>= 30', color: '#0066FF' },
  //   { value: '>= 20', color: '#00E6FF' },
  //   { value: '>= 15', color: '#00FFB3' },
  //   { value: '>= 10', color: '#00FF33' },
  //   { value: '>= 5', color: '#33FF00' },
  //   { value: '>= 2', color: '#B3FF00' },
  //   { value: '>= 1', color: '#FFE600' },
  //   { value: '>= 0', color: '#FF6600' },
  //   { value: '< 0', color: '#FF0000' },
  // ];

  video_jitter = this.generateColorRangeArray(
    [100, 75, 50, 30, 20, 15, 10, 5, 2, 1, 0],
    (val) => this.setColor('video_jitter_std', val)
  );
  // video_jitter = [
  //   { value: '>= 100', color: '#570070' },
  //   { value: '>= 75', color: '#3800B0' },
  //   { value: '>= 50', color: '#0000FF' },
  //   { value: '>= 30', color: '#0066FF' },
  //   { value: '>= 20', color: '#00E6FF' },
  //   { value: '>= 15', color: '#00FFB3' },
  //   { value: '>= 10', color: '#00FF33' },
  //   { value: '>= 5', color: '#33FF00' },
  //   { value: '>= 2', color: '#B3FF00' },
  //   { value: '>= 1', color: '#FFE600' },
  //   { value: '>= 0', color: '#FF6600' },
  //   { value: '< 0', color: '#FF0000' },
  // ];

  pingColor_pktloss = this.generateColorRangeArray(
    [100, 50, 25, 15, 10, 7, 5, 3, 2, 1, 0.5, 0.1, 0],
    (val) => this.setColor('pkt_loss', val)
  );
  // pingColor_pktloss = [
  //   { value: '>= 100', color: '#570070' },
  //   { value: '>= 50', color: '#3800B0' },
  //   { value: '>= 25', color: '#1900F0' },
  //   { value: '>= 15', color: '#0033FF' },
  //   { value: '>= 10', color: '#0099FF' },
  //   { value: '>= 7', color: '#00FFFF' },
  //   { value: '>= 5', color: '#00FF99' },
  //   { value: '>= 3', color: '#00FF4D' },
  //   { value: '>= 2', color: '#1AFF00' },
  //   { value: '>= 1', color: '#80FF00' },
  //   { value: '>= 0.5', color: '#E6FF00' },
  //   { value: '>= 0.1', color: '#FFCC00' },
  //   { value: '>= 0', color: '#FF0000' },
  //   { value: '< 0', color: '#FF0000' },
  // ];

  fpsColorArray = this.generateColorRangeArray(
    [60, 45, 30, 24, 20, 15, 10, 5, 0],
    (val) => this.setColor('fps', val)
  );
  // fpsColorArray = [
  //   { value: '>= 60', color: '#FF0000' },
  //   { value: '>= 45', color: '#FF8000' },
  //   { value: '>= 30', color: '#E6FF00' },
  //   { value: '>= 24', color: '#66FF00' },
  //   { value: '>= 20', color: '#00FF33' },
  //   { value: '>= 15', color: '#00FFB3' },
  //   { value: '>= 10', color: '#00B3FF' },
  //   { value: '>= 5', color: '#0033FF' },
  //   { value: '>= 0', color: '#3100C0' },
  //   { value: '< 0', color: '#570070' },
  // ];

  totaltimeColors3 = this.generateColorRangeArray(
    [30, 20, 15, 10, 7, 5, 3, 2, 1, 0.5, 0],
    (val) => this.setColor('totaltime', val)
  );
  // totaltimeColors3 = [
  //   { value: '>= 30', color: '#FF0000' },
  //   { value: '>= 20', color: '#FF6600' },
  //   { value: '>= 15', color: '#FFE600' },
  //   { value: '>= 10', color: '#B3FF00' },
  //   { value: '>= 7', color: '#33FF00' },
  //   { value: '>= 5', color: '#00FF33' },
  //   { value: '>= 3', color: '#00FFB3' },
  //   { value: '>= 2', color: '#00E6FF' },
  //   { value: '>= 1', color: '#0066FF' },
  //   { value: '>= 0.5', color: '#0000FF' },
  //   { value: '>= 0', color: '#3800B0' },
  //   { value: '< 0', color: '#570070' },
  // ];

  transferSpeedColorArray = this.generateColorRangeArray(
    [50000000, 25000000, 15000000, 10000000, 7000000, 5000000, 3000000, 2000000, 1000000, 500000, 200000, 100000, 0],
    (val) => this.setColor('transfer_speed_bps', val)
  );

  bytesTransferredColorArray = this.generateColorRangeArray(
    [50000000, 20000000, 10000000, 5000000, 2000000, 1000000, 500000, 200000, 100000, 50000, 10000, 0],
    (val) => this.setColor('bytes_transferred', val)
  );

  ftpTotalTimeColorArray = this.generateColorRangeArray(
    [30, 20, 15, 10, 7, 5, 3, 2, 1, 0.5, 0],
    (val) => this.setColor('total_time_sec', val)
  );

  latencyColors3 = this.generateColorRangeArray(
    [500, 300, 200, 150, 100, 75, 50, 30, 20, 10, 5, 0],
    (val) => this.setColor('latency', val)
  );
  // latencyColors3 = [
  //   { value: '>= 500', color: '#FF0000' },
  //   { value: '>= 300', color: '#FF6600' },
  //   { value: '>= 200', color: '#FFCC00' },
  //   { value: '>= 150', color: '#CCFF00' },
  //   { value: '>= 100', color: '#66FF00' },
  //   { value: '>= 75', color: '#00FF00' },
  //   { value: '>= 50', color: '#00FF80' },
  //   { value: '>= 30', color: '#00FFE6' },
  //   { value: '>= 20', color: '#00B3FF' },
  //   { value: '>= 10', color: '#004DFF' },
  //   { value: '>= 5', color: '#1900F0' },
  //   { value: '>= 0', color: '#3800B0' },
  //   { value: '< 0', color: '#570070' },
  // ];

  snrColors3 = this.generateColorRangeArray(
    [40, 35, 30, 25, 20, 15, 10, 5, 0],
    (val) => this.setColor('snr', val)
  );
  // snrColors3 = [
  //   { value: '>= 40', color: '#570070' },
  //   { value: '>= 35', color: '#3100C0' },
  //   { value: '>= 30', color: '#0033FF' },
  //   { value: '>= 25', color: '#00B3FF' },
  //   { value: '>= 20', color: '#00FFB3' },
  //   { value: '>= 15', color: '#00FF33' },
  //   { value: '>= 10', color: '#66FF00' },
  //   { value: '>= 5', color: '#E6FF00' },
  //   { value: '>= 0', color: '#FF8000' },
  //   { value: '< 0', color: '#FF0000' },
  // ];

  yube_qlty = [
    { value: 'Excellent', color: this.setColor('overall_quality_assessment', 'Excellent') },
    { value: 'Good', color: this.setColor('overall_quality_assessment', 'Good') },
    { value: 'Fair', color: this.setColor('overall_quality_assessment', 'Fair') },
    { value: 'Poor', color: this.setColor('overall_quality_assessment', 'Poor') },
  ];
  // yube_qlty = [
  //   { value: 'Excellent', color: '#570070' },
  //   { value: 'Good', color: '#00B3FF' },
  //   { value: 'Fair', color: '#66FF00' },
  //   { value: 'Poor', color: '#FF0000' },
  // ];

  call_ColorArray = [
    { value: 'Alerted', color: this.setColor('ALERTING', true) },
    { value: 'Dialed', color: this.setColor('ORIGINATING', true) },
    { value: 'Responded', color: this.setColor('CONNECTED', true) },
  ];
  // call_ColorArray = [
  //   { value: 'Alerted', color: '#a6eb47ff' },
  //   { value: 'Dialed', color: '#61c008ff' },
  //   { value: 'Responded', color: '#097909ff' },
  // ];

  gpsColorArray3 = [
    { value: 'GPS', color: this.setColor('GPS', true) },
  ];
  // gpsColorArray3 = [
  //   { value: 'GPS', color: '#388e3c' },
  // ];

  sinrColorArray = this.generateColorRangeArray(
    [30, 25, 20, 15, 10, 5, 3, 0, -5, -10],
    (val) => this.setColor('sinr', val)
  );
  // sinrColorArray = [
  //   { value: '>= 30', color: '#FF0000' },
  //   { value: '>= 25', color: '#FF8000' },
  //   { value: '>= 20', color: '#FFFF00' },
  //   { value: '>= 15', color: '#80FF00' },
  //   { value: '>= 10', color: '#00FF00' },
  //   { value: '>= 5', color: '#00FF80' },
  //   { value: '>= 3', color: '#00FFE6' },
  //   { value: '>= 0', color: '#0099FF' },
  //   { value: '>= -5', color: '#001AFF' },
  //   { value: '>= -10', color: '#3100C0' },
  //   { value: '< -10', color: '#570070' },
  // ];

  rsrqColorArray = this.generateColorRangeArray(
    [-3, -5, -7, -9, -10, -11, -12, -13, -15, -18, -20],
    (val) => this.setColor('rsrq', val)
  );
  // rsrqColorArray = [
  //   { value: '>= -3', color: '#FF0000' },
  //   { value: '>= -5', color: '#FF6600' },
  //   { value: '>= -7', color: '#FFE600' },
  //   { value: '>= -9', color: '#B3FF00' },
  //   { value: '>= -10', color: '#33FF00' },
  //   { value: '>= -11', color: '#00FF33' },
  //   { value: '>= -12', color: '#00FFB3' },
  //   { value: '>= -13', color: '#00E6FF' },
  //   { value: '>= -15', color: '#0066FF' },
  //   { value: '>= -18', color: '#0000FF' },
  //   { value: '>= -20', color: '#3800B0' },
  //   { value: '< -20', color: '#570070' },
  // ];

  rsrpColorArray3 = this.generateColorRangeArray(
    [-60, -65, -70, -75, -80, -85, -90, -95, -100, -105, -110, -115, -120, -130, -140],
    (val) => this.setColor('rsrp', val)
  );
  // rsrpColorArray3 = [
  //   { value: '>= -60', color: '#FF0000' },
  //   { value: '>= -65', color: '#FF4D00' },
  //   { value: '>= -70', color: '#FFB300' },
  //   { value: '>= -75', color: '#FFFF00' },
  //   { value: '>= -80', color: '#B3FF00' },
  //   { value: '>= -85', color: '#66FF00' },
  //   { value: '>= -90', color: '#00FF00' },
  //   { value: '>= -95', color: '#00FF4D' },
  //   { value: '>= -100', color: '#00FF99' },
  //   { value: '>= -105', color: '#00FFE6' },
  //   { value: '>= -110', color: '#00B3FF' },
  //   { value: '>= -115', color: '#0066FF' },
  //   { value: '>= -120', color: '#001AFF' },
  //   { value: '>= -130', color: '#2100E0' },
  //   { value: '>= -140', color: '#4000A0' },
  //   { value: '< -140', color: '#570070' },
  // ];

  rssiColorArray = this.generateColorRangeArray(
    [-35, -40, -45, -50, -55, -60, -65, -70, -75, -80, -85, -90, -95, -100, -105, -110],
    (val) => this.setColor('rssi', val)
  );
  // rssiColorArray = [
  //   { value: '>= -35', color: '#FF0000' },
  //   { value: '>= -40', color: '#FF9900' },
  //   { value: '>= -45', color: '#FF9900' },
  //   { value: '>= -50', color: '#FFE600' },
  //   { value: '>= -55', color: '#CCFF00' },
  //   { value: '>= -60', color: '#4DFF00' },
  //   { value: '>= -65', color: '#00FF00' },
  //   { value: '>= -70', color: '#00FF4D' },
  //   { value: '>= -75', color: '#00FF99' },
  //   { value: '>= -80', color: '#00FFE6' },
  //   { value: '>= -85', color: '#00CCFF' },
  //   { value: '>= -90', color: '#0080FF' },
  //   { value: '>= -95', color: '#004DFF' },
  //   { value: '>= -100', color: '#0000FF' },
  //   { value: '>= -105', color: '#2900D0' },
  //   { value: '>= -110', color: '#4000A0' },
  //   { value: '< -110', color: '#570070' },
  // ];



  generateColorRangeArray(
    thresholds: number[],
    colorFn: (value: number) => string
  ): { value: string; color: string }[] {
    const result = thresholds.map(t => ({
      value: `>= ${t}`,
      color: colorFn(t),
    }));

    const last = thresholds[thresholds.length - 1];
    const tailColor = colorFn(last - 1);

    if (tailColor === result[result.length - 1].color) {
      // >= last and < last map to the same color — merge them into a single
      // "< prevThreshold" entry so the range boundary stays accurate.
      result.pop();
      const prevThreshold = thresholds[thresholds.length - 2];
      result.push({
        value: prevThreshold !== undefined ? `< ${prevThreshold}` : `< ${last}`,
        color: tailColor,
      });
    } else {
      result.push({ value: `< ${last}`, color: tailColor });
    }

    // For consecutive same-color entries keep the LAST one (lowest threshold)
    // so the label correctly shows where the color band begins, not where it ends.
    return result.filter((entry, i) =>
      i === result.length - 1 || entry.color !== result[i + 1].color
    );
  }




  testparamTypeMap: any = {};
  allowedCellular: any = {};
  allowedWifi: any = {};
  testtypeParameterMaps: any = {};
  testWiseAllParameters: any = {
    //testname order matters fist is continuous and second is single
    RF: [
      {
        id: 1,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'rssi',
        value: 'rssi',
        name: 'RSSI',
        param: 'rssi',
        searchKey: 'rssi',
        type: 'rf',
        testName: ['continuous', '3_min'],
        dname: 'RF',
        catagory: 'RF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 2,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'rsrp',
        value: 'rsrp',
        name: 'RSRP',
        param: 'rsrp',
        searchKey: 'rsrp',
        type: 'rf',
        testName: ['continuous', '3_min'],
        dname: 'RF',
        catagory: 'RF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 3,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'rsrq',
        value: 'rsrq',
        name: 'RSRQ',
        param: 'rsrq',
        searchKey: 'rsrq',
        type: 'rf',
        testName: ['continuous', '3_min'],
        dname: 'RF',
        catagory: 'RF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 4,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'sinr',
        value: 'sinr',
        name: 'SINR',
        param: 'sinr',
        searchKey: 'sinr',
        type: 'rf',
        testName: ['continuous', '3_min'],
        dname: 'RF',
        catagory: 'RF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
    ],
    IPERF: [
      {
        id: 5,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'rssi',
        value: 'rssi',
        name: 'RSSI',
        param: 'rssi',
        searchKey: 'rssi',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'
          // ,'iperftest_continuous', 'iperftest'
        ],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 6,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'rsrp',
        value: 'rsrp',
        name: 'RSRP',
        param: 'rsrp',
        searchKey: 'rsrp',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'
          // ,'iperftest_continuous', 'iperftest'
        ],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 7,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'rsrq',
        value: 'rsrq',
        name: 'RSRQ',
        param: 'rsrq',
        searchKey: 'rsrq',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'
          // ,'iperftest_continuous', 'iperftest'
        ],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 8,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'sinr',
        value: 'sinr',
        name: 'SINR',
        param: 'sinr',
        searchKey: 'sinr',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'
          // ,'iperftest_continuous', 'iperftest'
        ],
        dname: 'IPERF',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 9,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'tcp_ul',
        value: 'iperf_tcp_ul_throughput',
        name: 'TCP UL',
        param: 'iperf_tcp_ul_throughput',
        searchKey: 'tcp_ul',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'
          // ,'iperftest_continuous', 'iperftest'
        ],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 10,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'tcp_dl',
        value: 'iperf_tcp_dl_throughput',
        name: 'TCP DL',
        param: 'iperf_tcp_dl_throughput',
        searchKey: 'tcp_dl',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'
          // ,'iperftest_continuous', 'iperftest'
        ],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 11,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'udp_ul',
        value: 'iperf_udp_ul_throughput',
        name: 'UDP UL',
        param: 'iperf_udp_ul_throughput',
        searchKey: 'udp_ul',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'
          // ,'iperftest_continuous', 'iperftest'
        ],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 12,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'udp_dl',
        value: 'iperf_udp_dl_throughput',
        name: 'UDP DL',
        param: 'iperf_udp_dl_throughput',
        searchKey: 'udp_dl',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'
          // ,'iperftest_continuous', 'iperftest'
        ],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 13,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'ul_jitter',
        value: 'iperf_udp_ul_jitter',
        name: 'UL JITTER',
        param: 'iperf_udp_ul_jitter',
        searchKey: 'ul_jitter',
        type: 'iperf',
              testName: ['iperf_continuous', 'iperf'
          // ,'iperftest_continuous', 'iperftest'
        ],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 14,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'dl_jitter',
        value: 'iperf_udp_dl_jitter',
        name: 'DL JITTER',
        param: 'iperf_udp_dl_jitter',
        searchKey: 'dl_jitter',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'
          // ,'iperftest_continuous', 'iperftest'
        ],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
    ],
    Youtube: [
      {
        id: 15,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'average_download_speed_mbps',
        value: 'average_download_speed_mbps',
        name: 'Average Download Speed',
        param: 'average_download_speed_mbps',
        searchKey: 'average_download_speed_mbps',
        type: 'ytube',
        catagory: 'Youtube Test',
        testName: ['ytube_continuous', 'ytube'],
        dname: 'Youtube',
        testtype: 'application',
        allowed: { cellular: true },
      },
    ],
    'Wget Curl': [
      {
        id: 16,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'totaltime',
        value: 'totaltime',
        name: 'Total Time',
        param: 'totaltime',
        searchKey: 'curltest_total_time',
        type: 'curl',
        catagory: 'Wget URL Test',
        testName: ['curl_continuous', 'curl'],
        dname: 'Wget Curl',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
    ],
    'Speed Test': [
      {
        id: 17,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'download',
        value: 'download',
        name: 'Download Speed',
        param: 'download',
        searchKey: 'speedtest_download',
        type: 'sptest',
        catagory: 'Speed Test',
        testName: ['sptest_continuous', 'sptest'],
        dname: 'Speed Test',
        testtype: 'application',
        allowed: { cellular: true },
      },
      {
        id: 18,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'upload',
        value: 'upload',
        name: 'Upload Speed',
        param: 'upload',
        searchKey: 'speedtest_upload',
        type: 'sptest',
        catagory: 'Speed Test',
        testName: ['sptest_continuous', 'sptest'],
        dname: 'Speed Test',
        testtype: 'application',
        allowed: { cellular: true },
      },
    ],
    'Ping Test': [
      {
        id: 19,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'pkt_loss',
        value: 'pkt_loss',
        name: 'Packet Loss',
        param: 'pkt_loss',
        searchKey: 'pkt_loss',
        type: 'ping',
        catagory: 'Ping Test',
        testName: ['ping_continuous', 'ping'],
        dname: 'Ping Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
    ],
    'IPERF Test': [
      {
        id: 36,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'rssi',
        value: 'rssi',
        name: 'RSSI',
        param: 'rssi',
        searchKey: 'rssi',
        type: 'iperftest',
        catagory: 'IPERF Test',
        testName: ['iperftest_continuous', 'iperftest'],
        dname: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 37,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'rsrp',
        value: 'rsrp',
        name: 'RSRP',
        param: 'rsrp',
        searchKey: 'rsrp',
        type: 'iperftest',
        catagory: 'IPERF Test',
        testName: ['iperftest_continuous', 'iperftest'],
        dname: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 38,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'rsrq',
        value: 'rsrq',
        name: 'RSRQ',
        param: 'rsrq',
        searchKey: 'rsrq',
        type: 'iperftest',
        catagory: 'IPERF Test',
        testName: ['iperftest_continuous', 'iperftest'],
        dname: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 39,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'sinr',
        value: 'sinr',
        name: 'SINR',
        param: 'sinr',
        searchKey: 'sinr',
        type: 'iperftest',
        catagory: 'IPERF Test',
        testName: ['iperftest_continuous', 'iperftest'],
        dname: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 40,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'tcp_ul',
        value: 'iperf_tcp_ul_throughput',
        name: 'TCP UL',
        param: 'iperf_tcp_ul_throughput',
        searchKey: 'tcp_ul',
        type: 'iperftest',
        catagory: 'IPERF Test',
        testName: ['iperftest_continuous', 'iperftest'],
        dname: 'IPERF Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 41,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'tcp_dl',
        value: 'iperf_tcp_dl_throughput',
        name: 'TCP DL',
        param: 'iperf_tcp_dl_throughput',
        searchKey: 'tcp_dl',
        type: 'iperftest',
        catagory: 'IPERF Test',
        testName: ['iperftest_continuous', 'iperftest'],
        dname: 'IPERF Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 42,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'udp_ul',
        value: 'iperf_udp_ul_throughput',
        name: 'UDP UL',
        param: 'iperf_udp_ul_throughput',
        searchKey: 'udp_ul',
        type: 'iperftest',
        catagory: 'IPERF Test',
        testName: ['iperftest_continuous', 'iperftest'],
        dname: 'IPERF Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 43,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'udp_dl',
        value: 'iperf_udp_dl_throughput',
        name: 'UDP DL',
        param: 'iperf_udp_dl_throughput',
        searchKey: 'udp_dl',
        type: 'iperftest',
        catagory: 'IPERF Test',
        testName: ['iperftest_continuous', 'iperftest'],
        dname: 'IPERF Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 44,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'ul_jitter',
        value: 'iperf_udp_ul_jitter',
        name: 'UL JITTER',
        param: 'iperf_udp_ul_jitter',
        searchKey: 'ul_jitter',
        type: 'iperftest',
        catagory: 'IPERF Test',
        testName: ['iperftest_continuous', 'iperftest'],
        dname: 'IPERF Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 45,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'dl_jitter',
        value: 'iperf_udp_dl_jitter',
        name: 'DL JITTER',
        param: 'iperf_udp_dl_jitter',
        searchKey: 'dl_jitter',
        type: 'iperftest',
        catagory: 'IPERF Test',
        testName: ['iperftest_continuous', 'iperftest'],
        dname: 'IPERF Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
    ],
    'Video Single': [
      {
        id: 20,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'bitrate',
        value: 'bitrate',
        name: 'Bitrate',
        param: 'bitrate',
        searchKey: 'bitrate',
        type: 'video',
        catagory: 'Video Test',
        testName: ['video_continuous', 'video_single'],
        dname: 'Video Single',
        testtype: 'cellular',
        allowed: { cellular: true },
      },
      {
        id: 21,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'fps',
        value: 'fps',
        name: 'Framerate',
        param: 'fps',
        searchKey: 'fps',
        type: 'video',
        catagory: 'Video Test',
        testName: ['video_continuous', 'video_single'],
        dname: 'Video Single',
        testtype: 'cellular',
        allowed: { cellular: true },
      },
      {
        id: 22,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'speed',
        value: 'speed',
        name: 'Speed',
        param: 'speed',
        searchKey: 'speed',
        type: 'video',
        catagory: 'Video Test',
        testName: ['video_continuous', 'video_single'],
        dname: 'Video Single',
        testtype: 'cellular',
        allowed: { cellular: true },
      },
      {
        id: 23,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'audio_jitter',
        value: 'audio_jitter_std',
        name: 'Audio Jitter',
        param: 'audio_jitter_std',
        searchKey: 'audio_jitter_std',
        type: 'video',
        catagory: 'Video Test',
        testName: ['video_continuous', 'video_single'],
        dname: 'Video Single',
        testtype: 'cellular',
        allowed: { cellular: true },
      },
      {
        id: 24,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'video_jitter',
        value: 'video_jitter_std',
        name: 'Video Jitter',
        param: 'video_jitter_std',
        searchKey: 'video_jitter_std',
        type: 'video',
        catagory: 'Video Test',
        testName: ['video_continuous', 'video_single'],
        dname: 'Video Single',
        testtype: 'cellular',
        allowed: { cellular: true },
      },
    ],
    Call: [
      {
        id: 26,
        value: 'ORIGINATING',
        allowedType: { wifi: true, cell: true },
        rangeValue: 'ORIGINATING',
        bypassRange: true,
        name: 'Dialed',
        param: 'ORIGINATING',
        searchKey: 'ORIGINATING',
        type: 'call',
        catagory: 'Call Test',
        testName: ['dialnumber_continuous', 'dialnumber'],
        alias: ['call_continuous', 'call'],
        dname: 'Call',
        testtype: 'application',
        allowed: { cellular: true },
      },
      {
        id: 25,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'ALERTING',
        bypassRange: true,
        value: 'ALERTING',
        name: 'Alerted',
        param: 'ALERTING',
        searchKey: 'ALERTING',
        type: 'call',
        catagory: 'Call Test',
        testName: ['dialnumber_continuous', 'dialnumber'],
        alias: ['call_continuous', 'call'],
        dname: 'Call',
        testtype: 'application',
        allowed: { cellular: true },
      },

      {
        id: 27,
        value: 'CONNECTED',
        allowedType: { wifi: true, cell: true },
        rangeValue: 'CONNECTED',
        bypassRange: true,
        name: 'Responded',
        param: 'CONNECTED',
        searchKey: 'CONNECTED',
        type: 'call',
        catagory: 'Call Test',
        testName: ['dialnumber_continuous', 'dialnumber'],
        alias: ['call_continuous', 'call'],
        dname: 'Call',
        testtype: 'application',
        allowed: { cellular: true },
      },
    ],
    'Fast Gps': [
      {
        id: 28,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'GPS',
        bypassRange: true,
        value: 'GPS',
        name: 'GPS',
        param: 'GPS',
        searchKey: 'GPS',
        type: 'gnss',
        catagory: 'Fast Gps',
        testName: ['gnss_continuous', 'gnss'],
        dname: 'Fast Gps',
        testtype: 'application',
        allowed: { cellular: true },
      },
    ],
    'RRC State': [
      {
        id: 29,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'rrc_param',
        bypassRange: true,
        value: 'rrc_param',
        name: 'RRC State',
        param: 'rrc_param',
        searchKey: 'rrc_param',
        type: 'rrc',
        catagory: 'RRC State',
        testName: ['rrc_state_continuous', 'rrc_state'],
        dname: 'RRC State',
        testtype: 'application',
        allowed: { cellular: true },
      },
    ],
    'FTP Test': [
      {
        id: 30,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'bytes_transferred',
        value: 'bytes_transferred',
        name: 'Bytes Transferred',
        param: 'bytes_transferred',
        searchKey: 'bytes_transferred',
        // The walktestreport summary endpoint now exposes this under an ftptest_-prefixed key
        // (with precomputed _min/_max) to disambiguate from Wget Post Test, which shares the
        // same unprefixed field name. searchKey stays unprefixed since it still matches the
        // raw per-notification reportfilter keys used by the FTP-range fallback.
        summaryKey: 'ftptest_bytes_transferred',
        type: 'ftp',
        catagory: 'FTP Test',
        testName: ['ftp_continuous', 'ftp'],
        alias: ['ftptest_continuous', 'ftptest'],
        dname: 'FTP Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 31,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'transfer_speed_bps',
        value: 'transfer_speed_bps',
        name: 'Transfer Speed (bps)',
        param: 'transfer_speed_bps',
        searchKey: 'transfer_speed_bps',
        summaryKey: 'ftptest_transfer_speed_bps',
        type: 'ftp',
        catagory: 'FTP Test',
        testName: ['ftp_continuous', 'ftp'],
        alias: ['ftptest_continuous', 'ftptest'],
        dname: 'FTP Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 32,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'total_time_sec',
        value: 'total_time_sec',
        name: 'Total Time (s)',
        param: 'total_time_sec',
        searchKey: 'total_time_sec',
        summaryKey: 'ftptest_total_time_sec',
        type: 'ftp',
        catagory: 'FTP Test',
        testName: ['ftp_continuous', 'ftp'],
        alias: ['ftptest_continuous', 'ftptest'],
        dname: 'FTP Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      // {
      //   id: 33,
      //   allowedType: { wifi: true, cell: true },
      //   rangeValue: 'time_to_connect_sec',
      //   value: 'time_to_connect_sec',
      //   name: 'Time to Connect (s)',
      //   param: 'time_to_connect_sec',
      //   searchKey: 'time_to_connect_sec',
      //   type: 'ftp',
      //   catagory: 'FTP Test',
      //   testName: ['ftp_continuous', 'ftp'],
      //   alias: ['ftptest_continuous', 'ftptest'],
      //   dname: 'FTP Test',
      //   testtype: 'application',
      //   allowed: { wifi: true, cellular: true },
      // },
      // {
      //   id: 34,
      //   allowedType: { wifi: true, cell: true },
      //   rangeValue: 'time_to_first_byte_sec',
      //   value: 'time_to_first_byte_sec',
      //   name: 'Time to First Byte (s)',
      //   param: 'time_to_first_byte_sec',
      //   searchKey: 'time_to_first_byte_sec',
      //   type: 'ftp',
      //   catagory: 'FTP Test',
      //   testName: ['ftp_continuous', 'ftp'],
      //   alias: ['ftptest_continuous', 'ftptest'],
      //   dname: 'FTP Test',
      //   testtype: 'application',
      //   allowed: { wifi: true, cellular: true },
      // },
      // {
      //   id: 35,
      //   allowedType: { wifi: true, cell: true },
      //   rangeValue: 'connections_made',
      //   value: 'connections_made',
      //   name: 'Connections Made',
      //   param: 'connections_made',
      //   searchKey: 'connections_made',
      //   type: 'ftp',
      //   catagory: 'FTP Test',
      //   testName: ['ftp_continuous', 'ftp'],
      //   alias: ['ftptest_continuous', 'ftptest'],
      //   dname: 'FTP Test',
      //   testtype: 'application',
      //   allowed: { wifi: true, cellular: true },
      // },
    ],
    'Wget Post Test': [
      {
        id: 47,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'bytes_transferred',
        value: 'bytes_transferred',
        name: 'Bytes Transferred',
        param: 'bytes_transferred',
        searchKey: 'bytes_transferred',
        type: 'wget_post',
        catagory: 'Wget Post Test',
        testName: ['wget_post_continuous', 'wget_post'],
        alias: ['wgetposttest_continuous', 'wgetposttest'],
        dname: 'Wget Post Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 48,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'transfer_speed_bps',
        value: 'transfer_speed_bps',
        name: 'Transfer Speed (bps)',
        param: 'transfer_speed_bps',
        searchKey: 'transfer_speed_bps',
        type: 'wget_post',
        catagory: 'Wget Post Test',
        testName: ['wget_post_continuous', 'wget_post'],
        alias: ['wgetposttest_continuous', 'wgetposttest'],
        dname: 'Wget Post Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 49,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'total_time_sec',
        value: 'total_time_sec',
        name: 'Total Time (s)',
        param: 'total_time_sec',
        searchKey: 'total_time_sec',
        type: 'wget_post',
        catagory: 'Wget Post Test',
        testName: ['wget_post_continuous', 'wget_post'],
        alias: ['wgetposttest_continuous', 'wgetposttest'],
        dname: 'Wget Post Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 50,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'time_to_connect_sec',
        value: 'time_to_connect_sec',
        name: 'Time to Connect (s)',
        param: 'time_to_connect_sec',
        searchKey: 'time_to_connect_sec',
        type: 'wget_post',
        catagory: 'Wget Post Test',
        testName: ['wget_post_continuous', 'wget_post'],
        alias: ['wgetposttest_continuous', 'wgetposttest'],
        dname: 'Wget Post Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 51,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'time_to_first_byte_sec',
        value: 'time_to_first_byte_sec',
        name: 'Time to First Byte (s)',
        param: 'time_to_first_byte_sec',
        searchKey: 'time_to_first_byte_sec',
        type: 'wget_post',
        catagory: 'Wget Post Test',
        testName: ['wget_post_continuous', 'wget_post'],
        alias: ['wgetposttest_continuous', 'wgetposttest'],
        dname: 'Wget Post Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 52,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'connections_made',
        value: 'connections_made',
        name: 'Connections Made',
        param: 'connections_made',
        searchKey: 'connections_made',
        type: 'wget_post',
        catagory: 'Wget Post Test',
        testName: ['wget_post_continuous', 'wget_post'],
        alias: ['wgetposttest_continuous', 'wgetposttest'],
        dname: 'Wget Post Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
    ],
    'IW Event': [
      {
        id: 46,
        allowedType: { wifi: true, cell: false },
        rangeValue: 'message',
        bypassRange: true,
        value: 'message',
        name: 'IW Event',
        param: 'message',
        searchKey: 'message',
        type: 'iwevent',
        catagory: 'IW Event',
        testName: ['iwevent_continuous', 'iwevent'],
        dname: 'IW Event',
        testtype: 'application',
        allowed: { wifi: true },
      },
    ],
  };

  childPopupNameMapping = {
    rf: {
      val: 'rf-pindrop',
      type: 'PINRF',
      displayName: 'RF Configurations',
      parameter: '3_min',
      testname: 'RF Pindrop',
      catagory: 'RF',
      userDisplayname: 'RF (Pindrop)',
      parameter_other: undefined,
    },
    rfc: {
      val: 'rf-continuous',
      type: 'RF',
      displayName: 'RF Configurations',
      parameter: 'continuous',
      testname: 'RF Continuous',
      catagory: 'RF',
      userDisplayname: 'RF (Continuous)',
      parameter_other: undefined,
    },
    iperf: {
      val: 'iperf-pindrop',
      type: 'PINIPERF',
      displayName: 'IPERF Configurations:',
      parameter: 'iperf',
      testname: 'IPERF Pindrop',
      catagory: 'IPERF',
      userDisplayname: 'IPERF (Pindrop)',
      parameter_other: undefined,
    },
    iperfc: {
      val: 'iperf-continuous',
      type: 'IPERF',
      displayName: 'IPERF Configurations:',
      parameter: 'iperf_continuous',
      testname: 'IPERF Continuous',
      catagory: 'IPERF',
      userDisplayname: 'IPERF (Continuous)',
      parameter_other: undefined,
    },
    iperftest: {
      val: 'iperftest-pindrop',
      type: 'PINIPERFTEST',
      displayName: 'IPERF Configurations:',
      parameter: 'iperftest',
      testname: 'IPERF Test Pindrop',
      catagory: 'IPERF',
      userDisplayname: 'Multi IPERF(Pindrop)',
      parameter_other: undefined,
    },
    iperftestc: {
      val: 'iperftest-continuous',
      type: 'IPERFTEST',
      displayName: 'IPERF Configurations:',
      parameter: 'iperftest_continuous',
      testname: 'IPERF Test Continuous',
      catagory: 'IPERF',
      userDisplayname: 'Multi IPERF(Continuous)',
      parameter_other: undefined,
    },
    ping: {
      val: 'ping',
      type: 'PING',
      displayName: 'Ping Configurations',
      parameter: 'ping',
      testname: 'Ping Test',
      catagory: 'PING',
      userDisplayname: 'Ping (Pindrop)',
      parameter_other: undefined,
    },
    pingc: {
      val: 'ping-continuous',
      type: 'PINGCONTI',
      displayName: 'Ping Configurations',
      parameter: 'ping_continuous',
      testname: 'Ping Continuous',
      catagory: 'PING',
      userDisplayname: 'Ping (Continuous)',
      parameter_other: undefined,
    },
    curl: {
      val: 'curl',
      type: 'CURL',
      displayName: 'Wget Url Configurations',
      parameter: 'curl',
      testname: 'Curl Test',
      catagory: 'CURL',
      userDisplayname: 'Url Get (Pindrop)',
      parameter_other: undefined,
    },
    curlc: {
      val: 'curl-continuous',
      type: 'CURLCONTI',
      displayName: 'Wget Url Configurations',
      parameter: 'curl_continuous',
      testname: 'Curl Continuous',
      catagory: 'CURL',
      userDisplayname: 'Url Get (Continuous)',
      parameter_other: undefined,
    },
    ytube: {
      val: 'youtube-pindrop',
      type: 'PINYOUTUBE',
      displayName: 'Youtube Configurations',
      parameter: 'ytube',
      testname: 'Youtube Pindrop',
      catagory: 'YOUTUBE',
      userDisplayname: 'Youtube (Pindrop)',
      parameter_other: undefined,
    },
    ytubec: {
      val: 'youtube-continuous',
      type: 'YOUTUBE',
      displayName: 'Youtube Configurations',
      parameter: 'ytube_continuous',
      testname: 'Youtube Continuous',
      catagory: 'YOUTUBE',
      userDisplayname: 'Youtube (Continuous)',
      parameter_other: undefined,
    },
    speed: {
      val: 'speed',
      type: 'SPEED',
      displayName: 'Speed Test Configurations',
      parameter: 'sptest',
      testname: 'Speed',
      catagory: 'SPEED',
      userDisplayname: 'Speed (Pindrop)',
      parameter_other: undefined,
    },
    speedc: {
      val: 'speed-continuous',
      type: 'SPEEDCONTI',
      displayName: 'Speed Test Configurations',
      parameter: 'sptest_continuous',
      testname: 'Speed Continuous',
      catagory: 'SPEED',
      userDisplayname: 'Speed (Continuous)',
      parameter_other: undefined,
    },
    video: {
      val: 'video_single',
      type: 'VIDEO',
      displayName: 'Video Test Configurations',
      parameter: 'video_single',
      testname: 'Video',
      catagory: 'VIDEO',
      userDisplayname: 'Video (Pindrop)',
      parameter_other: undefined,
    },
    videoc: {
      val: 'video-continuous',
      type: 'VIDEOCONTI',
      displayName: 'Video Test Configurations',
      parameter: 'video_continuous',
      testname: 'Video Continuous',
      catagory: 'VIDEO',
      userDisplayname: 'Video (Continuous)',
      parameter_other: undefined,
    },
    call: {
      val: 'call',
      type: 'CALL',
      displayName: 'Call Setup Configurations',
      parameter: 'call',
      testname: 'Call',
      catagory: 'CALL',
      userDisplayname: 'Call setup (Pindrop)',
      parameter_other: 'dialnumber',
    },
    callc: {
      val: 'call-continuous',
      type: 'CALLCONTI',
      displayName: 'Call Setup Configurations',
      parameter: 'call_continuous',
      testname: 'Call Continuous',
      catagory: 'CALL',
      userDisplayname: 'Call setup (Continuous)',
      parameter_other: 'dialnumber_continuous',
    },
    rrc: {
      val: 'rrc-single',
      type: 'RRC',
      displayName: 'RRC State Configurations',
      parameter: 'rrc_state',
      testname: 'RRC Single',
      catagory: 'RRC',
      userDisplayname: 'RRC State (Pindrop)',
      parameter_other: undefined,
    },
    rrcc: {
      val: 'rrc-continuous',
      type: 'RRCCONTI',
      displayName: 'RRC State Configurations',
      parameter: 'rrc_state_continuous',
      testname: 'RRC Continuous',
      catagory: 'RRC',
      userDisplayname: 'RRC State (Continuous)',
      parameter_other: undefined,
    },
    gnss: {
      val: 'gnss',
      type: 'GNSS',
      displayName: 'GNSS Configurations',
      parameter: 'gnss',
      testname: 'GNSS Single',
      catagory: 'GNSS',
      userDisplayname: 'Fast Gps (Pindrop)',
      parameter_other: undefined,
    },
    gnssc: {
      val: 'gnss-continuous',
      type: 'GNSSCONTI',
      displayName: 'GNSS Configurations',
      parameter: 'gnss_continuous',
      testname: 'GNSS Continuous',
      catagory: 'GNSS',
      userDisplayname: 'Fast Gps (Continuous)',
      parameter_other: undefined,
    },
    ftp: {
      val: 'ftp',
      type: 'FTP',
      displayName: 'FTP Test Configurations',
      parameter: 'ftp',
      testname: 'FTP Test',
      catagory: 'FTP',
      userDisplayname: 'FTP (Pindrop)',
      parameter_other: 'ftptest',
    },
    ftpc: {
      val: 'ftp-continuous',
      type: 'FTPCONTI',
      displayName: 'FTP Test Configurations',
      parameter: 'ftp_continuous',
      testname: 'FTP Continuous',
      catagory: 'FTP',
      userDisplayname: 'FTP (Continuous)',
      parameter_other: 'ftptest_continuous',
    },
    wgetpost: {
      val: 'wget-post',
      type: 'WGETPOST',
      displayName: 'Wget Post Test Configurations',
      parameter: 'wget_post',
      testname: 'Wget Post Test',
      catagory: 'Wget Post',
      userDisplayname: 'Url post (Pindrop)',
      parameter_other: 'wgetposttest',
    },
    wgetpostc: {
      val: 'wget-post-continuous',
      type: 'WGETPOSTCONTI',
      displayName: 'Wget Post Test Configurations',
      parameter: 'wget_post_continuous',
      testname: 'Wget Post Continuous',
      catagory: 'Wget Post',
      userDisplayname: 'Url Post (Continuous)',
      parameter_other: 'wgetposttest_continuous',
    },
    securitytest: {
      val: 'security-continuous',
      type: 'SECURITY',
      displayName: 'Security Test',
      parameter: 'securitytest',
      testname: 'Security Single',
      catagory: 'SECURITY',
      userDisplayname: 'Security Single',
      parameter_other: undefined,
    },
    security_continuous: {
      val: 'security-continuous',
      type: 'SECURITY',
      displayName: 'Security Test',
      parameter: 'securitytest_continuous',
      testname: 'Security Continuous',
      catagory: 'SECURITY',
      userDisplayname: 'Security Continuous',
      parameter_other: undefined,
    },
    security_single: {
      val: 'security-single',
      type: 'SECURITY_SINGLE',
      displayName: 'Security Test',
      parameter: 'security_single',
      testname: 'Security Single',
      catagory: 'SECURITY',
      userDisplayname: 'Security Single',
      parameter_other: undefined,
    },
  };

  allTestMappngDragdrop: any = {};
  testDisplayNames: any = {};
  // rule_id -> display name override for curl rules whose method is POST (mutated in place, never reassigned)
  ruleTestTypeNameMap: { [ruleId: string]: string } = {};

  // Display name for a test type; curl tests whose condition method is POST get the POST names
  getTestDisplayName(type: string, method?: string): string {
    if (type === 'curl' || type === 'curl_continuous') {
      const verb = method == 'POST' ? 'POST' : 'GET';
      return `Url ${verb} (${type === 'curl' ? 'Pindrop' : 'Continuous'})`;
    }
    return this.testDisplayNames?.[type];
  }
  testtype;
  createAllTestsMapping() {
    const allTestsMapping: any = {};
    const allTestMappngDragdrop: any = {};
    const othernamesMaps: any = {};
    const typeMapping: any = {};
    Object.entries(this.childPopupNameMapping).forEach(([key, value]) => {
      const {
        type,
        testname,
        parameter,
        catagory,
        userDisplayname,
        parameter_other,
      } = value;
      allTestsMapping[type] = {
        name: type,
        value: testname,
        param: key,
        type: parameter,
        dname: userDisplayname,
      };

      allTestMappngDragdrop[key] = {
        name: type,
        value: testname,
        param: key,
        catagory: catagory,
      };

      if (parameter_other) {
        othernamesMaps[parameter_other] = userDisplayname;
      }
      if (parameter) {
        othernamesMaps[parameter] = userDisplayname;
      }

      typeMapping[type] = parameter;
    });
    this.allTestMappngDragdrop = allTestMappngDragdrop;
    this.allTestsMapping = allTestsMapping;
    othernamesMaps['curl_post'] = 'Url Post (Pindrop)';
    othernamesMaps['curl_continuous_post'] = 'Url Post (Continuous)';
    this.testDisplayNames = othernamesMaps;
    typeMapping['security_single'] = 'security_single';
    typeMapping['security_continuous'] = 'securitytest';
    this.typeMapping = typeMapping;
    console.log(
      'allTestsMapping',
      allTestsMapping,
      othernamesMaps,
      typeMapping,
      allTestMappngDragdrop,
    );
  }


      //   {
      //   id: 30,
      //   allowedType: { wifi: true, cell: true },
      //   rangeValue: 'bytes_transferred',
      //   value: 'bytes_transferred',
      //   name: 'Bytes Transferred',
      //   param: 'bytes_transferred',
      //   searchKey: 'bytes_transferred',
      //   type: 'ftp',
      //   catagory: 'FTP Test',
      //   testName: ['ftp_continuous', 'ftp'],
      //   dname: 'FTP Test',
      //   testtype: 'application',
      //   allowed: { wifi: true, cellular: true },
      // }

  generateAvailableTests() {
    for (let each in this.testWiseAllParameters) {
      let tests = this.testWiseAllParameters?.[each]?.[0];
      // Built once per category (not inside the testName/alias blocks below) so that a test
      // like FTP - whose real ui_testtype is its alias, not testName (see updatePayloadData) -
      // can still register these under its alias key further down.
      let conti = [];
      let single = [];
      this.testWiseAllParameters?.[each].map((parameter: any) => {
        conti.push({
          value: parameter?.value,
          name: parameter?.name,
          id: parameter?.id,
          dispname: `Continuous (${parameter?.dname})`,
        });
        single.push({
          value: parameter?.value,
          name: parameter?.name,
          id: parameter?.id,
          dispname: `Pin drop (${parameter?.dname})`,
        });
      });
      if (tests?.allowed?.cellular) {
        this.allowedCellular[tests?.dname] = true;
      }
      if (tests?.allowed?.wifi) {
        this.allowedWifi[tests?.dname] = true;
      }
      if (tests?.testName) {
        console.log(tests?.othernames);
        this.continuoustests[tests?.testName?.[0]] =
          tests?.othernames?.[tests?.testName?.[0]] || tests?.testName?.[0];
        this.singletests[tests?.testName?.[1]] =
          tests?.othernames?.[tests?.testName?.[1]] || tests?.testName?.[1];
        if (tests?.testtype == 'application') {
          if (tests?.testName?.[0]) {
            this.applicationscontinuous[tests?.testName?.[0]] =
              tests?.othernames?.[tests?.testName?.[0]] || tests?.testName?.[0];
          }

          if (tests?.testName?.[1]) {
            this.applicationsingle[tests?.testName?.[1]] =
              tests?.othernames?.[tests?.testName?.[1]] || tests?.testName?.[1];
          }
        }

        this.testtypeParameterMaps[tests?.testName?.[0]] = conti;
        this.testtypeParameterMaps[tests?.testName?.[1]] = single;

        tests?.testName.map((t) => {
          this.allAvailableTestTypes.push({
            name: t,
            dname: tests?.dname,
            type: tests?.type,
          });
          this.walktesttypeMapping[t] = {
            name: tests?.catagory,
            value: tests?.type,
            id: tests?.id,
            param: t,
            dname: tests?.dname,
          }; //csv
          this.testparamTypeMap[t] = tests?.type;
        });
      }
      if (tests?.alias) {
        //this will handle if we have given some other name
        if (tests?.alias?.[0]) {
          this.applicationscontinuous[tests?.alias?.[0]] = tests?.alias?.[0];
          this.continuoustests[tests?.alias?.[0]] = tests?.alias?.[0];
        }

        if (tests?.alias?.[1]) {
          this.applicationsingle[tests?.alias?.[1]] = tests?.alias?.[1];
          this.singletests[tests?.alias?.[1]] = tests?.alias?.[1];
        }

        // Some tests (e.g. FTP, Wget Post) are posted with the alias as the actual
        // ui_testtype rather than testName (see updatePayloadData), so the alias also
        // needs to resolve to a test category/type - otherwise notifications for these
        // tests never match a conducted test type or testparamTypeMap entry.
        this.testtypeParameterMaps[tests?.alias?.[0]] = conti;
        this.testtypeParameterMaps[tests?.alias?.[1]] = single;

        tests?.alias.map((t) => {
          this.allAvailableTestTypes.push({
            name: t,
            dname: tests?.dname,
            type: tests?.type,
          });
          this.walktesttypeMapping[t] = {
            name: tests?.catagory,
            value: tests?.type,
            id: tests?.id,
            param: t,
            dname: tests?.dname,
          };
          this.testparamTypeMap[t] = tests?.type;
        });
      }
    }
    console.log(
      this.testWiseAllParameters,
      this.allAvailableTestTypes,
      this.testparamTypeMap,
    );
    // Security tests are not in testWiseAllParameters; register their ui_testtype values so the
    // start/stop tracking flow (handleStartTesProcess, handleIncomingEvents, statusConversion, etc.)
    // treats them the same as other continuous/single tests.
    this.continuoustests['securitytest_continuous'] = 'securitytest_continuous';
    this.singletests['securitytest'] = 'securitytest';
    this.allAvailableTestTypes.push(
      { name: 'securitytest_continuous', dname: 'Security Test', type: 'SECURITY' },
      { name: 'securitytest', dname: 'Security Test', type: 'SECURITY' },
    );
  }

  updatePayloadData(
    data: any,
    type: any,
    modem: any,
    modemParametersMapping: any,
  ) {

    console.log(this.singletests, type,this.continuoustests, type);
    if (this.singletests?.[type]) {
      data.test_duration = 'single';
      data.ui_testtype =
        type == 'call' ? 'dialnumber':type=='ftp'?"ftptest":type=='wget_post'?"curl":type=='security_continuous'?"securitytest": this.singletests?.[type];
    }

    if (this.continuoustests?.[type]) {
      data.test_duration = 'continuous';
      data.ui_testtype =
        type == 'call_continuous'
          ? 'dialnumber_continuous'
          :type=='ftp_continuous'?"ftptest_continuous"
          :type=='wget_post_continuous'?"curl_continuous"
          : this.continuoustests?.[type];
    }
    if (type === 'securitytest') {
      data.test_duration = 'continuous';
      data.ui_testtype = 'securitytest_continuous';
    }
    if (type === 'security_single') {
      data.test_duration = 'single';
      data.ui_testtype = 'securitytest';
    }

    if (this.applicationscontinuous?.[type] || this.applicationsingle?.[type]) {
      data.condition.type = 'application';
    }

    if (type == 'iperf' || type == 'iperf_continuous'
         || type == 'iperftest' || type == 'iperftest_continuous'
         ||type == 'ftp' || type == 'ftp-continuous' ||
         type == 'ftp_continuous'||type == 'sptest' ||
         type == 'sptest_continuous') {
      data['test_id'] =
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'test_id'
        ];
    }

    if (type == 'ftp' || type == 'ftp-continuous' || type == 'ftp_continuous') {
      if (!data.test_duration) data.test_duration = type == 'ftp' ? 'single' : 'continuous';
      if (!data.ui_testtype) data.ui_testtype = 'ftptest';
      data.walktesttype = data.ui_testtype || 'ftptest';
      data.condition.type = 'application';
    }

    if (type == 'wget_post' || type == 'wget-post-continuous' || type == 'wget_post_continuous') {
      const isSingle = type == 'wget_post';
      if (!data.test_duration) data.test_duration = isSingle ? 'single' : 'continuous';
      if (!data.ui_testtype) data.ui_testtype = isSingle ? 'curl' : 'curl_continuous';
      data.walktesttype = data.ui_testtype || (isSingle ? 'curl' : 'curl_continuous');
      data.condition.type = 'application';
    }

    return data;
  }

  getCorrectUrl(url:any, port:any){
    if(!url)return;
    
    if(url=="Default Auto"){
      return undefined;
    }else{
      if(port){
        return `${url}:${port}`
      }else{
        return url
      }
    }
  }

  parameters(
    type: string,
    modem: any,
    modemParametersMapping: any,
    currentSyncValue: any,
    defaultParameter = { value: undefined },
    mac?:any
  ) {
    console.log(type, 'ppppppppppppppp');

    if (type == 'continuous') {
      if (
        modemParametersMapping?.[modem][this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        defaultParameter.value = 'rssi';
      } else {
        defaultParameter.value = 'rsrp';
      }
      let output = {
        rfsts: true,
        start_after:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'start_after'
          ] || 0,
        stop_after:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'stop_after'
          ] || 0,
        sync_after: currentSyncValue,
        scaninfo:
          modemParametersMapping?.[modem]?.['IPERF'] ||
          modemParametersMapping?.[modem]?.['PINIPERF'] ||
          modemParametersMapping?.[modem]?.['IPERFTEST'] ||
          modemParametersMapping?.[modem]?.['PINIPERFTEST'] ||
          modemParametersMapping?.[modem]?.['CURL'] ||
          modemParametersMapping?.[modem]?.['CURLCONTI'] ||
          modemParametersMapping?.[modem]?.['YOUTUBE'] ||
          modemParametersMapping?.[modem]?.['PINYOUTUBE'] ||
          modemParametersMapping?.[modem]?.['PING'] ||
          modemParametersMapping?.[modem]?.['PINGCONTI'] ||
          modemParametersMapping?.[modem]?.['SPEED'] ||
          modemParametersMapping?.[modem]?.['SPEEDCONTI']
            ? false
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'radio_continuous'
              ],
        serveinfo:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'serving_continuous'
          ],
        neighbour_scan:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'neighbour_scan'
          ] || false,
      };
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
          output['mac_number'] = mac;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }

      return output;
    } else if (type == '3_min') {
      defaultParameter.value = 'rsrp';
      let output = {
        rfsts: true,
        sync_after: currentSyncValue,
        scaninfo:
          modemParametersMapping?.[modem]?.['IPERF'] ||
          modemParametersMapping?.[modem]?.['PINIPERF'] ||
          modemParametersMapping?.[modem]?.['IPERFTEST'] ||
          modemParametersMapping?.[modem]?.['PINIPERFTEST'] ||
          modemParametersMapping?.[modem]?.['CURL'] ||
          modemParametersMapping?.[modem]?.['CURLCONTI'] ||
          modemParametersMapping?.[modem]?.['YOUTUBE'] ||
          modemParametersMapping?.[modem]?.['PINYOUTUBE'] ||
          modemParametersMapping?.[modem]?.['PING'] ||
          modemParametersMapping?.[modem]?.['PINGCONTI'] ||
          modemParametersMapping?.[modem]?.['SPEED'] ||
          modemParametersMapping?.[modem]?.['SPEEDCONTI']
            ? false
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'radio_pindrop'
              ],
        serveinfo:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'serving_pindrop'
          ],
        neighbour_scan:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'neighbour_scan'
          ] || false,
      };
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
          output['mac_number'] = mac;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }

      return output;
    } else if (type == 'iperf' || type == 'iperf_continuous' || type == 'iperftest' || type == 'iperftest_continuous') {
      const output: any = {
        duration:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'duration_continuous'
          ] ||
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'duration_pindrop'
          ],

        with_ping:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'with_ping'
          ] || false,
        sync_after: currentSyncValue,
        server:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'server'
          ]?.['address'],
        url:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'server'
          ]?.['address'],
        interface:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ],
        ip_v: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'ipv4'
        ]
          ? 4
          : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'ipv6'
              ]
            ? 6
            : 4,
        port: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'server'
        ]?.['port'],
        ip: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'ipv4'
        ]
          ? modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'server'
            ]?.['ip']
          : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'server'
            ]?.['ip6'],
      };

      if (type == 'iperf_continuous' || type == 'iperftest_continuous') {
        output['start_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'start_after'
          ] || 0;
        output['stop_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'stop_after'
          ] || 0;
      }

      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] != 'WiFi'
      ) {
        output['acceleration'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'acc'
          ] == 'yes'
            ? true
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                  'acc'
                ] == 'no'
              ? false
              : modemParametersMapping?.[modem]?.[
                  this.testTypeMapping?.[type]
                ]?.['acceleration'];
      }

      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
          output['mac_number'] = mac;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'ping_size'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ping_size'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'ping_size'
          ];
      }

      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'tcp_upload'
        ] ||
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'tcp_download'
        ]
      ) {
        if (
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'window'
          ]
        ) {
          output['window'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'window'
            ];
          output['tcp_sw_unit'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'window_unit'
            ];
        }
        if (defaultParameter?.value != 'rsrp') {
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'tcp_upload'
          ]
            ? (defaultParameter.value = 'iperf_tcp_ul_throughput')
            : (defaultParameter.value = 'iperf_tcp_dl_throughput');
        }

        output['TCP'] = {
          direction:
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'tcp_upload'
            ] &&
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'tcp_download'
            ]
              ? 'both'
              : modemParametersMapping?.[modem]?.[
                    this.testTypeMapping?.[type]
                  ]?.['tcp_upload']
                ? 'upload'
                : 'download',
          parallel_stream:
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'tcp_parallel_stream'
            ],
        };
        if (
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'length_tcp'
          ]
        ) {
          output['TCP']['length'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'length_tcp'
            ];
        }

        if (
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'tcp_unit'
          ]
        ) {
          output['TCP']['tcp_bl_unit'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'tcp_unit'
            ];
        }
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'udp_upload'
        ] ||
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'udp_download'
        ]
      ) {
        if (
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'buffer_size'
          ]
        ) {
          output['socket_buffer_size'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'buffer_size'
            ];
          output['socket_buffer_size_unit'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'buffer_size_unit'
            ];
        }

        if (defaultParameter?.value != 'rsrp') {
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'udp_upload'
          ]
            ? (defaultParameter.value = 'iperf_udp_ul_throughput')
            : (defaultParameter.value = 'iperf_udp_dl_throughput');
        }

        output['UDP'] = {
          direction:
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'udp_upload'
            ] &&
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'udp_download'
            ]
              ? 'both'
              : modemParametersMapping?.[modem]?.[
                    this.testTypeMapping?.[type]
                  ]?.['udp_upload']
                ? 'upload'
                : 'download',
          udp_bitrate:
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'udp_bitrate'
            ],
          parallel_stream:
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'udp_parallel_stream'
            ],
        };
        if (
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'length_udp'
          ]
        ) {
          output['UDP']['length'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'length_udp'
            ];
        }

        if (
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'udp_unit'
          ]
        ) {
          output['UDP']['udp_bl_unit'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'udp_unit'
            ];
        }
      }
      if (type == 'iperftest' || type == 'iperftest_continuous') {
        output['userapp'] = type;
      }
      return output;
    } else if (type == 'ping' || type == 'ping_continuous') {
      // defaultParameter = 'rsrp';
      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'pkt_loss';
      }
      let output: any = {
        sync_after: currentSyncValue,
        server:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'server'
          ]?.['address'],
        url: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'url'
        ],
        pktcount:
          +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'pkt_count'
          ],

        pktinterval:
          +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'pktinterval'
          ],
        pktsize:
          +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'pktsize'
          ],
        userapp: type,
      };
      if (type == 'ping_continuous') {
        output['start_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'start_after'
          ] || 0;
        output['stop_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'stop_after'
          ] || 0;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
          output['mac_number'] = mac;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }

      return output;
    } else if (type == 'curl' || type == 'curl_continuous') {
      // defaultParameter = 'rsrp';
      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'totaltime';
      }
      // Url Get / Url Post are merged: a CURL test with method POST is sent as a POST rule
      const curlCfg = modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]];
      if (curlCfg?.['method'] == 'POST') {
        return this.createPostPayload(curlCfg, type == 'curl_continuous', currentSyncValue, mac, true);
      }
      let output: any = {
        sync_after: currentSyncValue,
        server:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'server'
          ]?.['address'],
        url: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'url'
        ],
        download_limit_bytes:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'download_limit_bytes'
          ] ?? 100 * 1024 * 1024,
        userapp: type,
      };

      if (type == 'curl_continuous') {
        output['start_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'start_after'
          ] || 0;
        output['stop_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'stop_after'
          ] || 0;
        output['iteration_count'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'iteration_count'
          ];
        output['iteration_interval'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'iteration_interval'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
          output['mac_number'] = mac;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }

      return output;
    } else if (type == 'ytube' || type == 'ytube_continuous') {
      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'overall_quality_assessment';
      }
      let output: any = {
        sync_after: currentSyncValue,
        server:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'server'
          ]?.['address'],
        url: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'url'
        ],
        userapp: type,
      };
      if (type == 'ytube_continuous') {
        output['start_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'start_after'
          ] || 0;
        output['stop_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'stop_after'
          ] || 0;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
          output['mac_number'] = mac;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }

      return output;
    } else if (type === 'securitytest' || type === 'securitytest_continuous' || type === 'security_single') {
      const isSingle = type === 'security_single';
      const testKey = isSingle ? 'SECURITY_SINGLE' : 'SECURITY';
      const secEntry = modemParametersMapping?.[modem]?.[testKey];
      const profile = secEntry?.profile;
      const output: any = {
        sync_after: currentSyncValue,
        profile_id: profile?.profile_id,
        token: localStorage.getItem('token'),
        url: (window as any)?.__env?.enableLogging === 'true'
              ? `${this.fileServerUrl}/custom/security_files`
              : `${window.location.origin}/fileurl/custom/security_files`,
        filehash: profile?.profile_hash,
        profile_name: profile?._id ? `${profile._id}.json` : undefined,
        userapp: isSingle ? 'securitytest' : 'securitytest_continuous',
        profile_timeout: +(secEntry?.profile_timeout ?? 0),
        change_window_id: secEntry?.change_window_id ?? null,
        ...(isSingle ? {} : {
          start_after: secEntry?.start_after ?? 0,
          stop_after: secEntry?.stop_after ?? 0,
          securitytest_delay: +(secEntry?.delay ?? 0),
        }),
      };
      if (secEntry?.['wifiSSID'] && secEntry?.['modem_type'] == 'WiFi') {
        output['ssid'] = secEntry['wifiSSID'];
        output['mac_number'] = mac;
      }
      if (secEntry?.['interface'] && secEntry?.['modem_type'] == 'WiFi') {
        output['interface'] = secEntry['interface'];
      }
      return output;
    } else if (type == 'sptest' || type == 'sptest_continuous') {
      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'upload';
      }
      let output: any = {
        sync_after: currentSyncValue,
        server:modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.['server']?.['address'],
        userapp: type,
      };
      if (type == 'sptest_continuous') {
        output['start_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'start_after'
          ] || 0;
        output['stop_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'stop_after'
          ] || 0;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
          output['mac_number'] = mac;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'url'
        ]?.[0]?.server
      ) {
      output['url'] = this.getCorrectUrl(modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.['url']?.[0]?.fullurl||modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.['url']?.[0]?.server, modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.['url']?.[0]?.port)
          // `${modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.['url']?.[0]?.fullurl||modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.['url']?.[0]?.server}${modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.['url']?.[0]?.port?
          //  ':'+modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.['url']?.[0]?.port:''}`;
      }

      return output;
    } else if (type == 'video_single' || type == 'video_continuous') {
      let token = localStorage.getItem('token');
      token = this.encryptUsingAES256(token);

      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'bitrate';
      }

      let output: any = {
        sync_after: currentSyncValue,
        ip: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'ip'
        ],
        filename:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'file'
          ],
        path: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'path'
        ],
        server:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'server'
          ],
        port: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'port'
        ],
        token: token,
        userapp: type,
      };
      if (type == 'video_continuous') {
        output['start_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'start_after'
          ] || 0;
        output['stop_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'stop_after'
          ] || 0;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
          output['mac_number'] = mac;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }

      return output;
    } else if (type == 'call' || type == 'call_continuous') {
      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'ALERTING';
      }

      let output: any = {
        sync_after: currentSyncValue,

        numbertodial:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'number'
          ],
        timetowait: !isNaN(
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'waittime'
          ],
        )
          ? +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'waittime'
            ]
          : 30,
        userapp: type == 'call' ? 'dialnumber' : 'dialnumber_continuous',
      };
      if (type == 'call_continuous') {
        output['start_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'start_after'
          ] || 0;
        output['stop_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'stop_after'
          ] || 0;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
          output['mac_number'] = mac;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }
      if (type == 'call_continuous') {
        console.log(
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'dialfrequency'
          ],
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'dialfrequencyUnit'
          ],
        );

        output['dialfrequency'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'dialfrequencyUnit'
          ] == 'Min'
            ? +modemParametersMapping?.[modem]?.[
                this.testTypeMapping?.[type]
              ]?.['dialfrequency'] * 60
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                  'dialfrequencyUnit'
                ] == 'Hrs'
              ? +modemParametersMapping?.[modem]?.[
                  this.testTypeMapping?.[type]
                ]?.['dialfrequency'] * 3600
              : +modemParametersMapping?.[modem]?.[
                  this.testTypeMapping?.[type]
                ]?.['dialfrequency'];
      }
      return output;
    } else if (type == 'rrc_state' || type == 'rrc_state_continuous') {
      let output: any = {
        sync_after: currentSyncValue,

        interval: !isNaN(
          +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interval'
          ],
        )
          ? +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'interval'
            ]
          : 2,
        userapp: type,
      };
      if (type == 'rrc_state_continuous') {
        output['start_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'start_after'
          ] || 0;
        output['stop_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'stop_after'
          ] || 0;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
          output['mac_number'] = mac;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }
      return output;
    } else if (type == 'gnss' || type == 'gnss_continuous') {
      if (defaultParameter?.value != 'rsrp') {
        defaultParameter.value = 'GPS';
      }

      let output: any = {
        sync_after: currentSyncValue,

        interval: !isNaN(
          +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'gnss_interval'
          ],
        )
          ? +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'gnss_interval'
            ]
          : 2,
        userapp: type,
      };
      if (type == 'gnss_continuous') {
        output['start_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'start_after'
          ] || 0;
        output['stop_after'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'stop_after'
          ] || 0;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
          output['mac_number'] = mac;
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }
      return output;
    } else if (type == 'ftp' || type == 'ftp-continuous' || type == 'ftp_continuous') {
      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'transfer_speed_bps';
      }
      const cfg = modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]];
      console.log(cfg, type);
      return {
        sync_after: currentSyncValue,
        url: cfg?.['url'] || '',
        port: cfg?.server?.port,
        ftp_mode: cfg?.['download'] ? 'GET' : 'PUT',
        ftp_type: cfg?.['ftp_type'] || 'unsecured',
        ftp_username: cfg?.['username'] || 'anonymous',
        ftp_password: cfg?.['password'] || '',
        size: +(String(cfg?.['size'] ?? '1M').replace(/M$/i, '')) || 1,
        size_unit: cfg?.['size_unit'] || 'MB',
        managed: cfg?.['managed'] || false,
        ...(cfg?.['download'] === false ? { upload_path: cfg?.['local_file'] || '' } : {}),
        ...(cfg?.['download'] !== false ? { download_path: cfg?.['remote_file'] || '' } : {}),
        ...((type == 'ftp-continuous' || type == 'ftp_continuous') ? {
          start_after: cfg?.['start_after'] || 0,
          stop_after: cfg?.['stop_after'] || 0,
        } : {}),
        ...(cfg?.['wifiSSID'] && cfg?.['modem_type'] == 'WiFi' ? { ssid: cfg['wifiSSID'], mac_number: mac } : {}),
        ...(cfg?.['interface'] && cfg?.['modem_type'] == 'WiFi' ? { interface: cfg['interface'] } : {}),
        userapp: (type=='ftp-continuous' || type == 'ftp_continuous')?'ftptest_continuous':'ftptest',
      };
    } else if (type == 'wget_post' || type == 'wget-post-continuous' || type == 'wget_post_continuous') {
      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'totaltime';
      }
      const cfg = modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]];
      return this.createPostPayload(cfg, type != 'wget_post', currentSyncValue, mac);
    }
  }

  // Url POST rule payload; shared by the CURL test (method POST) and the legacy WGETPOST tests
  createPostPayload(cfg: any, isContinuous: boolean, currentSyncValue: any, mac: any, withTiming = isContinuous) {
    const wgetContentType = cfg?.['content_type'] || 'application/octet-stream';
    let contentPayload: any = {};
    if (wgetContentType === 'application/json') {
      let parsedJson: any = {};
      try {
        parsedJson = cfg?.['json_data'] ? JSON.parse(cfg['json_data']) : {};
      } catch (e) {
        parsedJson = {};
      }
      contentPayload = { json_data: parsedJson };
    } else {
      contentPayload = { bytes: +(cfg?.['bytes'] ?? 100) || 100 };
    }
    return {
      sync_after: currentSyncValue,
      url: cfg?.['url'] || '',
      method: 'POST',
      content_type: wgetContentType,
      ...contentPayload,
      ...(withTiming ? {
        start_after: cfg?.['start_after'] || 0,
        stop_after: cfg?.['stop_after'] || 0,
        iteration_count: cfg?.['iteration_count'] ?? 0,
        iteration_interval: cfg?.['iteration_interval'] ?? 5,
      } : {}),
      ...(cfg?.['wifiSSID'] && cfg?.['modem_type'] == 'WiFi' ? { ssid: cfg['wifiSSID'], mac_number: mac } : {}),
      ...(cfg?.['interface'] && cfg?.['modem_type'] == 'WiFi' ? { interface: cfg['interface'] } : {}),
      userapp: isContinuous ? 'curl_continuous' : 'curl',
    };
  }

  iperfParameterOrder = [
    
    'server',
    'port',
    'duration',
    'acceleration',
    'ip_v',
    'ip',
    "profile_name",
    "profile_id",
    "filehash",
    "profile_timeout",
    "securitytest_delay",
    'pktcount',
    'scaninfo',
    'serveinfo',
    'neighbour_scan',
    'pktinterval',
    'pktsize',
    'ssid',
    'ping_size',
    'url',
    'download_limit_bytes',
    'method',
    'content_type',
    'bytes',
    'iteration_count',
    'iteration_interval',
    'dialfrequency',
    'numbertodial',
    'timetowait',
    'interval',
    'filename',
    'start_after',
    'stop_after',
    'sync_after',

    
  ];

  topLevelData=[
       "ts",
      "status",
      "stop_ts"
  ]

  tcpUpdParameters = {
    both: ['Upload', 'Download'],
    upload: ['Upload'],
    download: ['Download'],
    parallel_stream: 'Parallel Stream',
    udp_bitrate: 'Bitrate (Mbps)',
  };

  testTypeAndKeys = {
    RF: [
      'radio_continuous',
      'serving_continuous',
      'neighbour_scan',
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    PINRF: [
      'radio_pindrop',
      'serving_pindrop',
      'neighbour_scan',
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    IPERF: [
      'index',
      'duration_continuous',
      'server',
      'ping_size',
      'acceleration',
      'bidirectional',
      'ipv4',
      'ipv6',
      'window',
      'length_tcp',
      'length_udp',
      'udp_upload',
      'udp_download',
      'tcp_upload',
      'tcp_download',
      'udp_bitrate',
      'tcp_parallel_stream',
      'udp_parallel_stream',
      'tcp_unit',
      'udp_unit',
      'window_unit',
      'buffer_size',
      'buffer_size_unit',
      'start_after',
      'stop_after',
      'sync_after',
      'with_ping',
      'tcp_buffer_default',
      'udp_buffer_default',
      'server',
      'managed',
      'wifiSSID',
    ],
    PINIPERF: [
      'index',
      'duration_pindrop',
      'ping_size',
      'acceleration',
      'bidirectional',
      'ipv4',
      'ipv6',
      'window',
      'length_tcp',
      'length_udp',
      'udp_upload',
      'udp_download',
      'tcp_upload',
      'tcp_download',
      'udp_bitrate',
      'tcp_parallel_stream',
      'udp_parallel_stream',
      'tcp_unit',
      'udp_unit',
      'window_unit',
      'buffer_size',
      'buffer_size_unit',
      'start_after',
      'stop_after',
      'sync_after',
      'with_ping',
      'tcp_buffer_default',
      'udp_buffer_default',
      'server',
      'managed',
      'wifiSSID',
    ],
    IPERFTEST: [
      'index',
      'duration_continuous',
      'server',
      'ping_size',
      'acceleration',
      'bidirectional',
      'ipv4',
      'ipv6',
      'window',
      'length_tcp',
      'length_udp',
      'udp_upload',
      'udp_download',
      'tcp_upload',
      'tcp_download',
      'udp_bitrate',
      'tcp_parallel_stream',
      'udp_parallel_stream',
      'tcp_unit',
      'udp_unit',
      'window_unit',
      'buffer_size',
      'buffer_size_unit',
      'start_after',
      'stop_after',
      'sync_after',
      'with_ping',
      'tcp_buffer_default',
      'udp_buffer_default',
      'server',
      'managed',
      'wifiSSID',
    ],
    PINIPERFTEST: [
      'index',
      'duration_pindrop',
      'ping_size',
      'acceleration',
      'bidirectional',
      'ipv4',
      'ipv6',
      'window',
      'length_tcp',
      'length_udp',
      'udp_upload',
      'udp_download',
      'tcp_upload',
      'tcp_download',
      'udp_bitrate',
      'tcp_parallel_stream',
      'udp_parallel_stream',
      'tcp_unit',
      'udp_unit',
      'window_unit',
      'buffer_size',
      'buffer_size_unit',
      'start_after',
      'stop_after',
      'sync_after',
      'with_ping',
      'tcp_buffer_default',
      'udp_buffer_default',
      'server',
      'managed',
      'wifiSSID',
    ],
    CALLCONTI: [
      'number',
      'waittime',
      'index',
      'callPossible',
      'dialfrequency',
      'dialfrequencyUnit',
      'start_after',
      'stop_after',
      'sync_after',
      'contact',
      'wifiSSID',
    ],
    CALL: [
      'number',
      'waittime',
      'index',
      'callPossible',
      'start_after',
      'stop_after',
      'sync_after',
      'contact',
      'dialfrequency',
      'dialfrequencyUnit',
      'wifiSSID',
    ],
    YOUTUBE: [
      'server',
      'url',
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    PINYOUTUBE: [
      'server',
      'url',
      'urlError',
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    CURLCONTI: [
      'url',
      'urlError',
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
      'iteration_interval',
      'iteration_count',
      'method',
      'get_url',
      'post_url',
      'content_type',
      'bytes',
      'json_data',
    ],
    CURL: [
      'url',
      'urlError',
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
      'method',
      'get_url',
      'post_url',
      'content_type',
      'bytes',
      'json_data',
    ],
    GNSSCONTI: [
      'gnss_interval',
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    GNSS: [
      'gnss_interval',
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    PINGCONTI: [
      'url',
      'pkt_count',
      'pktinterval',
      'pktsize',
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    PING: [
      'url',
      'pkt_count',
      'pktinterval',
      'pktsize',
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    RRCCONTI: [
      'interval',
      'index',
      'mode',
      'interface',
      'deviceInterfaces',
      'allssids',
      'wifiSSID',
    ],
    RRC: [
      'interval',
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    SPEEDCONTI: [
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'url',
      'wifiSSID',
    ],
    SPEED: [
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'url',
      'wifiSSID',
    ],
    FTP: [
      'index',
      'url',
      'port',
      'username',
      'password',
      'upload',
      'download',
      'ftp_type',
      'size',
      'size_unit',
      'managed',
      'server',
      'remote_file',
      'local_file',
      'upload_path',
      'download_path',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    FTPCONTI: [
      'index',
      'url',
      'port',
      'username',
      'password',
      'upload',
      'download',
      'ftp_type',
      'size',
      'size_unit',
      'managed',
      'server',
      'remote_file',
      'local_file',
      'upload_path',
      'download_path',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    WGETPOST: [
      'index',
      'url',
      'port',
      'username',
      'password',
      'wget_type',
      'size',
      'server',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    WGETPOSTCONTI: [
      'index',
      'url',
      'port',
      'username',
      'password',
      'wget_type',
      'size',
      'server',
      'start_after',
      'stop_after',
      'sync_after',
      'wifiSSID',
    ],
    SECURITY: [
      'index',
      'profile',
      'profile_timeout',
      'change_window_id',
      'delay',
      'wifiSSID',
    ],
    SECURITY_SINGLE: [
      'index',
      'profile',
      'profile_timeout',
      'change_window_id',
      'wifiSSID',
    ],
  };

  valueFormatter = {
    dialfrequency: 'Call Frequency (Sec)',
    '3_min': 'RF(PIN DROP)',
    iperf: ' IPERF(PIN DROP)',
    iperf_continuous: 'IPERF (CONTINUOUS)',
    iperftest: 'Multi IPERF(PIN DROP)',
    iperftest_continuous: 'Multi IPERF(CONTINUOUS)',
    continuous: 'RF (CONTINUOUS)',
    securitytest:"Security test (Single)",
    securitytest_continuous:"Security test (Continuous)",
    status: 'Test status',
    message: 'Reason',
    imei: 'IMEI / Interface',
    dialnumber: 'Call setup (SINGLE)',
    dialnumber_continuous: 'Call setup (CONTINUOUS)',
    scaninfo: 'RF Scan',
    neighbour_scan: 'Neighbour Scan',
    serverinfo: 'Serving Cell',
    start_after: 'Start After (sec)',
    stop_after: 'Stop After (sec)',
    sync_after: 'Sync After (sec)',
    pktcount: 'Packet Count',
    ip_v: 'IP VERSION',
    ip: 'IP ADDRESS',
    ui_testtype: 'Type',
    ping_continuous: 'PING (CONTINUOUS)',
    ping: 'PING (PIN DROP)',
    curl: 'WGET URL (PIN DROP)',
    video_single: 'Video (Single)',
    video_continuous: 'Video (Continuous)',
    curl_continuous: 'WGET URL (CONTINUOUS)',
    sptest: 'SPEED (PIN DROP)',
    sptest_continuous: 'SPEED (CONTINUOUS)',
    ytube: 'YOUTUBE (PIN DROP)',
    ytube_continuous: 'YOUTUBE (CONTINUOUS)',
    numbertodial: 'Dialed Number',
    timetowait: 'Wait Time(Sec)',
    serveinfo: 'Serving Cell',
    filename: 'File Name',
    rrc_state: 'RRC State (PIN DROP)',
    rrc_state_continuous: 'RRC State (Continuous)',
    gnss: 'Past GPS (PIN DROP)',
    gnss_continuous: 'Fast GPS (Continuous)',
    ts:"Triggered at",
    stop_ts:"Completed at",
    profile_id:"Profile ID",
    filehash:"File Hash",
    profile_name:"Profile Name",
    profile_timeout:"Profile Timeout",
    securitytest_delay:"Delay (sec)",
    download_limit_bytes: 'Byte Transfer Limit (bytes)',
    method: 'Method',
    content_type: 'Content Type',
    bytes: 'Bytes',
    iteration_count: 'Iteration Count',
    iteration_interval: 'Iteration Interval (sec)'
  };


  statusFormatter:any={"active":"Test Triggered", 
                   "Applied":"Test Running", 
                   "Applied_pin":"Completed", 
                   "Not Applied":"Test Failed", 
                   "Not Applied_pin":"Test Failed",
                   "Rejected":"Test Rejected",
                   "Rejected_pin":"Test Rejected", 
                   "Queued":"Processing", 
                   "Queued_pin":"In Progress", 
                   "In Progress":"Processing",
                   "In Progress_pin":"Test Running",
                   "Stopped_Applied":"Stopped" }

  timeFields:any={
    ts:"Triggered at",
    stop_ts:"stop_ts"
  }

   createModemConfigurations(
    deviceInterfaces: any[],
    modemInterface: String,
    ssid?: any,
    ssidList?: any,
    type?: any,
    index?: any,
    acc?: any,
    isActiveInterface?: any,
    mode?: any,
    callPossible?: any,
    target?: any,
    existingValues: any = {},
  ) {
    //if something is not being set correctly then please check "configurationSettings" in live page that is overwritting the values for default values.
    let allInterfaces = deviceInterfaces
      ? !deviceInterfaces.includes(modemInterface)
        ? [...deviceInterfaces, modemInterface]
        : deviceInterfaces
      : [modemInterface];
    console.log(existingValues, 'oooooooooooooooo');
    if (target) {
      console.log(target);
      switch (target) {
        case 'IPERF':
        case 'IPERFTEST':
          const defaultValuesIPERF = {
            index,
            interface: modemInterface,
            deviceInterfaces: allInterfaces,
            allssids: ssidList || [],
            acc,
            start_after: 0,
            isActiveInterface,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesIPERF['wifiSSID'] =
              defaultValuesIPERF['wifiSSID'] || ssid);
          type && (defaultValuesIPERF['modem_type'] = type);
          return defaultValuesIPERF;

        case 'PINIPERF':
        case 'PINIPERFTEST':
          const defaultValuesIPERFC = {
            index,
            interface: modemInterface,
            deviceInterfaces: allInterfaces,
            allssids: ssidList || [],
            acc,
            isActiveInterface,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesIPERFC['wifiSSID'] =
              defaultValuesIPERFC['wifiSSID'] || ssid);
          type && (defaultValuesIPERFC['modem_type'] = type);

          return defaultValuesIPERFC;

        case 'RF':
          const defaultValuesRF = {
            radio_continuous: true,
            serving_continuous: true,
            neighbour_scan: false,
            index,
            acc,
            start_after: 0,
            isActiveInterface,
            mode,
            ...existingValues,
          };

          ssid &&
            (defaultValuesRF['wifiSSID'] = defaultValuesRF['wifiSSID'] || ssid);
          defaultValuesRF['interface'] = modemInterface;
          defaultValuesRF['deviceInterfaces'] = allInterfaces;
          defaultValuesRF['allssids'] = ssidList || [];
          type && (defaultValuesRF['modem_type'] = type);
          return defaultValuesRF;

        case 'PINRF':
          const defaultValuesRFPIN = {
            radio_pindrop: true,
            serving_pindrop: true,
            neighbour_scan: false,
            index,
            acc,
            start_after: 0,
            isActiveInterface,
            ...existingValues,
          };

          ssid &&
            (defaultValuesRFPIN['wifiSSID'] =
              defaultValuesRFPIN['wifiSSID'] || ssid);
          defaultValuesRFPIN['interface'] = modemInterface;
          defaultValuesRFPIN['deviceInterfaces'] = allInterfaces;
          defaultValuesRFPIN['allssids'] = ssidList || [];
          type && (defaultValuesRFPIN['modem_type'] = type);
          return defaultValuesRFPIN;

        case 'PING':
          const defaultValuesPING = {
            interface: modemInterface,
            deviceInterfaces: allInterfaces,
            allssids: ssidList || [],
            urlError: true,
            index,
            acc,
            start_after: 0,
            isActiveInterface,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesPING['wifiSSID'] =
              defaultValuesPING['wifiSSID'] || ssid);
          type && (defaultValuesPING['modem_type'] = type);

          return defaultValuesPING;

        case 'PINGCONTI':
          const defaultValuesPINGCONTI = {
            interface: modemInterface,
            deviceInterfaces: allInterfaces,
            allssids: ssidList || [],
            urlError: true,
            index,
            acc,
            isActiveInterface,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesPINGCONTI['wifiSSID'] =
              defaultValuesPINGCONTI['wifiSSID'] || ssid);
          type && (defaultValuesPINGCONTI['modem_type'] = type);

          return defaultValuesPINGCONTI;

        case 'CURLCONTI':
          const defaultValuesCURLCONTI = {
            interface: modemInterface,
            deviceInterfaces: allInterfaces,
            allssids: ssidList || [],
            urlError: true,
            index,
            acc,
            isActiveInterface,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesCURLCONTI['wifiSSID'] =
              defaultValuesCURLCONTI['wifiSSID'] || ssid);
          type && (defaultValuesCURLCONTI['modem_type'] = type);

          return defaultValuesCURLCONTI;

        case 'CURL':
          const defaultValuesCURL = {
            interface: modemInterface,
            deviceInterfaces: allInterfaces,
            allssids: ssidList || [],
            urlError: true,
            index,
            acc,
            isActiveInterface,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesCURL['wifiSSID'] =
              defaultValuesCURL['wifiSSID'] || ssid);
          type && (defaultValuesCURL['modem_type'] = type);

          return defaultValuesCURL;

        case 'PINYOUTUBE':
          const defaultValuesY = {
            interface: modemInterface,
            deviceInterfaces: allInterfaces,
            allssids: ssidList || [],
            urlError: true,
            index,
            acc,
            isActiveInterface,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesY['wifiSSID'] = defaultValuesY['wifiSSID'] || ssid);
          type && (defaultValuesY['modem_type'] = type);

          return defaultValuesY;

        case 'YOUTUBE':
          if (acc != 'yes') {
            const defaultValuesYC = {
              interface: modemInterface,
              deviceInterfaces: allInterfaces,
              allssids: ssidList || [],
              urlError: true,
              index,
              acc,
              isActiveInterface,
              mode,
              ...existingValues,
            };
            ssid &&
              (defaultValuesYC['wifiSSID'] =
                defaultValuesYC['wifiSSID'] || ssid);
            type && (defaultValuesYC['modem_type'] = type);
            return defaultValuesYC;
          } else {
            return null;
          }

        case 'SPEED':
          const defaultValuesS = {
            interface: modemInterface,
            deviceInterfaces: allInterfaces,
            allssids: ssidList || [],
            urlError: true,
            index,
            acc,
            isActiveInterface,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesS['wifiSSID'] = defaultValuesS['wifiSSID'] || ssid);
          type && (defaultValuesS['modem_type'] = type);

          return defaultValuesS;

        case 'SPEEDCONTI':
          const defaultValuesSC = {
            interface: modemInterface,
            deviceInterfaces: allInterfaces,
            allssids: ssidList || [],
            urlError: true,
            index,
            acc,
            isActiveInterface,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesSC['wifiSSID'] = defaultValuesSC['wifiSSID'] || ssid);
          type && (defaultValuesSC['modem_type'] = type);
          return defaultValuesSC;

        case 'VIDEO':
          const defaultValuesVideo = {
            interface: modemInterface,
            deviceInterfaces: allInterfaces,
            allssids: ssidList || [],
            urlError: true,
            index,
            acc,
            ...existingValues,
          };
          ssid &&
            (defaultValuesVideo['wifiSSID'] =
              defaultValuesVideo['wifiSSID'] || ssid);
          type && (defaultValuesVideo['modem_type'] = type);

          return defaultValuesVideo;
        case 'CALL':
          if (callPossible) {
            const defaultValuesCall = {
              index,
              mode,
              callPossible,
              ...existingValues,
            };

            ssid &&
              (defaultValuesCall['wifiSSID'] =
                defaultValuesCall['wifiSSID'] || ssid);
            defaultValuesCall['interface'] = modemInterface;
            defaultValuesCall['deviceInterfaces'] = allInterfaces;
            defaultValuesCall['allssids'] = ssidList || [];
            type && (defaultValuesCall['modem_type'] = type);
            return defaultValuesCall;
          }
          return null;

        case 'CALLCONTI':
          if (callPossible) {
            const defaultValuesCallConti = {
              index,
              mode,
              callPossible,
              ...existingValues,
            };

            ssid &&
              (defaultValuesCallConti['wifiSSID'] =
                defaultValuesCallConti['wifiSSID'] || ssid);
            defaultValuesCallConti['interface'] = modemInterface;
            defaultValuesCallConti['deviceInterfaces'] = allInterfaces;
            defaultValuesCallConti['allssids'] = ssidList || [];
            type && (defaultValuesCallConti['modem_type'] = type);
            return defaultValuesCallConti;
          }
          return null;

        case 'RRC':
          const defaultValuesRRC = {
            index,
            mode,
            ...existingValues,
          };

          ssid &&
            (defaultValuesRRC['wifiSSID'] =
              defaultValuesRRC['wifiSSID'] || ssid);
          defaultValuesRRC['interface'] = modemInterface;
          defaultValuesRRC['deviceInterfaces'] = allInterfaces;
          defaultValuesRRC['allssids'] = ssidList || [];
          type && (defaultValuesRRC['modem_type'] = type);

          return defaultValuesRRC;

        case 'RRCCONTI':
          const defaultValuesRRCConti = {
            index,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesRRCConti['wifiSSID'] =
              defaultValuesRRCConti['wifiSSID'] || ssid);
          defaultValuesRRCConti['interface'] = modemInterface;
          defaultValuesRRCConti['deviceInterfaces'] = allInterfaces;
          defaultValuesRRCConti['allssids'] = ssidList || [];
          type && (defaultValuesRRCConti['modem_type'] = type);
          return defaultValuesRRCConti;

        case 'GNSS':
          const defaultValuesGNSS = {
            index,
            mode,
            ...existingValues,
          };

          ssid &&
            (defaultValuesGNSS['wifiSSID'] =
              defaultValuesGNSS['wifiSSID'] || ssid);
          defaultValuesGNSS['interface'] = modemInterface;
          defaultValuesGNSS['deviceInterfaces'] = allInterfaces;
          defaultValuesGNSS['allssids'] = ssidList || [];
          type && (defaultValuesGNSS['modem_type'] = type);
          return defaultValuesGNSS;

        case 'GNSSCONTI':
          const defaultValuesGNSSConti = {
            index,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesGNSSConti['wifiSSID'] =
              defaultValuesGNSSConti['wifiSSID'] || ssid);
          defaultValuesGNSSConti['interface'] = modemInterface;
          defaultValuesGNSSConti['deviceInterfaces'] = allInterfaces;
          defaultValuesGNSSConti['allssids'] = ssidList || [];
          type && (defaultValuesGNSSConti['modem_type'] = type);
          return defaultValuesGNSSConti;

        case 'FTP':
          const defaultValuesFTP = {
            index,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesFTP['wifiSSID'] = defaultValuesFTP['wifiSSID'] || ssid);
          defaultValuesFTP['interface'] = modemInterface;
          defaultValuesFTP['deviceInterfaces'] = allInterfaces;
          defaultValuesFTP['allssids'] = ssidList || [];
          type && (defaultValuesFTP['modem_type'] = type);
          return defaultValuesFTP;

        case 'FTPCONTI':
          const defaultValuesFTPConti = {
            index,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesFTPConti['wifiSSID'] = defaultValuesFTPConti['wifiSSID'] || ssid);
          defaultValuesFTPConti['interface'] = modemInterface;
          defaultValuesFTPConti['deviceInterfaces'] = allInterfaces;
          defaultValuesFTPConti['allssids'] = ssidList || [];
          type && (defaultValuesFTPConti['modem_type'] = type);
          return defaultValuesFTPConti;

        case 'WGETPOST': {
          const defaultValuesWgetPost = {
            index,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesWgetPost['wifiSSID'] = defaultValuesWgetPost['wifiSSID'] || ssid);
          defaultValuesWgetPost['interface'] = modemInterface;
          defaultValuesWgetPost['deviceInterfaces'] = allInterfaces;
          defaultValuesWgetPost['allssids'] = ssidList || [];
          type && (defaultValuesWgetPost['modem_type'] = type);
          return defaultValuesWgetPost;
        }

        case 'WGETPOSTCONTI': {
          const defaultValuesWgetPostConti = {
            index,
            mode,
            ...existingValues,
          };
          ssid &&
            (defaultValuesWgetPostConti['wifiSSID'] = defaultValuesWgetPostConti['wifiSSID'] || ssid);
          defaultValuesWgetPostConti['interface'] = modemInterface;
          defaultValuesWgetPostConti['deviceInterfaces'] = allInterfaces;
          defaultValuesWgetPostConti['allssids'] = ssidList || [];
          type && (defaultValuesWgetPostConti['modem_type'] = type);
          return defaultValuesWgetPostConti;
        }

        case 'SECURITY':
        case 'SECURITY_SINGLE': {
          const defaultValuesSecurity: any = {
            index,
            mode,
            profile: null,
            profile_timeout: 0,
            change_window_id: null,
            delay: 0,
            ...existingValues,
          };
          defaultValuesSecurity['interface'] = modemInterface;
          defaultValuesSecurity['deviceInterfaces'] = allInterfaces;
          defaultValuesSecurity['allssids'] = ssidList || [];
          ssid && (defaultValuesSecurity['wifiSSID'] = defaultValuesSecurity['wifiSSID'] || ssid);
          type && (defaultValuesSecurity['modem_type'] = type);
          return defaultValuesSecurity;
        }

        default:
          return null;
        // delete this.modemAndParametersMapping?.[id];
        // delete this.resetMapping?.[id];
      }
    }
  }

  encryptUsingAES256(val: any) {
    let A = CryptoJS.enc.Utf8.parse(this.A);
    var iv = CryptoJS.enc.Utf8.parse(this.B);
    // console.log(this.A, iv);
    var encrypted = CryptoJS.AES.encrypt(val, A, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    }).ciphertext.toString(CryptoJS.enc.Base64);
    // encrypted =encrypted.toString();
    return encrypted;
  }

  getMaps(mapid?: any) {
    const filter: any = { sort: { mapname: 'asc' } };
    if (mapid) {
      filter.query = {
        bool: {
          must: [
            {
              query_string: {
                query: `\"${mapid}\"`,
                type: 'phrase',
                fields: ['_id'],
              },
            },
          ],
        },
      };
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/maplist/_search?pretty&size=1000`,
      filter,
    );
  }

  getReportMaplist(daterange: any) {
    let start = daterange?.startDate;
    let end = daterange?.endDate;
    return this.httpClient.get(
      `${this.apiEndPoint}/_/2.0/walktestmaps?starttime=${start}&endtime=${end}`,
    );
  }

  addDummyMap(filter: any) {
    return this.httpClient.post(
      this.apiEndPoint + '/gwdevice/maplist/_create?_id=dummymap',
      filter,
    );
  }

  getReportMaplistBase(daterange: any) {
    let start = daterange?.startDate;
    let end = daterange?.endDate;
    return this.httpClient.get(
      `${this.apiEndPoint}/_/2.0/walktestmaps?starttime=${start}&endtime=${end}&device_type=base`,
    );
  }

  downloadMap(file: string) {
    return this.httpClient.get(`${this.fileServerUrl}/${file}`);
  }

  getVideosList() {
    console.log('called..........');
    return this.httpClient.get(`${this.fileServerUrl}/videos/files`);
  }

  getMapList() {
    return this.httpClient.get(`${this.fileServerUrl}/files`);
  }

  getMapListReports() {
    return this.httpClient.get(`${this.fileServerUrl}/reportsFiles`);
  }

  getTestCurrentStatus(ruleids: string) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: ruleids,
                type: 'phrase',
                fields: ['rule_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicereq/_search?pretty&size=10`,
      filter,
    );
  }

  getTestsCurrentStatus(locname: string) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: locname,
                type: 'phrase',
                fields: ['locname'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicereq/_search?pretty&size=10`,
      filter,
    );
  }

  getAllRunningTests() {
    const filter = {
      query: {
        bool: {
          should: [
            {
              bool: {
                must: [
                  {
                    query_string: {
                      query: '(continuous) OR (iperf_continuous) OR (iperftest_continuous)',
                      type: 'phrase',
                      fields: ['walktesttype', 'test_duration'],
                    },
                  },
                  {
                    query_string: {
                      query: '(Applied) OR (In Progress) OR (Queued)',
                      type: 'phrase',
                      fields: ['status.keyword'],
                    },
                  },
                ],
                must_not: [
                  {
                    query_string: {
                      query: '(securitytest) OR (securitytest_continuous)',
                      type: 'phrase',
                      fields: ['ui_testtype'],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
      sort: {
        '_kuzzle_info.createdAt': 'desc',
      },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktest/_search?size=10000`,
      filter,
    );
  }

  getSecurityRunningTests() {
    const filter = {
      query: {
        bool: {
          should: [
            {
              bool: {
                must: [
                  {
                    query_string: {
                      query: '(securitytest) OR (securitytest_continuous)',
                      type: 'phrase',
                      fields: ['walktesttype'],
                    },
                  },
                  {
                    query_string: {
                      query: '(Applied) OR (In Progress) OR (Queued)',
                      type: 'phrase',
                      fields: ['status.keyword'],
                    },
                  },
                ],
                must_not: [],
              },
            },
          ],
        },
      },
      sort: {
        '_kuzzle_info.createdAt': 'desc',
      },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktest/_search?size=10000`,
      filter,
    );
  }

  getWalktestByRuleId(ruleId: string) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: ruleId,
                type: 'phrase',
                fields: ['rule_id'],
              },
            },
          ],
        },
      },
      sort: {
        '_kuzzle_info.createdAt': 'desc',
      },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktest/_search?size=1`,
      filter,
    );
  }

  deleteRoute(id: string) {
    return this.httpClient.delete(
      `${this.apiEndPoint}/gwdevice/walktestroute/${id}`,
    );
  }

  createRoute(
    location: { x_coord: number; y_coord: number },
    mapname: string,
    mapid: string,
    ts: number,
    locname: string,
    walktesttype: string,
    dimension: { width: number; height: number },
  ) {
    const filter = {
      locname: locname,
      mapname: mapname,
      mapid: mapid,
      walktesttype: walktesttype,
      location: location,
      ts: ts,
      width: dimension?.width,
      height: dimension?.height,
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktestroute/_create`,
      filter,
    );
  }

  createPinDropEvent(
    location: { x_coord: number; y_coord: number },
    ts: number,
    locname: string,
    deviceid: string,
    text: string,
  ) {
    const filter = {
      locname: locname,
      location: location,
      ts: ts,
      stop_ts: ts,
      log_text: text,
      deviceid: deviceid,
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/eventlog/_create`,
      filter,
    );
  }

  locateUntracedPoints(
    first: { x: number; y: number; ts: number; floor?: string },
    ts: any,
    notification: any,
  ) {
    let parametrs = notification?._source?.reportfilter;
    const colors = { rssi: '#808080' };
    parametrs
      ? Object.keys(parametrs).map((each: any) => {
          if (each) {
            if (each == 'lat') {
              //assuming only GNSS test will have lat in report_filter if not then we need to add another check to add test type
              colors['GPS'] = this.setColor('GPS', parametrs?.[each]);
            } else {
              colors[each] = this.setColor(each, parametrs?.[each]);
            }
          }
        })
      : {};
    console.log(colors);
    Object.assign(notification, {
      id: notification?._id,
      coordinate: { x: first?.x, y: first?.y },
      degree: 0,
      floor: undefined,
      colors,
      parametrs,
      values: parametrs,
    });
    return notification;
  }

  locatePoint(
    first: { x: number; y: number; ts: number; floor?: string },
    second: { x: number; y: number; ts: number; floor?: string },
    ts: number,
    notification: any,
  ) {
    notification?._id == '11oyYIoBOkCuU1Z7sQoO' &&
      console.log(first, second, ts, notification);
    let original = notification;
    let parametrs = notification?._source?.reportfilter;
    const colors = { rssi: '#808080' };
    //  (notification?._source?.ui_testtype=="3_min"||notification?._source?.ui_testtype=="continuous"||notification?._source?.ui_testtype=="iperf"||notification?._source?.ui_testtype=="iperf_continuous") ? { rssi: '#808080' }:
    // (notification?._source?.ui_testtype=="ytube"||notification?._source?.ui_testtype=="ytube")
    // { rssi: '#808080' }
    parametrs
      ? Object.keys(parametrs).map((each: any) => {
          if (each) {
            if (each == 'lat') {
              //assuming only GNSS test will have lat in report_filter if not then we need to add another check to add test type
              colors['GPS'] = this.setColor('GPS', parametrs?.[each]);
            } else {
              colors[each] = this.setColor(each, parametrs?.[each]);
            }
          }
        })
      : {};
    // console.log(colors);
    let degree = 0;
    if (first?.ts) {
      if (ts <= first?.ts && ts >= second?.ts) {
        // console.log(ts, 'first')
        let slop = (first?.y - second?.y) / (first?.x - second?.x);
        let radAngle = Math.atan(slop);
        degree = (180 * radAngle) / Math.PI;
        let percent = (ts - second?.ts) / (first?.ts - second?.ts);
        let coordinate = {
          x: second?.x + (first?.x - second?.x) * percent,
          y: second?.y + (first?.y - second?.y) * percent,
        };
        let floor = first?.floor;
        let routePoint = first?.ts + '-';
        let values = parametrs;
        return {
          ...notification,
          id: notification?._id,
          coordinate,
          degree,
          floor,
          routePoint,
          colors,
          values,
        };
      } else if (ts > first?.ts) {
        // console.log(ts, 'second')
        let floor = first?.floor;
        let values = parametrs;
        return {
          ...notification,
          id: notification?._id,
          coordinate: { x: first?.x, y: first?.y },
          degree: 0,
          floor: floor,
          routePoint: first?.ts,
          colors,
          values,
        };
      }
    } else {
      // console.log(ts, 'third')
      let floor = second?.floor;
      let values = parametrs;
      return {
        ...notification,
        id: notification?._id,
        coordinate: { x: second?.x, y: second?.y },
        degree: 0,
        floor: floor,
        routePoint: second?.ts,
        colors,
        values,
      };
    }
  }

  locateSinglescane(notification: any, another_location?: any) {
    // console.log("locating the points");
    let parametrs = notification?._source?.reportfilter;
    let location = another_location || notification?._source?.location;
    const colors = { rssi: '#808080' };

    parametrs
      ? Object.keys(parametrs).map((each: any) => {
          if (each) {
            if (each == 'lat') {
              //assuming only GNSS test will have lat in report_filter if not then we need to add another check to add test type
              colors['GPS'] = this.setColor('GPS', parametrs?.[each]);
            } else {
              colors[each] = this.setColor(each, parametrs?.[each]);
            }
          }
        })
      : {};
    // console.log(colors);
    if (another_location?.lat) {
      notification._source.location = another_location;
    }
    Object.assign(notification, {
      id: notification?._id,
      coordinate: { x: location?.x_coord, y: location?.y_coord },
      degree: 0,
      floor: undefined,
      colors,
      parametrs,
      values: parametrs,
    });
    // console.log(notification?._source?.rule_result?.[0]?.walk_test?.location?.lat, notification?._source?.rule_result?.[0]?.walk_test?.location?.lng)
    return notification;
  }

  createObserverFunctionality() {
    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry: any) => {
          const intersecting = entry.isIntersecting;
          // console.log(entry)
          entry.target.style.visibility = intersecting ? 'visible' : 'hidden';
        });
      },
      { threshold: 0.3 },
    );

    return observer;
  }

  locateAtLatestPoint(
    lastPoint: { x: number; y: number; ts: number; floor?: string },
    notification: any,
  ) {
    let parametrs = notification?._source?.reportfilter;
    const colors = { rssi: '#808080' };
    parametrs
      ? Object.keys(parametrs).map((each: any) => {
          if (each) {
            if (each == 'lat') {
              //assuming only GNSS test will have lat in report_filter if not then we need to add another check to add test type
              colors['GPS'] = this.setColor('GPS', parametrs?.[each]);
            } else {
              colors[each] = this.setColor(each, parametrs?.[each]);
            }
          }
        })
      : {};
    let floor = lastPoint?.floor;
    let values = parametrs;
    return {
      ...notification,
      coordinate: { x: lastPoint?.x, y: lastPoint?.y },
      degree: 0,
      floor: floor,
      routePoint: lastPoint?.ts,
      colors,
      values,
    };
  }

  locatePindropTestPoint(
    notification: any,
    locationMap: {},
    count_num: number,
  ) {
    // console.log(locationMap)
    let parametrs = notification?._source?.reportfilter;
    const colors = { rssi: '#808080' };
    parametrs
      ? Object.keys(parametrs).map((each: any) => {
          if (each) {
            if (each == 'lat') {
              //assuming only GNSS test will have lat in report_filter if not then we need to add another check to add test type
              colors['GPS'] = this.setColor('GPS', parametrs?.[each]); //second parameter is redundent for GPS
            } else {
              colors[each] = this.setColor(each, parametrs?.[each]);
            }
          }
        })
      : {};
    let values = parametrs;
    return {
      ...notification,
      coordinate: locationMap?.[notification?._source?.rule_id],
      degree: 0,
      colors,
      values,
      count_no: count_num,
    };
  }

  getCurrentKuzzleTime() {
    return this.httpClient.get(`${this.apiEndPoint}/_now`);
  }

  getSurveyResult(notificationid) {
    const filter = {
      filter: [
        { type: 'single', field: 'notificationid', value: [notificationid] },
      ],
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/_/walktestsurveydata`,
      filter,
    );
  }

  getCompleteWalktestSurveyData(
    locname: string,
    dateRange?: any,
    subscription?: any,
  ) {
    // console.log("surveydata called  ");
    return new Promise((resolve: any, reject): any => {
      const filter: any = {
        filter: [{ type: 'single', field: 'locname', value: [locname] }],
      };
      dateRange?.[0] &&
        dateRange?.[1] &&
        filter['filter'].push({
          type: 'range',
          field: 'starttime',
          value: { min: dateRange?.[0], max: dateRange?.[1] },
        });
      let survey$ = this.httpClient
        .post(`${this.apiEndPoint}/_/walktestsurveydata`, filter)
        .subscribe((response) => {
          resolve(response);
        });
      subscription && subscription.push(survey$);
    });
  }

  getNotification(
    imei: number,
    start_ts: number,
    stop_ts: number,
    ruleid?: number,
    notiid?: number,
  ) {
    let imei_m = `\"${imei}\"`;
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: { query: imei_m, type: 'phrase', fields: ['imei'] },
            },
            {
              query_string: {
                query: start_ts,
                type: 'phrase',
                fields: ['rule_result.walk_test.start_TS'],
              },
            },
            {
              query_string: {
                query: stop_ts,
                type: 'phrase',
                fields: ['rule_result.walk_test.stop_TS'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    if (ruleid) {
      filter.query.bool.must.push({
        query_string: { query: ruleid, type: 'phrase', fields: ['rule_id'] },
      });
    }
    if (notiid) {
      filter.query.bool.must.push({
        query_string: { query: notiid, type: 'phrase', fields: ['_id'] },
      });
    }

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktestnotification/_search?size=1`,
      filter,
    );
  }

  getNotificationFromId(notiid?: number) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: { query: notiid, type: 'phrase', fields: ['_id'] },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktestnotification/_search?size=1`,
      filter,
    );
  }

  getGroupDetails(deviceid: any) {
    const match = [];
    if (deviceid) {
      match.push({ match: { 'devices.deviceid': deviceid } });
    }
    // deviceData?.modemData&&deviceData?.modemData.map(each=>{
    //      match.push({ "match": { "devices.imei": each?.IMEI }})
    // })
    const filter = {
      query: {
        nested: {
          path: 'devices',
          query: {
            bool: {
              must: match,
            },
          },
        },
      },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicegroup/_search?size=10`,
      filter,
    );
  }

  getNotificationCount(
    deviceid: any,
    mapid: any,
    starttime: any,
    endtime: any,
    includebase?: any,
    base?: any,
  ) {
    const filter = { query: { bool: { must: [] } } };
    filter.query.bool.must.push({
      range: {
        'rule_result.walk_test.stop_TS': { gte: starttime, lte: endtime },
      },
    });
    if (deviceid) {
      filter.query.bool.must.push({
        query_string: { query: deviceid, type: 'phrase', fields: ['deviceid'] },
      });
    }
    if (mapid) {
      filter.query.bool.must.push({
        query_string: {
          query: `\"${mapid}\"`,
          type: 'phrase',
          fields: ['mapid'],
        },
      });
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktestnotification/_count`,
      filter,
    );
  }

  getDeviceTableData(id: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: `\"${id}\"`,
                type: 'phrase',
                fields: ['_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/edgedevicemaster_slice/_search?size=1`,
      filter,
    );
  }

  updateSliceData(id: any, key: any, value: any) {
    const filter = { [key]: value };
    //console.log(filter, id);
    return this.httpClient.put(
      `${this.apiEndPoint}/gwdevice/edgedevicemaster_slice/${id}/_update`,
      filter,
    );
  }

  getHelperTableData(id: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: `\"${id}\"`,
                type: 'phrase',
                fields: ['_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/edgedevice_helper/_search?size=1`,
      filter,
    );
  }

  getDeviceTableDataFromPlatform(id: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: `\"${id}\"`,
                type: 'phrase',
                fields: [
                  'xedge_platform.firmware_versions.PlatformSerialNumber',
                ],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/edgedevicemaster_slice/_search?size=1`,
      filter,
    );
  }

  getDivecesList(mapName: any, daterange?: any) {
    // console.log(mapName[0]?.mapid)
    let api = `${this.apiEndPoint}/_/2.0/walktestdevices?mapid=${mapName[0]?.mapid}`;
    if (daterange?.startDate && daterange?.endDate) {
      api = `${api}&starttime=${daterange?.startDate}&endtime=${daterange?.endDate}`;
    }
    return this.httpClient.get(api);
  }

  getDivecesBase(mapName: any, daterange?: any) {
    // console.log(mapName[0]?.mapid)
    let api = `${this.apiEndPoint}/_/2.0/walktestdevices?mapid=${mapName[0]?.mapid}`;
    if (daterange?.startDate && daterange?.endDate) {
      api = `${api}&starttime=${daterange?.startDate}&endtime=${daterange?.endDate}&device_type=base`;
    }
    return this.httpClient.get(api);
  }

  fetchCompleteEventLogs(
    locname?: string,
    ruleid?: string,
    deviceid?: any,
    imei?: number,
    start?: number,
    end?: number,
    data = { result: [] },
    subscription?: any,
    size?: any,
    order?: any,
  ) {
    // console.log("eventlog called  ", data);
    return new Promise((resolve, reject) => {
      // return new Promise((resolve, reject)=>{
      const bodyFilter = {};
      const finalResult = data;
      start && (bodyFilter['starttime'] = start);
      end && (bodyFilter['endtime'] = end);
      ruleid && (bodyFilter['ruleid'] = ruleid);
      locname && (bodyFilter['locname'] = locname);
      deviceid && (bodyFilter['deviceid'] = deviceid);
      imei && (bodyFilter['imei'] = imei);
      size && (bodyFilter['size'] = size);
      order && (bodyFilter['sort'] = order);
      let eventlog$ = this.httpClient
        .post(`${this.apiEndPoint}/_/2.0/eventlogdata`, bodyFilter)
        .subscribe({next:(res: any) => {
          if (res?.result?.data) {
            finalResult['result'].push(res?.result?.data);
          }
          let len = 0;
          if (finalResult.result) {
            finalResult.result.map((each) => {
              if (each) {
                len += each.length;
              }
            });
          }
          console.log(
            finalResult.result.length,
            len,
            res?.result?.status,
            res?.result?.status == 'incomplete' && (size ? len <= 40000 : true),
          );
          if (
            res?.result?.status == 'incomplete' &&
            (size ? len <= 30000 : true)
          ) {
            this.fetchCompleteEventLogs(
              locname,
              ruleid,
              deviceid,
              imei,
              res?.result?.starttime,
              end,
              finalResult,
              subscription,
              size,
            ).then((response) => {
              resolve(response);
            });
          } else {
            resolve({ result: { hits: finalResult?.result.flat() } });
          }
        },
      error:(err)=>{
          resolve({ result: { hits: finalResult?.result.flat() } });
      }});
      subscription && subscription.push(eventlog$);
    });
  }

  getMapDataFromId(id: any) {
    return this.httpClient.get(`${this.apiEndPoint}/gwdevice/maplist/${id}`);
  }

  rejectMessageInterpreter(msg: string = '', modem: any) {
    return msg.includes('3_min') && msg.includes('running')
      ? `RF test is running on Modem ${modem}`
      : msg.includes('iperftest') && msg.includes('running')
        ? `IPERF Test is running on Modem ${modem}`
      : msg.includes('iperf') && msg.includes('running')
        ? `IPERF test is running on Modem ${modem}`
        : msg.includes('conti') && msg.includes('running')
          ? `Continuous test is running on Modem ${modem}`
          : msg.includes('Bandlock')
            ? `Band lock is being configured on Modem ${modem}`
            : msg.includes('swupgrade')
              ? `Modem ${modem} software is being updated`
              : msg.includes('wificonfig')
                ? `WiFi Configuration is in progress`
                : msg.includes('apnconfig')
                  ? `APN is being configured on Modem ${modem}`
                  : msg.includes('3atcmd_dbg')
                    ? `Debugging is in progress on Modem ${modem}`
                    : msg.includes('cmdline_dbg')
                      ? `Debugging is in progress on Modem ${modem}`
                      : msg.includes('reboot')
                        ? `Reboot is in progress on Modem ${modem}`
                        : msg.includes('tele_freq')
                          ? `Telemetry is being configured on Modem ${modem}`
                          : msg.includes('WalkTest test running with ID')
                            ? `Walktest is running in modem ${modem}`
                            : msg;
  }

  walktestReportData(data) {
    return this.httpClient.post(
      this.apiEndPoint + '/_/walktestreportdata',
      data,
    );
  }
  checkModemStatus(devices = []) {
    const filter = {
      type: 'walktest',
      devices: devices,
    };
    return this.httpClient.post(`${this.apiEndPoint}/_/2.0/assetgroup`, filter);
  }

  checkModemStatusBase(devices = [], interfaces = []) {
    const filter = {
      type: 'walktest',
      devices: devices,
      device_type: 'base',
      wifi_interface: interfaces,
    };
    return this.httpClient.post(`${this.apiEndPoint}/_/2.0/assetgroup`, filter);
  }

  saveSession(
    mapname: any,
    mapid: any,
    ruleid: any,
    imei: any,
    deviceid: any,
    device_type?: any,
  ) {
    const filter = {
      ruleid: ruleid,
      mapname: mapname,
      mapid: mapid,
      imei: imei,
      deviceid: deviceid,
      status: 'Applied',
    };
    if (device_type) {
      filter['device_type'] = device_type;
    }
    // console.log(JSON.stringify(filter));
    return this.httpClient.post(
      `${this.apiEndPoint}/_/2.0/savesession`,
      filter,
    );
  }

  // The summary endpoint pairs most array fields (rssi, ftptest_bytes_transferred, ...) with
  // sibling *_min/*_max scalars precomputed server-side. When a time range is too large the API
  // paginates it as several 'incomplete' responses that this method stitches together by
  // recursing with the returned starttime - so merging has to treat the two shapes differently:
  // arrays concatenate across batches, but *_min/*_max must be re-min'd/re-max'd against what
  // was already accumulated, not blindly spread (they aren't arrays, and overwriting with the
  // latest batch's value would silently drop a more extreme min/max seen in an earlier batch).
  private mergeMinMax(existing: any, incoming: any, type: 'min' | 'max') {
    const values = [existing, incoming]
      .filter((val) => val != null && val !== '' && !isNaN(+val))
      .map(Number);
    if (!values.length) {
      return null;
    }
    return type === 'min' ? Math.min(...values) : Math.max(...values);
  }

  walktestFilterData(
    time?: any,
    deviceid?: any,
    floorid?: any,
    imei?: any,
    result = {},
    subsctiption?: any,
  ) {
    return new Promise((resolve: any, reject: any) => {
      const output = { ...result };
      const structure = {};
      time?.[0] && (structure['starttime'] = time?.[0]);
      time?.[1] && (structure['endtime'] = time?.[1]);
      imei && (structure['imei'] = imei);
      deviceid && (structure['deviceid'] = deviceid);
      floorid && (structure['mapid'] = floorid);
      // console.log(structure)
      // return new Promise((resolve, reject)=>{
      let report$ = this.httpClient
        .post(`${this.apiEndPoint}/_/walktestreport`, structure)
        .subscribe((res: any) => {
          console.log(res);
          const newObject = {};
          if (res?.result) {
            for (let each in res?.result) {
              if (each == 'starttime' || each == 'status') {
                continue;
              }
              const incoming = res?.result?.[each];
              if (each.endsWith('_min')) {
                newObject[each] = this.mergeMinMax(output?.[each], incoming, 'min');
              } else if (each.endsWith('_max')) {
                newObject[each] = this.mergeMinMax(output?.[each], incoming, 'max');
              } else {
                newObject[each] = [
                  ...(Array.isArray(output?.[each]) ? output[each] : []),
                  ...(Array.isArray(incoming) ? incoming : []),
                ];
              }
            }
          }
          if (res?.result?.status == 'incomplete') {
            this.walktestFilterData(
              [res?.result?.starttime, time?.[1]],
              deviceid,
              floorid,
              imei,
              newObject,
              subsctiption,
            ).then((response) => {
              resolve(response);
            });
          } else {
            // this.walktestFilterSubject.next(newObject)
            resolve(newObject);
          }
        });
      subsctiption && subsctiption.push(report$);
      // })
    });
  }

  fetchWalktestreportdata(
    time: any,
    mapid: any,
    deviceid: any,
    data = { result: [] },
    subscription?: any,
    baseId?: any,
  ) {
    // console.log("reportdata called  ", data);
    return new Promise((resolve: any, reject: any) => {
      let devices = [];
      if (deviceid) {
        devices.push(deviceid);
      }
      if (baseId) {
        devices.push(baseId);
      }
      const bodyFilter: any = {
        filter: [
          {
            type: 'range',
            field: 'starttime',
            value: {
              min: time?.[0],
              max: time?.[1],
            },
          },
        ],
      };

      mapid &&
        bodyFilter?.filter.push({
          type: 'single',
          field: 'mapid',
          value: [mapid],
        });

      devices.length > 0 &&
        bodyFilter?.filter.push({
          type: 'single',
          field: 'deviceid',
          value: devices,
        });

      // console.log(JSON.stringify(bodyFilter))
      let report$ = this.httpClient
        .post(`${this.apiEndPoint}/_/walktestreportdata`, bodyFilter)
        .subscribe((res: any) => {
          const finalResult = data;
          // console.log(res)
          if (res?.result?.data) {
            // finalResult['result'].push(...data?.result);
            finalResult['result'].push(res?.result?.data);
          }
          // else {
          //   finalResult['result'].push(...data?.result);
          // }
          // finalResult['result'] = res?.result?.data?[...data?.result, ...res?.result?.data]:data?.result
          if (res?.result?.status == 'incomplete') {
            // console.log(finalResult, "incomplete");
            let lastInd = res?.result?.data ? res?.result?.data.length - 1 : 0;
            let lastData = res?.result?.data?.[lastInd];
            let time_lastNotification = lastData?._source?.ts + 1;
            this.fetchWalktestreportdata(
              [time_lastNotification, time?.[1]],
              mapid,
              deviceid,
              finalResult,
              undefined,
              baseId,
            ).then((response) => {
              resolve(response);
            });
          } else {
            // console.log(finalResult, "complete");
            resolve({ result: finalResult?.result.flat() });
          }
        });
      subscription && subscription.push(report$);
      // return this.walktestReportDataSubject.pipe(first())
    });
  }

  getDropdownOptions() {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: 'dropdown_options',
                type: 'phrase',
                fields: ['_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/configparam/_search?size=1`,
      filter,
    );
  }

  fetchPCIs(rule = [], time) {
    const filterObject = { filter: [] };
    rule &&
      filterObject?.['filter'].push({
        field: 'rule_id',
        type: 'single',
        value: rule,
      });
    time?.[0] &&
      time?.[1] &&
      filterObject?.['filter'].push({
        field: 'starttime',
        type: 'range',
        value: {
          min: time?.[0],
          max: time?.[1],
        },
      });
    return this.httpClient.post(
      `${this.apiEndPoint}/_/2.0/pcinotificationreport`,
      filterObject,
    );
  }
  fetchSurveyPCIs(rule = [], time: any) {
    const filterObject = { filter: [] };
    rule &&
      filterObject?.['filter'].push({
        field: 'rule_id',
        type: 'single',
        value: rule,
      });
    time?.[0] &&
      time?.[1] &&
      filterObject?.['filter'].push({
        field: 'starttime',
        type: 'range',
        value: {
          min: time?.[0],
          max: time?.[1],
        },
      });
    return this.httpClient.post(
      `${this.apiEndPoint}/_/2.0/pcireport`,
      filterObject,
    );
  }

  fetchRoute(locname: string) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: locname,
                type: 'phrase',
                fields: ['locname'],
              },
            },
          ],
        },
      },
      sort: { ts: 'desc' },
    };

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktestroute/_search?size=10000`,
      filter,
    );
  }
  getDetailedReportPageData(rule: string, locname: string) {
    return this.httpClient.post(`${this.fileServerUrl}/htmlfile`, {
      rule: rule,
      locname: locname,
    });
  }

  triggerExtrapolation(ruleid: any, locname:any) {
    return this.httpClient.post(`${this.apiEndPoint}/_/extrapolatelocation`, {
      ruleid, locname
    });
  }

  generateDetailedReport(filter: any) {
    return this.httpClient.post(`${this.fileServerUrl}/htmlfile`, filter);
  }

  detailedReportData(user: any, authorization?: any) {
    const filter: any = {
      query: {
        bool: {
          must: [],
          must_not: [{ term: { type: 'security' } }],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };

    if (authorization != 'admin' && authorization != 'super admin') {
      filter.query.bool.must.push({
        query_string: { query: user, type: 'phrase', fields: ['user'] },
      });
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/detailedreportdata/_search?size=1000`,
      filter,
    );
  }

  downloadFile(file: any) {
    return this.httpClient.get(`${this.fileServerUrl}/${file}`, {
      responseType: 'blob',
    });
  }

  downloadFileInFolder(folder: any, file: any) {
    return this.httpClient.get(
      `${this.fileServerUrl}/custom/${folder}/${file}`,
      { responseType: 'blob', observe: 'events', reportProgress: true },
    );
  }


  scheduleTest(locname, payload) {
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_create?_id=${locname}`,
      payload,
    );
  }

  scheduleTestBulk(payloads = {}) {
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_mCreate`,
      payloads,
    );
  }

  getScheduledTest(locname) {
    return this.httpClient.get(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/${locname}`,
    );
  }

  getScheduledTestForSeries(series: any) {
    const payload = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: series,
                type: 'phrase',
                fields: ['series_id'],
              },
            },
          ],
          must_not: {
            exists: {
              field: 'status',
            },
          },
        },
      },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_search?size=10000`,
      payload,
    );
  }

  cancelScheduledTest(locname) {
    return this.httpClient.delete(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/${locname}`,
    );
  }

  deleteSeriesByApi(seriesId: string) {
    const url = `${this.fileServerUrl}/walktest/delete-by-series`;
    const token = localStorage.getItem('token');
    return new Observable((subscriber) => {
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ testid: seriesId }),
      }).then((response) => {
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        const read = () => {
          reader.read().then(({ done, value }) => {
            if (done) { subscriber.complete(); return; }
            buffer += decoder.decode(value, { stream: true });
            const chunks = buffer.split('\n\n');
            buffer = chunks.pop() || '';
            chunks.forEach((chunk) => {
              if (chunk.startsWith('data: ')) {
                try { subscriber.next(JSON.parse(chunk.substring(6))); } catch (_) {}
              }
            });
            read();
          }).catch((err) => subscriber.error(err));
        };
        read();
      }).catch((err) => subscriber.error(err));
    });
  }

  getTestStatus(locname: any) {
    return this.httpClient.get(
      `${this.apiEndPoint}/_/2.0/scheduled_walktest_status?locname=${locname}`,
    );
  }

  createIperfMonitorRecord(ruleid: any, device: any, imei: any) {
    const payload = {
      imei: imei,
      deviceid: device,
      rule_id: ruleid,
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/iperftest_monitor/_create?_id=${ruleid}`,
      payload,
    );
  }

  getDeviceLocation(serialnumber: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: `\"${serialnumber}\"`,
                type: 'phrase',
                fields: ['_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicestaticlocation/_search?size=100`,
      filter,
    );
  }

  getScheduledTests(
    id?: any,
    latest?: boolean,
    locname?: any,
    daterange?: any,
    securityMode?: boolean,
  ) {
    const filter: any = {
      query: { bool: { must: [] } },
      sort: { starttime: 'desc' },
    };

    if (id) {
      filter.query.bool.must.push({
        query_string: {
          query: id,
          type: 'phrase',
          fields: ['payload.devices.deviceid'],
        },
      });
    }
    if (latest) {
      // filter.query.bool.must.push({range:{endtime:{gte:new Date().valueOf(), lte:new Date().valueOf()+3600*1000*24*365}}});
    }

    if (daterange?.start) {
      console.log(daterange?.start, '  , ', daterange?.end);
      filter.query.bool.must.push({
        range: { endtime: { lte: daterange?.end } },
      });
      filter.query.bool.must.push({
        range: { starttime: { gte: daterange?.start } },
      });
    }
    if (locname) {
      filter.query.bool.must.push({
        query_string: { query: locname, type: 'phrase', fields: ['_id'] },
      });
    }

    if (securityMode !== undefined) {
      const securityFilter = {
        query_string: {
          query: '(securitytest) OR (securitytest_continuous)',
          type: 'phrase',
          fields: ['payload.devices.ui_testtype'],
        },
      };
      if (securityMode) {
        filter.query.bool.must.push(securityFilter);
      } else {
        filter.query.bool.must_not = [...(filter.query.bool.must_not ?? []), securityFilter];
      }
    }

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_search?size=10000`,
      filter,
    );
  }

  // NEW — returns the total hit count for a device from the _count endpoint (no size limit)
  getScheduledTestsCount(deviceId?: string, windowStart?: number, windowEnd?: number, securityMode?: boolean) {
    const filter: any = { query: { bool: { must: [] } } };
    if (deviceId) {
      filter.query.bool.must.push({
        query_string: { query: deviceId, type: 'phrase', fields: ['payload.devices.deviceid'] },
      });
    }
    if (windowStart != null && windowEnd != null) {
      filter.query.bool.must.push({ range: { starttime: { lte: windowEnd, gte: windowStart } } });
    }
    if (securityMode !== undefined) {
      const securityFilter = {
        query_string: {
          query: '(securitytest) OR (securitytest_continuous)',
          type: 'phrase',
          fields: ['payload.devices.ui_testtype'],
        },
      };
      if (securityMode) {
        filter.query.bool.must.push(securityFilter);
      } else {
        filter.query.bool.must_not = [...(filter.query.bool.must_not ?? []), securityFilter];
      }
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_count`,
      filter,
    );
  }

  // NEW — window fetch for calendar; beforeStartTime is an optional cursor for batch pagination
  getScheduledTestsForCalendarWindow(deviceId?: string, windowStart?: number, windowEnd?: number, beforeStartTime?: number, securityMode?: boolean) {
    const filter: any = {
      query: { bool: { must: [] } },
      sort: { starttime: 'desc' },
    };
    if (deviceId) {
      filter.query.bool.must.push({
        query_string: { query: deviceId, type: 'phrase', fields: ['payload.devices.deviceid'] },
      });
    }
    if (windowStart != null && windowEnd != null) {
      filter.query.bool.must.push({ range: { starttime: { lte: windowEnd, gte: windowStart } } });
    }
    if (beforeStartTime != null) {
      // Cursor: only fetch records with starttime <= cursor (for batch pagination)
      filter.query.bool.must.push({ range: { starttime: { lte: beforeStartTime } } });
    }
    if (securityMode !== undefined) {
      const securityFilter = {
        query_string: {
          query: '(securitytest) OR (securitytest_continuous)',
          type: 'phrase',
          fields: ['payload.devices.ui_testtype'],
        },
      };
      if (securityMode) {
        filter.query.bool.must.push(securityFilter);
      } else {
        filter.query.bool.must_not = [...(filter.query.bool.must_not ?? []), securityFilter];
      }
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_search?size=10000`,
      filter,
    );
  }

  // NEW — cursor-based paginated fetch; beforeStartTime is the exclusive upper bound on starttime
  getScheduledTestsPaginated(id?: any, size: number = 10000, beforeStartTime?: number, securityMode?: boolean) {
    const filter: any = {
      query: { bool: { must: [] } },
      sort: { starttime: 'desc' },
    };
    if (id) {
      filter.query.bool.must.push({
        query_string: { query: id, type: 'phrase', fields: ['payload.devices.deviceid'] },
      });
    }
    if (beforeStartTime != null) {
      filter.query.bool.must.push({ range: { starttime: { lte: beforeStartTime } } });
    }
    if (securityMode !== undefined) {
      const securityFilter = {
        query_string: {
          query: '(securitytest) OR (securitytest_continuous)',
          type: 'phrase',
          fields: ['payload.devices.ui_testtype'],
        },
      };
      if (securityMode) {
        filter.query.bool.must.push(securityFilter);
      } else {
        filter.query.bool.must_not = [...(filter.query.bool.must_not ?? []), securityFilter];
      }
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_search?size=${size}`,
      filter,
    );
  }

  getScheduledTestsForConflict(
    id?: any,
    latest?: boolean,
    locname?: any,
    daterange?: any,
  ) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: id,
                type: 'phrase',
                fields: ['payload.devices.deviceid'],
              },
            },
            { bool: { should: [] } },
          ],
        },
      },
      sort: { starttime: 'asc' },
    };

    if (daterange?.start) {
      console.log(daterange?.start, '  , ', daterange?.end);
      filter.query.bool.must?.[1]?.bool?.should.push({
        // Scenario 1: starttime within range (endtime can be anything)
        range: {
          starttime: {
            gte: daterange?.start,
            lte: daterange?.end,
          },
        },
      });
      filter.query.bool.must?.[1]?.bool?.should.push({
        // Scenario 2: both starttime and endtime within range
        bool: {
          must: [
            {
              range: {
                starttime: {
                  gte: daterange?.start,
                  lte: daterange?.end,
                },
              },
            },
            {
              range: {
                endtime: {
                  gte: daterange?.start,
                  lte: daterange?.end,
                },
              },
            },
          ],
        },
      });

      filter.query.bool.must?.[1]?.bool?.should.push({
        // Scenario 3: starttime before range but endtime within range
        bool: {
          must: [
            {
              range: {
                starttime: {
                  lt: daterange?.start,
                },
              },
            },
            {
              range: {
                endtime: {
                  gte: daterange?.start,
                  lte: daterange?.end,
                },
              },
            },
          ],
        },
      });
      filter.query.bool.must?.[1]?.bool?.should.push({
        // Scenario 4: starttime before range start and endtime after range end
        bool: {
          must: [
            {
              range: {
                starttime: {
                  lt: daterange?.start,
                },
              },
            },
            {
              range: {
                endtime: {
                  gt: daterange?.end,
                },
              },
            },
          ],
        },
      });
    }

    if (locname) {
      filter.query.bool.must?.[1]?.bool?.should.push({
        query_string: { query: locname, type: 'phrase', fields: ['_id'] },
      });
    }

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_search?size=10000`,
      filter,
    );
  }

  updateWalktestTable(id: any, payload: any) {
    return this.httpClient.patch(
      `${this.apiEndPoint}/gwdevice/devicereq/${id}/_update`,
      payload,
    );
  }

  createSchedulerEntry(payload: any) {
    return this.httpClient.post(
      `${this.fileServerUrl}/schedule_tests`,
      payload,
    );
  }

  getAllTests(locname: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: locname,
                type: 'phrase',
                fields: ['locname'],
              },
            },
            {
              query_string: {
                query: 'WalkTest',
                type: 'phrase',
                fields: ['rule'],
              },
            },
          ],
        },
      },
      sort: {
        '_kuzzle_info.createdAt': 'desc',
      },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicereq/_search?size=1000`,
      filter,
    );
  }

  updateScheduleTests(locname: any, data: any) {
    return this.httpClient.patch(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/${locname}/_update`,
      data,
    );
  }

  getIperfServers(servertype?: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: servertype || 'iperf_server',
                type: 'phrase',
                fields: ['_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/configparam/_search?size=1`,
      filter,
    );
  }

  pingServer(server: string) {
    return this.httpClient.get(`${this.fileServerUrl}/ping/${server}`);
  }

  getMapFile(file: string) {
    return this.httpClient.get(`${this.fileServerUrl}/${file}`, {
      responseType: 'blob',
    });
  }

  getMapFileInFolder(folder: any, file: string) {
    return this.httpClient.get(
      `${this.fileServerUrl}/custom/${folder}/${file}`,
      {
        responseType: 'blob',
      },
    );
  }

  iperfStatus(
    server: any,
    port: any,
    command: any,
    param1?: any,
    param2?: any,
    toeknid?: any,
  ) {
    if (param1 && param2) {
      const filter = {
        server: server,
        iperf_server_param1: param1,
        iperf_server_param2: param2,
        command: command,
        port: port,
      };
      if (command == 'stop') {
        filter['test_id'] = toeknid;
      }
      return this.httpClient.post(
        `${this.containerapiEndPoint}/stop_start_iperfserver`,
        filter,
      );
    } else {
      if (command == 'start') {
        return this.pingServer(server);
      }
    }
  }

  streamServers(filter: any) {
    return this.httpClient.post(
      `${this.containerapiEndPoint}/stop_start_iperfserver`,
      filter,
    );
  }

  getWorkingIperfServer(filter: any) {
    return this.httpClient.post(
      `${this.containerapiEndPoint}/stop_start_iperfserver`,
      filter,
    );
  }

  decryptUsingAES256(encrypted: any) {
    let _key = CryptoJS.enc.Utf8.parse('frgrtyhyujhogdrt');
    let _iv = CryptoJS.enc.Utf8.parse('frgrtyhyujhogdrt');

    let decrypted = CryptoJS.AES.decrypt(encrypted, _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8);
    return decrypted;
  }

  stopAllTests(deviceid: string) {
    return this.httpClient.post(`${this.apiEndPoint}/_/2.0/edgecmdstop`, {
      device: deviceid,
    });
  }

  stopOneTest(ruleid: string, tokenid?: any) {
    return this.httpClient
      .post(`${this.apiEndPoint}/_/2.0/edgecmdstop`, { ruleids: [ruleid] })
      .pipe(
        mergeMap((res: any) => {
          // console.log(res, "nothing......");
          return this.getTestCurrentStatus(ruleid);
        }),
      )
      .pipe(
        mergeMap((res: any) => {
          console.log(res,res?.result?.hits?.[0]?._source?.test_id, "devicereq data......");
          if (res?.result?.hits?.[0]?._source?.condition?.port) {
            let teatid = res?.result?.hits?.[0]?._source?.test_id || tokenid;
            return this.createIpertServerMapAnfStop(
              ruleid,
              res?.result?.hits?.[0],
              teatid,
              res?.result?.hits?.[0]?._source?.ui_testtype
            );
          }
          return of({});
        }),
      );
  }

  createIpertServerMapAnfStop(ruleid: any, data: any, token_id?: any, testype?:any) {
    const serverMapping = {
      iperf: { id: 'iperf_server', name: 'iperf_servers' },
      iperf_continuous: { id: 'iperf_server', name: 'iperf_servers' },
      iperftest: { id: 'iperf_server', name: 'iperf_servers' },
      iperftest_continuous: { id: 'iperf_server', name: 'iperf_servers' },
      sptest: { id: 'speedtest_server', name: 'speedtest_servers' },
      sptest_continuous: { id: 'speedtest_server', name: 'speedtest_servers' },
      ftptest: { id: 'ftp_server', name: 'ftp_servers' },
      ftptest_continuous: { id: 'ftp_server', name: 'ftp_servers' },
    };
    return this.getIperfServers(serverMapping?.[testype]?.id)
      .pipe(
        map((res: any) => {
          let servers = res?.result?.hits?.[0]?._source?.[serverMapping?.[testype]?.name];
          const map = {};
          servers &&
            servers.map((each) => {
              if (each?.ip) {
                map[`${each?.address}-${each?.ip}`] = each;
              }
              if (each?.ip6 && each?.ip6 != 'Not available') {
                map[`${each?.address}-${each?.ip6}`] = each;
              }
            });
          return map;
        }),
      )
      .pipe(
        mergeMap((map: any) => {
          // console.log(map, "nothing......");
          return this.stopServer(ruleid, map, data, token_id);
        }),
      );
  }

  stopAllTestWithRules(ruleid: any[] = []) {
    return this.httpClient.post(`${this.apiEndPoint}/_/2.0/edgecmdstop`, {
      ruleids: ruleid,
    });
  }

  stopServer(ruleid: string, credMap = {}, data?: any, tokenid?: any) {
    // console.log(ruleid, credMap, data, tokenid);
    if (data) {
      if (data?._source?.condition?.server || data?._source?.condition?.ip) {
        // console.log( credMap?.[`${data?._source?.condition?.server}-${data?._source?.condition?.ip}`]?.iperf_server_param1,credMap?.[`${data?._source?.condition?.server}-${data?._source?.condition?.ip}`]?.iperf_server_param2);
        return this.iperfStatus(
          data?._source?.condition?.server,
          data?._source?.condition?.port,
          'stop',
          credMap?.[
            `${data?._source?.condition?.server}-${data?._source?.condition?.ip}`
          ]?.iperf_server_param1,
          credMap?.[
            `${data?._source?.condition?.server}-${data?._source?.condition?.ip}`
          ]?.iperf_server_param2,
          tokenid,
        );
      }
      return of({ data });
    } else {
      return this.getTestCurrentStatus(ruleid)
        .pipe(
          mergeMap((response: any) => {
            // console.log(response, "from devicereq");
            let data = response?.result?.hits?.[0];
            let test_id =
              response?.result?.hits?.[0]?._source?.test_id || tokenid;
            return of({
              server: data?._source?.condition?.server,
              port: data?._source?.condition?.port,
              ip: data?._source?.condition?.ip,
              test_id: test_id,
            });
          }),
        )
        .pipe(
          mergeMap((res: any) => {
            // console.log(res, "from devicereq extracted");
            if (res?.server || res?.ip) {
              // console.log( credMap?.[`${res?.server}-${res?.ip}`]?.iperf_server_param1,credMap?.[`${res?.server}-${res?.ip}`]?.iperf_server_param2);
              return (
                credMap?.[`${res?.server}-${res?.ip}`]?.managed &&
                this.iperfStatus(
                  res?.server,
                  res?.port,
                  'stop',
                  credMap?.[`${res?.server}-${res?.ip}`]?.iperf_server_param1,
                  credMap?.[`${res?.server}-${res?.ip}`]?.iperf_server_param2,
                  res?.test_id,
                )
              );
            }
            return of({ res });
          }),
        );
    }
  }

  getDeviceLocationOnMap(serialnumber?: any, mapid?: any) {
    const filter = {
      query: { bool: { must: [] } },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };

    if (serialnumber) {
      filter.query.bool.must.push({
        query_string: {
          query: `${serialnumber}`,
          type: 'phrase',
          fields: ['_id'],
        },
      });
    }
    if (mapid) {
      filter.query.bool.must.push({
        query_string: {
          query: `\"${mapid}\"`,
          type: 'phrase',
          fields: ['mapid'],
        },
      });
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicestaticlocation/_search?size=100`,
      filter,
    );
  }

  getDeviceLastLocation(serialnumber: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: serialnumber,
                type: 'phrase',
                fields: ['deviceid'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicelocation/_search?size=1`,
      filter,
    );
  }

  getAllTestCurrentStatus(rule: string, arg: any[]) {
    const filter = {
      query: {
        bool: {
          must: [
            { query_string: { query: rule, type: 'phrase', fields: ['rule'] } },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    arg &&
      arg.map((each) => {
        if (each?.key && each?.value) {
          filter.query.bool.must.push({
            query_string: {
              query: each?.value,
              type: 'phrase',
              fields: [each?.key],
            },
          });
        }
      });
    // console.log(JSON.stringify(filter));
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicereq/_search?pretty&size=1`,
      filter,
    );
  }

  getEventlogs(ruleid: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: ruleid,
                type: 'phrase',
                fields: ['rule_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/eventlog/_search?pretty&size=10`,
      filter,
    );
  }

  time_convertFormatted(totalmiliSeconds: number): string {
    let totalSeconds = totalmiliSeconds / 1000;
    if (totalSeconds < 1) {
      return totalmiliSeconds + ' ms';
    }
    const days = Math.floor(totalSeconds / 86400);
    const remainingSeconds = totalSeconds % 86400;
    const hours = Math.floor(remainingSeconds / 3600);
    const minutes = Math.floor((remainingSeconds % 3600) / 60);
    const seconds = Math.floor(remainingSeconds % 60);

    const daysDisplay = days > 0 ? days + ' d ' : '';
    const hoursDisplay = hours > 0 ? hours + ' hr ' : '';
    const minutesDisplay = minutes > 0 ? minutes + ' min ' : '';
    const secondsDisplay = seconds > 0 ? seconds + ' sec' : '';

    return daysDisplay + hoursDisplay + minutesDisplay + secondsDisplay;
  }

  getEdgedevData(deviceId?: string, imei?: string) {
    let headers = new HttpHeaders();
    const payload = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: deviceId,
                type: 'phrase',
                fields: ['deviceid'],
              },
            },
            // { query_string: { query: imei, type: "phrase", fields: ["imei"] } },
          ],
        },
      },
      sort: [{ '_kuzzle_info.createdAt': 'desc' }],
    };
    return this.httpClient.post(
      this.apiEndPoint + '/gwdevice/edgedev/_search?size=1',
      payload,
      { headers },
    );
  }

  getDivecename() {
    return this.httpClient.get(this.apiEndPoint + '/_/2.0/devicelist');
  }

  statusConversion(type: string, status: string, ts?: any) {
    if (this.continuoustests?.[type]) {
      if (status == 'Applied') {
        return 'In Progress';
      } else if (status == 'active') {
        if (new Date().valueOf() - ts < 180000) {
          return 'Trigerred';
        } else {
          return 'No response from device';
        }
      } else if (status == 'Rejected') {
        return 'Rejected';
      } else if (status == 'Stopped_Applied') {
        return 'Stopped';
      } else if (status == 'Queued' || status == 'In Progress') {
        return 'Processing';
      }else if (status == 'Not Applied') {
        return 'Error';
      }
       else {
        return status;
      }
    } else if (this.singletests?.[type]) {
      if (status == 'Applied') {
        return 'Completed';
      } else if (status == 'active') {
        if (new Date().valueOf() - ts < 180000) {
          return 'Trigerred';
        } else {
          return 'No response from device';
        }
      } else if (status == 'Rejected') {
        return 'Rejected';
      } else if (status == 'Stopped_Applied') {
        return 'Stopped';
      } else if (status == 'Queued' || status == 'In Progress') {
        return 'In Progress';
      }else if (status == 'Not Applied') {
        return 'Error';
      }
       else {
        return status;
      }
    }
  }

  colorsList = [
    '#305f90',
    '#a7df1f',
    '#1355cd',
    '#71f7bd',
    '#f3a70f',
    '#724f5f',
    '#01093a',
    '#3cb85d',
    '#513849',
    '#e8236d',
    '#34fdfe',
    '#966136',
    '#76d9cc',
    '#bca405',
    '#b0dbdf',
    '#49bf25',
    '#329b47',
    '#6fef26',
    '#f86c93',
    '#a19eb1',
    '#2a8201',
    '#d753b1',
    '#bc709f',
    '#e262be',
    '#e9c79a',
    '#e17962',
    '#bb8724',
    '#869b5a',
    '#0c8ba4',
    '#2947c6',
    '#febb00',
    '#8f84bf',
    '#78f0bc',
    '#cbc01f',
    '#47b4bb',
    '#25cb1c',
    '#8fdaac',
    '#5ea3fc',
    '#c5c732',
    '#740785',
    '#9164a8',
    '#e99c8e',
    '#5cdabf',
    '#246315',
    '#167365',
    '#2c1158',
    '#9fb4be',
    '#3f0c49',
    '#c54af3',
    '#4d8ec8',
    '#aee313',
    '#0ee8e2',
    '#5d659d',
    '#d29163',
    '#84a15c',
    '#939957',
    '#8e0d0a',
    '#582a32',
    '#003094',
    '#af5c51',
    '#a6bf57',
    '#b60f45',
    '#a9c331',
    '#85816f',
    '#e618a5',
    '#068955',
    '#480fd4',
    '#d167f7',
    '#0062ec',
    '#d201c0',
    '#628f84',
    '#54e0fe',
    '#2f02f6',
    '#6aa631',
    '#9db9e1',
    '#930ea1',
    '#47fab1',
    '#a961d3',
    '#f83c1d',
    '#e5e6f7',
    '#88f116',
    '#798784',
    '#b2b752',
    '#4a3936',
    '#54c1c1',
    '#d4b11f',
    '#553f68',
    '#2a6f34',
    '#c9f029',
    '#51aba8',
    '#f2960c',
    '#c72759',
    '#9217eb',
    '#963951',
    '#9c27c7',
    '#b0bbdd',
    '#a0bd13',
    '#b2e8f5',
    '#f8b7fc',
    '#7d4ef2',
  ];

  filterParamsMapping = {
    RF: [
      { value: 'rssi', name: 'RSSI', param: 'rssi', searchKey: 'rssi' },
      { value: 'rsrp', name: 'RSRP', param: 'rsrp', searchKey: 'rsrp' },
      { value: 'rsrq', name: 'RSRQ', param: 'rsrq', searchKey: 'rsrq' },
      { value: 'sinr', name: 'SINR', param: 'sinr', searchKey: 'sinr' },
    ],
    IPERF: [
      { value: 'rssi', name: 'RSSI', param: 'rssi', searchKey: 'rssi' },
      { value: 'rsrp', name: 'RSRP', param: 'rsrp', searchKey: 'rsrp' },
      { value: 'rsrq', name: 'RSRQ', param: 'rsrq', searchKey: 'rsrq' },
      { value: 'sinr', name: 'SINR', param: 'sinr', searchKey: 'sinr' },
      {
        value: 'tcp_ul',
        name: 'TCP UL',
        param: 'iperf_tcp_ul_throughput',
        searchKey: 'tcp_ul',
      },
      {
        value: 'tcp_dl',
        name: 'TCP DL',
        param: 'iperf_tcp_dl_throughput',
        searchKey: 'tcp_dl',
      },
      {
        value: 'udp_ul',
        name: 'UDP UL',
        param: 'iperf_udp_ul_throughput',
        searchKey: 'udp_ul',
      },
      {
        value: 'udp_dl',
        name: 'UDP DL',
        param: 'iperf_udp_dl_throughput',
        searchKey: 'udp_dl',
      },
      {
        value: 'ul_jitter',
        name: 'UL JITTER',
        param: 'iperf_udp_ul_jitter',
        searchKey: 'ul_jitter',
      },
      {
        value: 'dl_jitter',
        name: 'DL JITTER',
        param: 'iperf_udp_dl_jitter',
        searchKey: 'dl_jitter',
      },
    ],
    Youtube: [
      {
        value: 'average_download_speed_mbps',
        name: 'Average Download Speed',
        param: 'average_download_speed_mbps',
        searchKey: 'average_download_speed_mbps',
      },
      // { value: 'overall_quality_assessment', name: 'Overall Quality Assessment', param:"overall_quality_assessment", searchKey: 'overall_quality_assessment' },
      // { value: 'bytes_received_kb', name: 'Bytes Received', param: "bytes_received_kb", searchKey: 'bytes_received_kb' },
      // { value: 'bytes_sent_kb', name: 'Bytes Sent', param: "bytes_sent_kb", searchKey: 'bytes_sent_kb' },
      // { value: 'average_upload_speed_mbps', name: 'Average Upload Speed', param: "average_upload_speed_mbps", searchKey: 'average_upload_speed_mbps' },
      // { value: 'server_response_time', name: 'Server Response Time', param: "server_response_time", searchKey: 'server_response_time' }
    ],
    'Wget Curl': [
      // { value: 'connect_time', name: 'Connect Time', param: "connect_time", searchKey: 'connect_time' },
      {
        value: 'totaltime',
        name: 'Total Time',
        param: 'totaltime',
        searchKey: 'curltest_total_time',
      },
      // { value: 'starttransfer_time', name: 'Start Transfer Time', param: "starttransfer_time", searchKey: 'starttransfer_time' }
    ],
    'Speed Test': [
      {
        value: 'download',
        name: 'Download Speed',
        param: 'download',
        searchKey: 'speedtest_download',
      },
      {
        value: 'upload',
        name: 'Upload Speed',
        param: 'upload',
        searchKey: 'speedtest_upload',
      },
      // { value: 'jitter', name: 'Jitter', param: "jitter", searchKey: 'jitter' },
      // { value: 'ping', name: 'Ping', param: "ping", searchKey: 'ping' }
    ],
    'Ping Test': [
      {
        value: 'pkt_loss',
        name: 'Packet Loss',
        param: 'pkt_loss',
        searchKey: 'pkt_loss',
      },
      // { value: 'pkts_tx', name: 'Packets Transmitted', param:"pkts_tx", searchKey: 'pkts_tx' },
      // { value: 'pkts_rx', name: 'Packets Received', param:"pkts_rx", searchKey: 'pkts_rx' }
    ],
  };

  parameterWisiRnage = {
    pktsize: {
      min: 20,
      max: 65507,
      message: 'Packet Size should be between 20 and 65507',
    },
    pkt_count: {
      min: 1,
      max: 10,
      message: 'Packet Count should be between 1 and 10',
    },
    pktinterval: {
      min: 1,
      max: 30,
      message: 'Packet Interval should be between 1 and 30',
    },
    tcp_parallel_stream: {
      min: 1,
      max: 16,
      message: 'Value should be between 1 and 16',
    },
    udp_parallel_stream: {
      min: 1,
      max: 8,
      message: 'Value should be between 1 and 8',
    },
    dialfrequency: {
      Min: { min: 1, max: 60, message: 'Value should be between 1 and 60' },
      Sec: {
        min: 60,
        max: 3600,
        message: 'Value should be between 60 and 3600',
      },
      Hrs: { min: 1, max: 1, message: 'Allowed value is 1' },
    },
    waittime: {
      min: 15,
      max: 60,
      message: 'Wait Time should be between 15 and 60',
    },
    interval: {
      min: 1,
      max: 1000,
      message: 'Interval should be between 1 and 1000',
    },
    gnss_interval: {
      min: 1,
      max: 1000,
      message: 'Interval should be between 1 and 1000',
    },
    iteration_count: {
      min: 0,
      max: 100,
      message: 'Iteration Count should be between 0 and 100',
    },
    iteration_interval: {
      min: 5,
      max: 300,
      message: 'Iteration Interval should be between 5 and 300',
    },
  };

  getDeviceStatus(serialNo: any) {
    return new Promise((resolve, reject) => {
      if (serialNo) {
        this.checkModemStatus([serialNo]).subscribe((deviceStatusData: any) => {
          console.log(deviceStatusData);
          let deviceData = deviceStatusData?.result?.[serialNo];
          let deviceStatus =
            deviceData?.['online'] == 'Yes' &&
            deviceData?.['status'] == 'Eligible';
          let active_interface = deviceData?.active_interface;
          this.getDeviceTableData(serialNo).subscribe({
            next: (devicesData: any) => {
              console.log(devicesData);
              if (devicesData?.result?.hits?.[0]) {
                const modemNames =
                  devicesData?.result?.hits?.[0]?._source?.modemNames;
                const modemDataLocal = {};
                const imeiModemMap = {};
                let platformNo =
                  devicesData?.result?.hits?.[0]?._source?.xedge_platform
                    ?.firmware_versions?.PlatformSerialNumber;
                let allModems =
                  devicesData?.result?.hits?.[0]?._source?.xedge_slice?.modem ||
                  [];
                let deviceacc =
                  devicesData?.result?.hits?.[0]?._source?.iperf_acceleration;
                console.log(allModems, 'modemsssss');
                allModems.map((each) => {
                  let modemStatus =
                    deviceStatusData?.result?.[serialNo]?.[each?.imei]?.[
                      'status'
                    ] == 'Eligible';

                  let mode =
                    deviceStatusData?.result?.[serialNo]?.[each?.imei]?.[
                      'mode'
                    ];
                  let reason =
                    deviceStatusData?.result?.[serialNo]?.[each?.imei]?.[
                      'reason'
                    ];

                  let ims_status = each?.IMS_Status;
                  let ims_registeration = each?.IMS_Registration_Status;
                  let voice_config = each?.Voice_CallCfg;
                  let callPossible = each?.IMS_Status != 'Disabled';
                  let acc = each?.native_driver
                    ? each?.native_driver == 'disabled'
                      ? 'yes'
                      : each?.native_driver == 'enabled'
                        ? 'no'
                        : 'na'
                    : 'na';
                  if (each?.imei) {
                    imeiModemMap[each?.imei] =
                      modemNames?.[each?.Slot]?.name || each?.modem_name;
                    modemDataLocal[
                      modemNames?.[each?.Slot]?.name || each?.modem_name
                    ] = {
                      id: modemNames?.[each?.Slot]?.name || each?.modem_name,
                      name: modemNames?.[each?.Slot]?.name || each?.modem_name,
                      imei: each?.imei,
                      isBackHaul: each?.mode == 'BackHaul',
                      deviceid: each?.deviceid,
                      status: deviceStatus ? modemStatus : false,
                      reason: reason,
                      mode,
                      ims_status,
                      ims_registeration,
                      voice_config,
                      device_ifs: devicesData?.result?.hits?.[0]?._source
                        ?.Iperf_device_if
                        ? devicesData?.result?.hits?.[0]?._source
                            ?.Iperf_device_if
                        : [],
                      modem_if: each?.Iperf_modem_if,
                      imsi: each?.IMSI,
                      acc,
                      deviceacc,
                      callPossible,
                      isActiveInterface:
                        each?.Iperf_modem_if == active_interface,
                    };
                  }
                });
                console.log(modemDataLocal);
                if (platformNo) {
                  this.getInterface(
                    platformNo,
                    modemDataLocal,
                    imeiModemMap,
                  ).then((res) => {
                    resolve(res);
                  });
                } else {
                  resolve({ data: modemDataLocal, imeiModemMap });
                }
              } else {
                resolve({ data: {}, imeiModemMap: {} });
              }
            },
            error: (err) => {
              this.getInterface(undefined, {}, {}).then((res) => {
                resolve(res);
              });
            },
          });
        });
      } else {
        this.getInterface(undefined, {}, {}).then((res) => {
          resolve(res);
        });
      }
    });
  }

  getInterface(platfromNo?: any, modemData = {}, imeiModemMap = {}) {
    console.log(platfromNo, modemData, imeiModemMap);
    if (platfromNo) {
      return new Promise((resolve, reject) => {
        this.getHelperTableData(platfromNo).subscribe({
          next: (pf: any) => {
            if (pf?.result?.hits?.[0]) {
              console.log(pf);
              let inerfaceNames =
                pf?.result?.hits?.[0]?._source?.interfaceNames;
              this.getEdgedevData(platfromNo).subscribe({
                next: (res: any) => {
                  if (res?.result?.hits?.[0]) {
                    let output = res?.result?.hits?.[0];
                    let accessInfo = output?._source?.['Access Info'];
                    // let deviceActualData = [];
                    let interfaceList = {};
                    const interfaceInfoObject = {};
                    const interfaces = [];
                    console.log(output?._source);
                    const wifiSSIDSmap = {};
                    if (output?._source?.['WIFI']) {
                      output?._source?.['WIFI'].map((each: any) => {
                        if (each?.networks) {
                          wifiSSIDSmap[each?.interface] = [];
                          each?.networks.map((ss: any) => {
                            wifiSSIDSmap[each?.interface].push(ss);
                          });
                        }
                      });
                    }
                    if (accessInfo) {
                      accessInfo.map((info: any) => {
                        if (info?.type == 'WiFi' && info?.interface) {
                          let interfaceName = info?.interface;

                          info['interfaceName'] = interfaceName;
                          info['deviceid'] = output?._source?.['deviceid'];
                          info['imei'] = interfaceName;
                          info['acc'] = 'na';
                          info['name'] = info?.['MAC'];
                          info['custom_name'] = inerfaceNames?.[interfaceName];
                          info['id'] = interfaceName;
                          info['status'] = true;
                          // info['status'] = info?.status=="enabled"?true:false;
                          // info['device_ifs'] = this.selectedDevice?.[0]?.device_if;
                          info['modem_if'] = interfaceName;
                          info['ssidlist'] = wifiSSIDSmap?.[interfaceName];
                          interfaceList?.[interfaceName]
                            ? interfaceList?.[interfaceName].push(info?.['MAC'])
                            : (interfaceList[interfaceName] = [info?.['MAC']]);
                          imeiModemMap[info?.['MAC']] = interfaceName;
                          interfaces.push(interfaceName);
                          interfaceInfoObject[interfaceName] = info;
                        } else {
                          if (info?.type == 'WiFi') {
                            let interfaceName: any;
                            for (let each in info) {
                              if (each != 'type' && each != 'MAC') {
                                interfaceName = each;
                              }
                            }
                            wifiSSIDSmap[interfaceName] =
                              output?._source?.['WIFI'];

                            info['interfaceName'] = interfaceName;
                            info['deviceid'] = output?._source?.['deviceid'];
                            info['imei'] = interfaceName;
                            info['acc'] = 'na';
                            info['name'] = info?.['MAC'];
                            info['custom_name'] =
                              inerfaceNames?.[interfaceName];
                            info['id'] = interfaceName;
                            info['status'] = true;
                            info['modem_if'] = interfaceName;
                            info['ssidlist'] = wifiSSIDSmap[interfaceName];
                            interfaceList?.[interfaceName]
                              ? interfaceList?.[interfaceName].push(
                                  info?.['MAC'],
                                )
                              : (interfaceList[interfaceName] = [
                                  info?.['MAC'],
                                ]);
                            imeiModemMap[info?.['MAC']] = interfaceName;
                            interfaces.push(interfaceName);
                            interfaceInfoObject[interfaceName] = info;
                          }
                        }
                      });
                    }
                    this.checkModemStatusBase(
                      [platfromNo],
                      interfaces,
                    ).subscribe({
                      next: (res: any) => {
                        let deviceData = res?.result?.[platfromNo];
                        let deviceStatus =
                          deviceData?.['online'] == 'Yes' &&
                          deviceData?.['status'] == 'Eligible';
                        interfaces.map((each) => {
                          let modemStatus =
                            res?.result?.[platfromNo]?.[each]?.['status'] ==
                            'Eligible';
                          let reason =
                            deviceData?.['online'] != 'Yes'
                              ? deviceData?.['reason'] == 'Device is offline'
                                ? 'Wifi Module Offline'
                                : deviceData?.['reason']
                              : res?.result?.[platfromNo]?.[each]?.['reason']
                                ? res?.result?.[platfromNo]?.[each]?.['reason']
                                : res?.result?.[platfromNo]?.['reason'];
                          if (interfaceInfoObject?.[each]) {
                            interfaceInfoObject[each]['status'] = deviceStatus
                              ? modemStatus
                              : false;
                            interfaceInfoObject[each]['reason'] = reason;
                          }
                          // deviceActualData.push(interfaceInfoObject?.[each]);
                        });
                        const data = { ...modemData, ...interfaceInfoObject };
                        resolve({ data, imeiModemMap });
                      },
                      error: (e) => {
                        resolve({ data: modemData, imeiModemMap });
                      },
                    });
                  } else {
                    resolve({ data: modemData, imeiModemMap });
                  }
                },
                error: (e) => {
                  resolve({ data: modemData, imeiModemMap });
                },
              });
            } else {
              resolve({ data: modemData, imeiModemMap });
            }
          },
          error: (err) => {
            resolve({ data: modemData, imeiModemMap });
          },
        });
      });
    } else {
      return Promise.resolve({ data: modemData, imeiModemMap });
    }
  }

  createWalktestTemplate(filter: any) {
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktest_templates/_create`,
      filter,
    );
  }

  deleteWalktestTemplate(id: any) {
    return this.httpClient.delete(
      `${this.apiEndPoint}/gwdevice/walktest_templates/${id}`,
    );
  }

  getWalktestTemplate(deviceid: any, testname?: any) {
    const filter = {
      query: { bool: { must: [] } },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    if (deviceid) {
      filter.query.bool.must.push({
        query_string: { query: deviceid, type: 'phrase', fields: ['xedge'] },
      });
    }

    if (testname) {
      filter.query.bool.must.push({
        query_string: { query: testname, type: 'phrase', fields: ['testname'] },
      });
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktest_templates/_search?size=10000`,
      filter,
    );
  }

  getModemTelemetryData(deviceid: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: deviceid,
                type: 'phrase',
                fields: ['deviceid'],
              },
            },
          ],
        },
      },
      aggregations: {
        modems: {
          terms: {
            field: 'imei',
            size: 4,
          },
          aggregations: {
            latest_record: {
              top_hits: {
                sort: [
                  {
                    'time_stamp.SystemEpoch': {
                      order: 'desc',
                    },
                  },
                ],
                size: 1,
              },
            },
          },
        },
      },
      size: 0,
    };

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/network/_search`,
      filter,
    );
  }
}

